import { ref as F, onMounted as Qe, openBlock as T, createElementBlock as L, normalizeClass as X, createElementVNode as P, toDisplayString as W, createCommentVNode as V, createVNode as Q, Transition as xe, withCtx as fe, withModifiers as le, renderSlot as J, computed as ae, withDirectives as Be, createBlock as Le, resolveDynamicComponent as gi, mergeProps as js, normalizeStyle as Xe, vShow as ut, unref as We, onUpdated as vi, nextTick as kt, Fragment as pe, reactive as Hs, watch as Te, withKeys as Me, renderList as De, vModelDynamic as yi, watchEffect as lr, inject as Mr, defineComponent as xr, h as Gs, getCurrentInstance as Ur, onUnmounted as Ws, shallowRef as an, onBeforeMount as bi, Text as _i, Teleport as Ei, createTextVNode as mt, resolveComponent as Ks, onBeforeUnmount as Br, createStaticVNode as Oi, mergeModels as sn, useModel as bt, toRefs as Ys, TransitionGroup as Xn, isRef as dr, vModelText as Ci } from "vue";
function Ti(e, t, n, r) {
  function a(s) {
    return s instanceof n ? s : new n(function(o) {
      o(s);
    });
  }
  return new (n || (n = Promise))(function(s, o) {
    function i(c) {
      try {
        d(r.next(c));
      } catch (u) {
        o(u);
      }
    }
    function l(c) {
      try {
        d(r.throw(c));
      } catch (u) {
        o(u);
      }
    }
    function d(c) {
      c.done ? s(c.value) : a(c.value).then(i, l);
    }
    d((r = r.apply(e, [])).next());
  });
}
function Si(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var wi = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var r, a, s;
    if (Array.isArray(t)) {
      if (r = t.length, r != n.length) return !1;
      for (a = r; a-- !== 0; )
        if (!e(t[a], n[a])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (s = Object.keys(t), r = s.length, r !== Object.keys(n).length) return !1;
    for (a = r; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, s[a])) return !1;
    for (a = r; a-- !== 0; ) {
      var o = s[a];
      if (!e(t[o], n[o])) return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
}, Ni = /* @__PURE__ */ Si(wi);
const va = "__googleMapsScriptId";
var Gt;
(function(e) {
  e[e.INITIALIZED = 0] = "INITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.SUCCESS = 2] = "SUCCESS", e[e.FAILURE = 3] = "FAILURE";
})(Gt || (Gt = {}));
let Vr = class jt {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: t, authReferrerPolicy: n, channel: r, client: a, id: s = va, language: o, libraries: i = [], mapIds: l, nonce: d, region: c, retries: u = 3, url: f = "https://maps.googleapis.com/maps/api/js", version: v }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = t, this.authReferrerPolicy = n, this.channel = r, this.client = a, this.id = s || va, this.language = o, this.libraries = i, this.mapIds = l, this.nonce = d, this.region = c, this.retries = u, this.url = f, this.version = v, jt.instance) {
      if (!Ni(this.options, jt.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(jt.instance.options)}`);
      return jt.instance;
    }
    jt.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? Gt.FAILURE : this.done ? Gt.SUCCESS : this.loading ? Gt.LOADING : Gt.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let t = this.url;
    return t += "?callback=__googleMapsCallback&loading=async", this.apiKey && (t += `&key=${this.apiKey}`), this.channel && (t += `&channel=${this.channel}`), this.client && (t += `&client=${this.client}`), this.libraries.length > 0 && (t += `&libraries=${this.libraries.join(",")}`), this.language && (t += `&language=${this.language}`), this.region && (t += `&region=${this.region}`), this.version && (t += `&v=${this.version}`), this.mapIds && (t += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (t += `&auth_referrer_policy=${this.authReferrerPolicy}`), t;
  }
  deleteScript() {
    const t = document.getElementById(this.id);
    t && t.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((t, n) => {
      this.loadCallback((r) => {
        r ? n(r.error) : t(window.google);
      });
    });
  }
  importLibrary(t) {
    return this.execute(), google.maps.importLibrary(t);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(t) {
    this.callbacks.push(t), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var t, n;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const r = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(r).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (s) => !r[s] && delete r[s]
    ), !((n = (t = window == null ? void 0 : window.google) === null || t === void 0 ? void 0 : t.maps) === null || n === void 0) && n.importLibrary || ((s) => {
      let o, i, l, d = "The Google Maps JavaScript API", c = "google", u = "importLibrary", f = "__ib__", v = document, p = window;
      p = p[c] || (p[c] = {});
      const m = p.maps || (p.maps = {}), g = /* @__PURE__ */ new Set(), y = new URLSearchParams(), S = () => (
        // @ts-ignore
        o || (o = new Promise(($, E) => Ti(this, void 0, void 0, function* () {
          var O;
          yield i = v.createElement("script"), i.id = this.id, y.set("libraries", [...g] + "");
          for (l in s)
            y.set(l.replace(/[A-Z]/g, (_) => "_" + _[0].toLowerCase()), s[l]);
          y.set("callback", c + ".maps." + f), i.src = this.url + "?" + y, m[f] = $, i.onerror = () => o = E(Error(d + " could not load.")), i.nonce = this.nonce || ((O = v.querySelector("script[nonce]")) === null || O === void 0 ? void 0 : O.nonce) || "", v.head.append(i);
        })))
      );
      m[u] ? console.warn(d + " only loads once. Ignoring:", s) : m[u] = ($, ...E) => g.add($) && S().then(() => m[u]($, ...E));
    })(r);
    const a = this.libraries.map((s) => this.importLibrary(s));
    a.length || a.push(this.importLibrary("core")), Promise.all(a).then(() => this.callback(), (s) => {
      const o = new ErrorEvent("error", { error: s });
      this.loadErrorCallback(o);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(t) {
    if (this.errors.push(t), this.errors.length <= this.retries) {
      const n = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${n} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, n);
    } else
      this.onerrorEvent = t, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((t) => {
      t(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), !this.loading)
      if (this.done)
        this.callback();
      else {
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match."), this.callback();
          return;
        }
        this.loading = !0, this.setScript();
      }
  }
};
const Li = {
  key: 0,
  class: "t-transp mn-r-small"
}, Ii = ["placeholder", "value"], Pi = {
  key: 0,
  class: "mn-t-thin invalid-feedback"
}, Ai = {
  __name: "Address",
  props: {
    apiKey: {
      type: String,
      required: !0
    },
    label: null,
    placeholder: "Enter something here",
    field: null,
    location: {
      type: Object,
      default: { lat: 48.6900735, lng: 41.1620239 }
    },
    address: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: "en"
    }
  },
  emits: ["update:address", "update:location", "update:country", "update:state", "update:city"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = F(null);
    let s;
    const o = () => {
      const i = s.getPlace();
      if (!i.geometry || !i.address_components)
        return;
      let l = "", d = "", c = "";
      for (let v = 0; v < i.address_components.length; v++) {
        let p = i.address_components[v];
        p.types.includes("country") && (l = p.long_name), p.types.includes("administrative_area_level_1") && (d = p.long_name), p.types.includes("locality") && (c = p.long_name);
      }
      const u = i.formatted_address, f = { lat: i.geometry.location.lat(), lng: i.geometry.location.lng() };
      r("update:address", u), r("update:location", f), r("update:country", l), r("update:state", d), r("update:city", c);
    };
    return Qe(() => {
      new Vr({
        apiKey: n.apiKey,
        version: "weekly",
        libraries: ["places"],
        language: n.locale
      }).load().then(() => {
        s = new google.maps.places.Autocomplete(a.value), s.addListener("place_changed", o);
      }).catch((l) => {
        console.error(l);
      });
    }), (i, l) => (T(), L("div", {
      class: X([i.$attrs.class, "flex-nowrap flex"])
    }, [
      e.label ? (T(), L("div", Li, [
        P("span", null, W(e.label), 1)
      ])) : V("", !0),
      P("input", {
        ref_key: "addressInput",
        ref: a,
        class: "w-100",
        placeholder: e.placeholder,
        value: e.address,
        onInput: l[0] || (l[0] = (...d) => i.onInput && i.onInput(...d))
      }, null, 40, Ii),
      Q(xe, {
        mode: "out-in",
        name: "fade"
      }, {
        default: fe(() => [
          i.validation ? (T(), L("div", Pi, " * " + W(i.validation.message), 1)) : V("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}, ki = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ai
}, Symbol.toStringTag, { value: "Module" })), $t = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, a] of t)
    n[r] = a;
  return n;
}, Di = {
  props: {
    progress: {
      type: Number,
      default: null
    },
    status: {
      type: String,
      default: null
    }
  }
}, Ri = { class: "circular-loader" }, Fi = {
  key: 0,
  class: "progress-text"
}, Mi = {
  key: 1,
  class: "uppercase t-semi w-m-10r status-text"
};
function xi(e, t, n, r, a, s) {
  return T(), L("div", Ri, [
    t[0] || (t[0] = P("svg", { viewBox: "25 25 50 50" }, [
      P("circle", {
        class: "circular-loader-fill",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        "stroke-width": "4",
        "stroke-miterlimit": "10"
      }),
      P("circle", {
        class: "circular-loader-circle",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        "stroke-width": "4",
        "stroke-miterlimit": "10"
      })
    ], -1)),
    n.progress ? (T(), L("div", Fi, W(n.progress), 1)) : V("", !0),
    n.status ? (T(), L("div", Mi, W(n.status), 1)) : V("", !0)
  ]);
}
const $n = /* @__PURE__ */ $t(Di, [["render", xi]]), Ui = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $n
}, Symbol.toStringTag, { value: "Module" })), Bi = ["disabled"], Vi = { key: 0 }, ji = { key: 1 }, Hi = {
  key: 2,
  class: "t-semi loading t-black"
}, Gi = {
  key: 3,
  class: "error"
}, Wi = {
  key: 0,
  class: "button-counter"
}, Ki = {
  __name: "Button",
  props: {
    submit: {
      type: Function,
      default: async () => {
        console.log("Button click.");
      }
    },
    text: {
      type: Object,
      default: (e) => e = {
        ...e.text,
        success: "✔",
        error: "✖"
      }
    },
    counter: {
      type: Object
    },
    callback: {
      type: Function,
      default: async () => {
        console.log("Button callback.");
      }
    },
    callbackDelay: {
      type: Number,
      default: 750
    },
    showSucces: {
      type: Boolean,
      default: !0
    },
    showLoader: {
      type: Boolean,
      default: !0
    },
    validation: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["error"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = F(null), s = F(null), o = F(!1), i = F(!1);
    async function l() {
      a.value.style["pointer-events"] = "none", s.value = null, o.value = !0;
      const d = () => {
        a.value && (a.value.classList.replace("bg-second", "bg-main"), a.value.style.pointerEvents = "auto", o.value = !1, i.value = !1, s.value = null);
      };
      try {
        await n.submit(), a.value.classList.replace("bg-main", "bg-second"), o.value = !1, n.showSucces ? (i.value = !0, setTimeout(d, 500)) : d(), n.callback && setTimeout(() => n.callback(), n.callbackDelay);
      } catch (c) {
        r("error", c), a.value.classList.replace("bg-main", "bg-fourth-nano"), s.value = n.error, setTimeout(() => {
          d(), a.value.classList.replace("bg-fourth-nano", "bg-main");
        }, 1330);
      }
    }
    return (d, c) => (T(), L("button", {
      onClick: le(l, ["stop"]),
      disabled: e.validation,
      ref_key: "button",
      ref: a,
      class: "button"
    }, [
      Q(xe, { name: "FromTop" }, {
        default: fe(() => [
          !o.value && !s.value && !i.value || !e.showLoader ? (T(), L("span", Vi, [
            J(d.$slots, "default")
          ])) : o.value && !s.value && e.showLoader ? (T(), L("span", ji, [
            Q($n, { class: "pos-relative pos-t-0 pos-l-0 loading" })
          ])) : i.value && e.showSucces ? (T(), L("span", Hi, W(e.text.success), 1)) : s.value ? (T(), L("span", Gi, W(s.value), 1)) : V("", !0)
        ]),
        _: 3
      }),
      e.counter ? (T(), L("p", Wi, W(e.counter), 1)) : V("", !0)
    ], 8, Bi));
  }
}, Yi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ki
}, Symbol.toStringTag, { value: "Module" })), qi = { class: "flex-v-center flex-nowrap flex" }, zi = {
  key: 0,
  class: "mn-r-auto t-transp mn-r-small"
}, Xi = ["name", "value", "checked"], qs = {
  __name: "Checkbox",
  props: {
    label: String,
    name: String,
    value: String,
    radio: {
      type: [Array, Boolean, Object],
      default: () => []
    },
    theme: {
      type: String,
      default: "light"
    }
  },
  emits: ["update:radio"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = (s) => {
      if (Array.isArray(n.radio)) {
        let o = [...n.radio];
        if (s.target.checked)
          o.push(n.value);
        else {
          const i = o.indexOf(n.value);
          i !== -1 && o.splice(i, 1);
        }
        r("update:radio", o);
      } else typeof n.radio == "boolean" && r("update:radio", s.target.checked);
    };
    return (s, o) => (T(), L("label", qi, [
      e.label ? (T(), L("div", zi, [
        P("span", null, W(e.label), 1)
      ])) : V("", !0),
      P("input", {
        onChange: a,
        class: "round radiobutton",
        type: "checkbox",
        name: e.name,
        value: e.value,
        checked: Array.isArray(e.radio) ? e.radio.includes(e.value) : e.radio
      }, null, 40, Xi),
      P("div", {
        class: X(["transition-elastic cursor-pointer mn-l-thin pd-thin h-2r w-4r radius-extra", {
          "bg-dark": !(Array.isArray(e.radio) ? e.radio.includes(e.value) : e.radio) && e.theme === "dark",
          "bg-light": !(Array.isArray(e.radio) ? e.radio.includes(e.value) : e.radio) && e.theme === "light",
          "bg-main": Array.isArray(e.radio) ? e.radio.includes(e.value) : e.radio
        }])
      }, [
        P("div", {
          class: X(["transition-linear w-1r h-1r radius-extra h-100 bg-white", {
            "mn-r-auto": !(Array.isArray(e.radio) ? e.radio.includes(e.value) : e.radio),
            "mn-l-auto": Array.isArray(e.radio) ? e.radio.includes(e.value) : e.radio
          }])
        }, null, 2)
      ], 2)
    ]));
  }
}, Ji = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qs
}, Symbol.toStringTag, { value: "Module" })), jr = {
  beforeMount(e, t, n) {
    var r;
    if (typeof t.value != "function") {
      let a = `[Vue-click-outside:] provided expression ${t.expression} is not a function, but has to be`;
      const s = (r = n.component) == null ? void 0 : r.name;
      s && (a += ` Found in component ${s}`), console.warn(a);
    }
    e.clickOutsideEvent = function(a) {
      e === a.target || e.contains(a.target) || t.value(a);
    }, document.addEventListener("click", e.clickOutsideEvent, !0);
  },
  unmounted(e) {
    document.removeEventListener("click", e.clickOutsideEvent, !0);
  }
}, Zi = {
  key: 0,
  class: "w-100 h-100 flex-center flex"
}, Qi = { key: 1 }, ur = {
  __name: "Dropdown",
  props: {
    label: {
      type: [String, Object],
      default: "Open"
    },
    align: {
      type: String,
      default: "left"
    }
  },
  setup(e) {
    let t = jr;
    const n = e, r = F(!1), a = ae(() => typeof n.label == "object");
    function s() {
      r.value = !1;
    }
    return (o, i) => Be((T(), L("div", {
      class: "dropdown pos-relative",
      onClick: i[0] || (i[0] = le((l) => r.value = !r.value, ["stop"]))
    }, [
      a.value ? (T(), L("div", Zi, [
        (T(), Le(gi(e.label.component), js(e.label.props, {
          class: e.label.class
        }), null, 16, ["class"]))
      ])) : (T(), L("div", Qi, W(e.label), 1)),
      Q(xe, {
        name: "TransitionTranslateY",
        mode: "out-in"
      }, {
        default: fe(() => [
          Be(P("div", {
            style: Xe({ left: e.align === "left" ? "0" : "auto", right: e.align === "right" ? "0" : "auto" }),
            class: "dropdown-content radius-big"
          }, [
            J(o.$slots, "default")
          ], 4), [
            [ut, r.value]
          ])
        ]),
        _: 3
      })
    ])), [
      [We(t), s]
    ]);
  }
}, el = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ur
}, Symbol.toStringTag, { value: "Module" })), tl = { class: "error-wrapper" }, nl = { class: "error-card" }, rl = {
  __name: "Error",
  props: {
    error: Object
  },
  setup(e) {
    return (t, n) => (T(), L("div", tl, [
      P("div", nl, [
        P("p", null, "Ошибка " + W(e.error.status), 1)
      ])
    ]));
  }
}, al = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rl
}, Symbol.toStringTag, { value: "Module" })), sl = {
  key: 0,
  class: "t-transp mn-r-small"
}, ol = { class: "w-100" }, il = ["type", "value", "placeholder", "tabindex", "disabled"], ll = ["value", "placeholder", "tabindex", "disabled"], dl = {
  key: 1,
  class: "t-transp mn-l-small"
}, ul = {
  key: 0,
  class: "mn-t-thin mn-b-thin mn-b-thin invalid-feedback"
}, cl = {
  __name: "Field",
  props: {
    label: null,
    symbol: null,
    type: "text",
    placeholder: "Enter something here",
    field: null,
    value: null,
    validation: !1,
    disabled: null,
    tabindex: -1
  },
  emits: ["update:field", "focus", "blur"],
  setup(e, { emit: t }) {
    const n = t, r = e;
    r.value && n("update:field", r.value);
    const a = F(null);
    function s() {
      var i;
      a.value && (a.value.style.height = "1rem"), a.value && (a.value.style.height = ((i = a.value) == null ? void 0 : i.scrollHeight) + "px");
    }
    vi(() => {
      r.type === "textarea" && kt(() => {
        focus();
      }), s();
    }), Qe(() => {
      r.type === "textarea" && kt(() => {
        focus();
      }), s();
    });
    const o = F(r.field);
    return (i, l) => (T(), L(pe, null, [
      P("div", {
        class: X([[
          i.$attrs.class,
          {
            "bg-fourth-nano": e.validation
          }
        ], "flex-center flex-nowrap flex"])
      }, [
        e.label ? (T(), L("div", sl, [
          P("span", null, W(e.label), 1)
        ])) : V("", !0),
        P("div", ol, [
          e.type !== "textarea" ? (T(), L("input", {
            key: 0,
            onInput: l[0] || (l[0] = (d) => o.value = n("update:field", d.target.value)),
            onFocus: l[1] || (l[1] = (d) => n("focus", d)),
            onBlur: l[2] || (l[2] = (d) => n("blur", d)),
            type: e.type,
            class: "w-100",
            value: e.field,
            placeholder: e.placeholder,
            tabindex: e.tabindex,
            disabled: e.disabled
          }, null, 40, il)) : (T(), L("textarea", {
            key: 1,
            ref_key: "textarea",
            ref: a,
            onInput: l[3] || (l[3] = (d) => o.value = n("update:field", d.target.value)),
            onFocus: l[4] || (l[4] = (d) => n("focus", d)),
            onBlur: l[5] || (l[5] = (d) => n("blur", d)),
            class: "w-100",
            style: { resize: "vertical" },
            value: e.field,
            placeholder: e.placeholder,
            tabindex: e.tabindex,
            disabled: e.disabled
          }, null, 40, ll))
        ]),
        J(i.$slots, "default", {}, void 0, !0),
        e.symbol ? (T(), L("div", dl, [
          P("span", null, W(e.symbol), 1)
        ])) : V("", !0)
      ], 2),
      Q(xe, { name: "fade" }, {
        default: fe(() => [
          e.validation ? (T(), L("div", ul, " * " + W(e.validation.message), 1)) : V("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}, Hr = /* @__PURE__ */ $t(cl, [["__scopeId", "data-v-5659d4ce"]]), fl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hr
}, Symbol.toStringTag, { value: "Module" })), pl = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function ml(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(pl), e.apply(this, n);
}
function cr(e) {
  "@babel/helpers - typeof";
  return cr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cr(e);
}
function hl(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function $l(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gl(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && on(e, t);
}
function vl(e) {
  var t = Xs();
  return function() {
    var r = ln(e), a;
    if (t) {
      var s = ln(this).constructor;
      a = Reflect.construct(r, arguments, s);
    } else
      a = r.apply(this, arguments);
    return yl(this, a);
  };
}
function yl(e, t) {
  if (t && (cr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return zs(e);
}
function zs(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fr(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return fr = function(r) {
    if (r === null || !bl(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, a);
    }
    function a() {
      return En(r, arguments, ln(this).constructor);
    }
    return a.prototype = Object.create(r.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), on(a, r);
  }, fr(e);
}
function En(e, t, n) {
  return Xs() ? En = Reflect.construct : En = function(a, s, o) {
    var i = [null];
    i.push.apply(i, s);
    var l = Function.bind.apply(a, i), d = new l();
    return o && on(d, o.prototype), d;
  }, En.apply(null, arguments);
}
function Xs() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function bl(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function on(e, t) {
  return on = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, on(e, t);
}
function ln(e) {
  return ln = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ln(e);
}
var yt = /* @__PURE__ */ function(e) {
  gl(n, e);
  var t = vl(n);
  function n(r) {
    var a;
    return $l(this, n), a = t.call(this, r), Object.setPrototypeOf(zs(a), n.prototype), a.name = a.constructor.name, a;
  }
  return hl(n);
}(/* @__PURE__ */ fr(Error)), Gr = 2, _l = 17, El = 3, ft = "0-9０-９٠-٩۰-۹", Ol = "-‐-―−ー－", Cl = "／/", Tl = "．.", Sl = "  ­​⁠　", wl = "()（）［］\\[\\]", Nl = "~⁓∼～", wn = "".concat(Ol).concat(Cl).concat(Tl).concat(Sl).concat(wl).concat(Nl), Wr = "+＋";
function ya(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), a = 0; a < 3; a++) {
    var s = Number(n[a]), o = Number(r[a]);
    if (s > o) return 1;
    if (o > s) return -1;
    if (!isNaN(s) && isNaN(o)) return 1;
    if (isNaN(s) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var Ll = {}.constructor;
function On(e) {
  return e != null && e.constructor === Ll;
}
function pr(e) {
  "@babel/helpers - typeof";
  return pr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pr(e);
}
function Fn(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Il(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Mn(e, t, n) {
  return t && Il(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Pl = "1.2.0", Al = "1.7.35", ba = " ext. ", kl = /^\d+$/, Ye = /* @__PURE__ */ function() {
  function e(t) {
    Fn(this, e), Ml(t), this.metadata = t, Js.call(this, t);
  }
  return Mn(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && kl.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new _a(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new _a(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[n];
        if (a)
          return a;
      } else {
        var s = this.countryCallingCodes()[n];
        if (s && s.length === 1 && s[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), _a = /* @__PURE__ */ function() {
  function e(t, n) {
    Fn(this, e), this.globalMetadataObject = n, this.metadata = t, Js.call(this, n.metadata);
  }
  return Mn(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(a) {
        return new Dl(a, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && Ea(this.types(), n))
        return new Fl(Ea(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? ba : this.metadata[13] || ba;
    }
  }]), e;
}(), Dl = /* @__PURE__ */ function() {
  function e(t, n) {
    Fn(this, e), this._format = t, this.metadata = n;
  }
  return Mn(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !Rl.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), Rl = /^\(?\$1\)?$/, Fl = /* @__PURE__ */ function() {
  function e(t, n) {
    Fn(this, e), this.type = t, this.metadata = n;
  }
  return Mn(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Ea(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Ml(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!On(e) || !On(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(On(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + xl(e) + ": " + e, "."));
}
var xl = function(t) {
  return pr(t);
};
function Kr(e, t) {
  if (t = new Ye(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Ul(e, t) {
  return t.countries.hasOwnProperty(e);
}
function Js(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? ya(t, Pl) === -1 ? this.v2 = !0 : ya(t, Al) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Bl = ";ext=", Vt = function(t) {
  return "([".concat(ft, "]{1,").concat(t, "})");
};
function Zs(e) {
  var t = "20", n = "15", r = "9", a = "6", s = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", i = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", u = "[  \\t]*", f = "(?:,{2}|;)", v = Bl + Vt(t), p = s + l + o + Vt(t) + i, m = s + d + o + Vt(r) + i, g = c + Vt(a) + "#", y = u + f + o + Vt(n) + i, S = u + "(?:,)+" + o + Vt(r) + i;
  return v + "|" + p + "|" + m + "|" + g + "|" + y + "|" + S;
}
var Vl = "[" + ft + "]{" + Gr + "}", jl = "[" + Wr + "]{0,1}(?:[" + wn + "]*[" + ft + "]){3,}[" + wn + ft + "]*", Hl = new RegExp("^[" + Wr + "]{0,1}(?:[" + wn + "]*[" + ft + "]){1,2}$", "i"), Gl = jl + // Phone number extensions
"(?:" + Zs() + ")?", Wl = new RegExp(
  // Either a short two-digit-only phone number
  "^" + Vl + "$|^" + Gl + "$",
  "i"
);
function Kl(e) {
  return e.length >= Gr && Wl.test(e);
}
function Yl(e) {
  return Hl.test(e);
}
var Oa = new RegExp("(?:" + Zs() + ")$", "i");
function ql(e) {
  var t = e.search(Oa);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(Oa), a = 1; a < r.length; ) {
    if (r[a])
      return {
        number: n,
        ext: r[a]
      };
    a++;
  }
}
var zl = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Xl(e) {
  return zl[e];
}
function Jl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Zl(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zl(e, t) {
  if (e) {
    if (typeof e == "string") return Ca(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ca(e, t);
  }
}
function Ca(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Ta(e) {
  for (var t = "", n = Jl(e.split("")), r; !(r = n()).done; ) {
    var a = r.value;
    t += Ql(a, t) || "";
  }
  return t;
}
function Ql(e, t, n) {
  return e === "+" ? t ? void 0 : "+" : Xl(e);
}
function Yr(e, t) {
  return ed(e, void 0, t);
}
function ed(e, t, n) {
  var r = n.type(t), a = r && r.possibleLengths() || n.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var s = e.length, o = a[0];
  return o === s ? "IS_POSSIBLE" : o > s ? "TOO_SHORT" : a[a.length - 1] < s ? "TOO_LONG" : a.indexOf(s, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function td(e, t, n) {
  if (t === void 0 && (t = {}), n = new Ye(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Qs(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Qs(e, t) {
  switch (Yr(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Et(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function nd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = rd(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rd(e, t) {
  if (e) {
    if (typeof e == "string") return Sa(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Sa(e, t);
  }
}
function Sa(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var ad = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function qr(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new Ye(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (Et(r, n.nationalNumberPattern())) {
      if (Jn(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Jn(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = nd(ad), s; !(s = a()).done; ) {
        var o = s.value;
        if (Jn(r, o, n))
          return o;
      }
    }
  }
}
function Jn(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Et(e, t.pattern());
}
function sd(e, t, n) {
  if (t = t || {}, n = new Ye(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return qr(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return Et(r, n.nationalNumberPattern());
}
function od(e, t, n) {
  var r = new Ye(n), a = r.getCountryCodesForCallingCode(e);
  return a ? a.filter(function(s) {
    return id(t, s, n);
  }) : [];
}
function id(e, t, n) {
  var r = new Ye(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function ld(e) {
  return e.replace(new RegExp("[".concat(wn, "]+"), "g"), " ").trim();
}
var dd = /(\$\d)/;
function ud(e, t, n) {
  var r = n.useInternationalFormat, a = n.withNationalPrefix, s = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && t.nationalPrefixFormattingRule() ? t.format().replace(dd, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? ld(s) : s;
}
var cd = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function fd(e, t, n) {
  var r = new Ye(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (cd.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function pd(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function md(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = hd(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hd(e, t) {
  if (e) {
    if (typeof e == "string") return wa(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wa(e, t);
  }
}
function wa(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Na(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function La(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Na(Object(n), !0).forEach(function(r) {
      $d(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Na(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $d(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Ia = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function gd(e, t, n, r) {
  if (n ? n = La(La({}, Ia), n) : n = Ia, r = new Ye(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var a = r.countryCallingCode(), s = n.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return s ? (o = Nn(s, e.carrierCode, "NATIONAL", r, n), Zn(o, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return s ? (o = Nn(s, null, "INTERNATIONAL", r, n), o = "+".concat(a, " ").concat(o), Zn(o, e.ext, r, n.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(s);
    case "RFC3966":
      return pd({
        number: "+".concat(a).concat(s),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var i = yd(s, e.carrierCode, a, n.fromCountry, r);
      return Zn(i, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function Nn(e, t, n, r, a) {
  var s = vd(r.formats(), e);
  return s ? ud(e, s, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(s.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function vd(e, t) {
  for (var n = md(e), r; !(r = n()).done; ) {
    var a = r.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var s = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (t.search(s) !== 0)
        continue;
    }
    if (Et(t, a.pattern()))
      return a;
  }
}
function Zn(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function yd(e, t, n, r, a) {
  var s = Kr(r, a.metadata);
  if (s === n) {
    var o = Nn(e, t, "NATIONAL", a);
    return n === "1" ? n + " " + o : o;
  }
  var i = fd(r, void 0, a.metadata);
  if (i)
    return "".concat(i, " ").concat(n, " ").concat(Nn(e, null, "INTERNATIONAL", a));
}
function Pa(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Aa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pa(Object(n), !0).forEach(function(r) {
      bd(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pa(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bd(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _d(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ed(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Od(e, t, n) {
  return t && Ed(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Cd = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (_d(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var a = Sd(t, r), s = a.country, o = a.countryCallingCode;
    this.country = s, this.countryCallingCode = o, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return Od(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : od(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return td(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return sd(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new Ye(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return qr(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return gd(this, n, r ? Aa(Aa({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), Td = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function Sd(e, t) {
  var n, r, a = new Ye(t);
  return Td(e) ? (n = e, a.selectNumberingPlan(n), r = a.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var wd = new RegExp("([" + ft + "])");
function Nd(e, t, n, r) {
  if (t) {
    var a = new Ye(r);
    a.selectNumberingPlan(t, n);
    var s = new RegExp(a.IDDPrefix());
    if (e.search(s) === 0) {
      e = e.slice(e.match(s)[0].length);
      var o = e.match(wd);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function Ld(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var a, s, o = r.length - 1, i = o > 0 && r[o];
      if (t.nationalPrefixTransformRule() && i)
        a = e.replace(n, t.nationalPrefixTransformRule()), o > 1 && (s = r[1]);
      else {
        var l = r[0];
        a = e.slice(l.length), i && (s = r[1]);
      }
      var d;
      if (i) {
        var c = e.indexOf(r[1]), u = e.slice(0, c);
        u === t.numberingPlan.nationalPrefix() && (d = t.numberingPlan.nationalPrefix());
      } else
        d = r[0];
      return {
        nationalNumber: a,
        nationalPrefix: d,
        carrierCode: s
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function mr(e, t) {
  var n = Ld(e, t), r = n.carrierCode, a = n.nationalNumber;
  if (a !== e) {
    if (!Id(e, a, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !Pd(a, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: r
  };
}
function Id(e, t, n) {
  return !(Et(e, n.nationalNumberPattern()) && !Et(t, n.nationalNumberPattern()));
}
function Pd(e, t) {
  switch (Yr(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Ad(e, t, n, r) {
  var a = t ? Kr(t, r) : n;
  if (e.indexOf(a) === 0) {
    r = new Ye(r), r.selectNumberingPlan(t, n);
    var s = e.slice(a.length), o = mr(s, r), i = o.nationalNumber, l = mr(e, r), d = l.nationalNumber;
    if (!Et(d, r.nationalNumberPattern()) && Et(i, r.nationalNumberPattern()) || Yr(d, r) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: s
      };
  }
  return {
    number: e
  };
}
function kd(e, t, n, r) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var s = Nd(e, t, n, r);
    if (s && s !== e)
      a = !0, e = "+" + s;
    else {
      if (t || n) {
        var o = Ad(e, t, n, r), i = o.countryCallingCode, l = o.number;
        if (i)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: i,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new Ye(r);
  for (var d = 2; d - 1 <= El && d <= e.length; ) {
    var c = e.slice(1, d);
    if (r.hasCallingCode(c))
      return r.selectNumberingPlan(c), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(d)
      };
    d++;
  }
  return {};
}
function Dd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Rd(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rd(e, t) {
  if (e) {
    if (typeof e == "string") return ka(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ka(e, t);
  }
}
function ka(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Fd(e, t) {
  var n = t.countries, r = t.defaultCountry, a = t.metadata;
  a = new Ye(a);
  for (var s = [], o = Dd(n), i; !(i = o()).done; ) {
    var l = i.value;
    if (a.country(l), a.leadingDigits()) {
      if (e && e.search(a.leadingDigits()) === 0)
        return l;
    } else if (qr({
      phone: e,
      country: l
    }, void 0, a.metadata))
      if (r) {
        if (l === r)
          return l;
        s.push(l);
      } else
        return l;
  }
  if (s.length > 0)
    return s[0];
}
function Md(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, a = t.metadata, s = a.getCountryCodesForCallingCode(e);
  if (s)
    return s.length === 1 ? s[0] : Fd(n, {
      countries: s,
      defaultCountry: r,
      metadata: a.metadata
    });
}
var eo = "+", xd = "[\\-\\.\\(\\)]?", Da = "([" + ft + "]|" + xd + ")", Ud = "^\\" + eo + Da + "*[" + ft + "]" + Da + "*$", Bd = new RegExp(Ud, "g"), hr = ft, Vd = "[" + hr + "]+((\\-)*[" + hr + "])*", jd = "a-zA-Z", Hd = "[" + jd + "]+((\\-)*[" + hr + "])*", Gd = "^(" + Vd + "\\.)*" + Hd + "\\.?$", Wd = new RegExp(Gd, "g"), Ra = "tel:", $r = ";phone-context=", Kd = ";isub=";
function Yd(e) {
  var t = e.indexOf($r);
  if (t < 0)
    return null;
  var n = t + $r.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function qd(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Bd.test(e) || Wd.test(e);
}
function zd(e, t) {
  var n = t.extractFormattedPhoneNumber, r = Yd(e);
  if (!qd(r))
    throw new yt("NOT_A_NUMBER");
  var a;
  if (r === null)
    a = n(e) || "";
  else {
    a = "", r.charAt(0) === eo && (a += r);
    var s = e.indexOf(Ra), o;
    s >= 0 ? o = s + Ra.length : o = 0;
    var i = e.indexOf($r);
    a += e.substring(o, i);
  }
  var l = a.indexOf(Kd);
  if (l > 0 && (a = a.substring(0, l)), a !== "")
    return a;
}
var Xd = 250, Jd = new RegExp("[" + Wr + ft + "]"), Zd = new RegExp("[^" + ft + "#]+$");
function Qd(e, t, n) {
  if (t = t || {}, n = new Ye(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new yt("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = tu(e, t.v2, t.extract), a = r.number, s = r.ext, o = r.error;
  if (!a) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new yt("TOO_SHORT") : new yt("NOT_A_NUMBER");
    return {};
  }
  var i = ru(a, t.defaultCountry, t.defaultCallingCode, n), l = i.country, d = i.nationalNumber, c = i.countryCallingCode, u = i.countryCallingCodeSource, f = i.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new yt("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < Gr) {
    if (t.v2)
      throw new yt("TOO_SHORT");
    return {};
  }
  if (d.length > _l) {
    if (t.v2)
      throw new yt("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var v = new Cd(c, d, n.metadata);
    return l && (v.country = l), f && (v.carrierCode = f), s && (v.ext = s), v.__countryCallingCodeSource = u, v;
  }
  var p = (t.extended ? n.hasSelectedNumberingPlan() : l) ? Et(d, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: c,
    carrierCode: f,
    valid: p,
    possible: p ? !0 : !!(t.extended === !0 && n.possibleLengths() && Qs(d, n)),
    phone: d,
    ext: s
  } : p ? nu(l, d, s) : {};
}
function eu(e, t, n) {
  if (e) {
    if (e.length > Xd) {
      if (n)
        throw new yt("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(Jd);
    if (!(r < 0))
      return e.slice(r).replace(Zd, "");
  }
}
function tu(e, t, n) {
  var r = zd(e, {
    extractFormattedPhoneNumber: function(o) {
      return eu(o, n, t);
    }
  });
  if (!r)
    return {};
  if (!Kl(r))
    return Yl(r) ? {
      error: "TOO_SHORT"
    } : {};
  var a = ql(r);
  return a.ext ? a : {
    number: r
  };
}
function nu(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function ru(e, t, n, r) {
  var a = kd(Ta(e), t, n, r.metadata), s = a.countryCallingCodeSource, o = a.countryCallingCode, i = a.number, l;
  if (o)
    r.selectNumberingPlan(o);
  else if (i && (t || n))
    r.selectNumberingPlan(t, n), t && (l = t), o = n || Kr(t, r.metadata);
  else return {};
  if (!i)
    return {
      countryCallingCodeSource: s,
      countryCallingCode: o
    };
  var d = mr(Ta(i), r), c = d.nationalNumber, u = d.carrierCode, f = Md(o, {
    nationalNumber: c,
    defaultCountry: t,
    metadata: r
  });
  return f && (l = f, f === "001" || r.country(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: s,
    nationalNumber: c,
    carrierCode: u
  };
}
function Fa(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ma(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fa(Object(n), !0).forEach(function(r) {
      au(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fa(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function au(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function su(e, t, n) {
  return Qd(e, Ma(Ma({}, t), {}, {
    v2: !0
  }), n);
}
function xa(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ou(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xa(Object(n), !0).forEach(function(r) {
      iu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xa(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function iu(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function lu(e, t) {
  return fu(e) || cu(e, t) || uu(e, t) || du();
}
function du() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uu(e, t) {
  if (e) {
    if (typeof e == "string") return Ua(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ua(e, t);
  }
}
function Ua(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function cu(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, s = !1, o, i;
    try {
      for (n = n.call(e); !(a = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); a = !0)
        ;
    } catch (l) {
      s = !0, i = l;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (s) throw i;
      }
    }
    return r;
  }
}
function fu(e) {
  if (Array.isArray(e)) return e;
}
function pu(e) {
  var t = Array.prototype.slice.call(e), n = lu(t, 4), r = n[0], a = n[1], s = n[2], o = n[3], i, l, d;
  if (typeof r == "string")
    i = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    o ? (l = s, d = o) : (l = void 0, d = s), a && (l = ou({
      defaultCountry: a
    }, l));
  else if (On(a))
    s ? (l = a, d = s) : d = a;
  else throw new Error("Invalid second argument: ".concat(a));
  return {
    text: i,
    options: l,
    metadata: d
  };
}
function Ba(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Va(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ba(Object(n), !0).forEach(function(r) {
      mu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ba(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function mu(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function hu(e, t, n) {
  t && t.defaultCountry && !Ul(t.defaultCountry, n) && (t = Va(Va({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return su(e, t, n);
  } catch (r) {
    if (!(r instanceof yt)) throw r;
  }
}
function $u() {
  var e = pu(arguments), t = e.text, n = e.options, r = e.metadata;
  return hu(t, n, r);
}
function Qn() {
  return ml($u, arguments);
}
const gu = [["‫افغانستان‬‎", "af", "93", , "🇦🇫"], ["Shqipëri", "al", "355", , "🇦🇱"], ["‫الجزائر‬‎", "dz", "213", , "🇩🇿"], ["American Samoa", "as", "1684", , "🇦🇸"], ["Andorra", "ad", "376", , "🇦🇩"], ["Angola", "ao", "244", , "🇦🇴"], ["Anguilla", "ai", "1264", , "🇦🇮"], ["Antigua and Barbuda", "ag", "1268", , "🇦🇬"], ["Argentina", "ar", "54", , "🇦🇷"], ["Հայաստան", "am", "374", , "🇦🇲"], ["Aruba", "aw", "297", , "🇦🇼"], ["Australia", "au", "61", 0, , "🇦🇺"], ["Österreich", "at", "43", , "🇦🇹"], ["Azərbaycan", "az", "994", , "🇦🇿"], ["Bahamas", "bs", "1242", , "🇧🇸"], ["‫البحرين‬‎", "bh", "973", , "🇧🇭"], ["বাংলাদেশ", "bd", "880", , "🇧🇩"], ["Barbados", "bb", "1246", , "🇧🇧"], ["Беларусь", "by", "375", , "🇧🇾"], ["België", "be", "32", , "🇧🇪"], ["Belize", "bz", "501", , "🇧🇿"], ["Bénin", "bj", "229", , "🇧🇯"], ["Bermuda", "bm", "1441", , "🇧🇲"], ["འབྲུག", "bt", "975", , "🇧🇹"], ["Bolivia", "bo", "591", , "🇧🇴"], ["Босна и Херцеговина", "ba", "387", , "🇧🇦"], ["Botswana", "bw", "267", , "🇧🇼"], ["Brasil", "br", "55", , "🇧🇷"], ["British Indian Ocean Territory", "io", "246", , "🇮🇴"], ["British Virgin Islands", "vg", "1284", , "🇻🇬"], ["Brunei", "bn", "673", , "🇧🇳"], ["България", "bg", "359", , "🇧🇬"], ["Burkina Faso", "bf", "226", , "🇧🇫"], ["Uburundi", "bi", "257", , "🇧🇮"], ["កម្ពុជា", "kh", "855", , "🇰🇭"], ["Cameroun", "cm", "237", , "🇨🇲"], ["Canada", "ca", "1", 1, "🇨🇦"], ["Kabu Verdi", "cv", "238", , "🇨🇻"], ["Caribbean Netherlands", "bq", "599", 1, , "🇧🇶"], ["Cayman Islands", "ky", "1345", , "🇰🇾"], ["République centrafricaine", "cf", "236", , "🇨🇫"], ["Tchad", "td", "235", , "🇹🇩"], ["Chile", "cl", "56", , "🇨🇱"], ["中国", "cn", "86", , "🇨🇳"], ["Christmas Island", "cx", "61", 2, , "🇨🇽"], ["Keeling", "cc", "61", 1, , "🇨🇨"], ["Colombia", "co", "57", , "🇨🇴"], ["‫جزر القمر‬‎", "km", "269", , "🇰🇲"], ["DRC", "cd", "243", , "🇨🇩"], ["Republic", "cg", "242", , "🇨🇬"], ["Cook Islands", "ck", "682", , "🇨🇰"], ["Costa Rica", "cr", "506", , "🇨🇷"], ["Côte d’Ivoire", "ci", "225", , "🇨🇮"], ["Hrvatska", "hr", "385", , "🇭🇷"], ["Cuba", "cu", "53", , "🇨🇺"], ["Curaçao", "cw", "599", 0, , "🇨🇼"], ["Κύπρος", "cy", "357", , "🇨🇾"], ["Česká republika", "cz", "420", , "🇨🇿"], ["Danmark", "dk", "45", , "🇩🇰"], ["Djibouti", "dj", "253", , "🇩🇯"], ["Dominica", "dm", "1767", , "🇩🇲"], ["República Dominicana", "do", "1", 2, ["809", "829", "849", "🇩🇴"]], ["Ecuador", "ec", "593", , "🇪🇨"], ["‫مصر‬‎", "eg", "20", , "🇪🇬"], ["El Salvador", "sv", "503", , "🇸🇻"], ["Guinea Ecuatorial", "gq", "240", , "🇬🇶"], ["Eritrea", "er", "291", , "🇪🇷"], ["Eesti", "ee", "372", , "🇪🇪"], ["Ethiopia", "et", "251", , "🇪🇹"], ["Islas Malvinas", "fk", "500", , "🇫🇰"], ["Føroyar", "fo", "298", , "🇫🇴"], ["Fiji", "fj", "679", , "🇫🇯"], ["Suomi", "fi", "358", 0, , "🇫🇮"], ["France", "fr", "33", , "🇫🇷"], ["Guyane française", "gf", "594", , "🇬🇫"], ["Polynésie française", "pf", "689", , "🇵🇫"], ["Gabon", "ga", "241", , "🇬🇦"], ["Gambia", "gm", "220", , "🇬🇲"], ["საქართველო", "ge", "995", , "🇬🇪"], ["Deutschland", "de", "49", , "🇩🇪"], ["Gaana", "gh", "233", , "🇬🇭"], ["Gibraltar", "gi", "350", , "🇬🇮"], ["Ελλάδα", "gr", "30", , "🇬🇷"], ["Kalaallit Nunaat", "gl", "299", , "🇬🇱"], ["Grenada", "gd", "1473", , "🇬🇩"], ["Guadeloupe", "gp", "590", 0, , "🇬🇵"], ["Guam", "gu", "1671", , "🇬🇺"], ["Guatemala", "gt", "502", , "🇬🇹"], ["Guernsey", "gg", "44", 1, , "🇬🇬"], ["Guinée", "gn", "224", , "🇬🇳"], ["Guiné Bissau", "gw", "245", , "🇬🇼"], ["Guyana", "gy", "592", , "🇬🇾"], ["Haiti", "ht", "509", , "🇭🇹"], ["Honduras", "hn", "504", , "🇭🇳"], ["香港", "hk", "852", , "🇭🇰"], ["Magyarország", "hu", "36", , "🇭🇺"], ["Ísland", "is", "354", , "🇮🇸"], ["भारत", "in", "91", , "🇮🇳"], ["Indonesia", "id", "62", , "🇮🇩"], ["‫ایران‬‎", "ir", "98", , "🇮🇷"], ["‫العراق‬‎", "iq", "964", , "🇮🇶"], ["Ireland", "ie", "353", , "🇮🇪"], ["Isle of Man", "im", "44", 2, , "🇮🇲"], ["‫ישראל‬‎", "il", "972", , "🇮🇱"], ["Italia", "it", "39", 0, , "🇮🇹"], ["Jamaica", "jm", "1876", , "🇯🇲"], ["日本", "jp", "81", , "🇯🇵"], ["Jersey", "je", "44", 3, , "🇯🇪"], ["‫الأردن‬‎", "jo", "962", , "🇯🇴"], ["Казахстан", "kz", "7", 1, , "🇰🇿"], ["Kenya", "ke", "254", , "🇰🇪"], ["Kiribati", "ki", "686", , "🇰🇮"], ["Kosovo", "xk", "383", , "🇽🇰"], ["‫الكويت‬‎", "kw", "965", , "🇰🇼"], ["Кыргызстан", "kg", "996", , "🇰🇬"], ["ລາວ", "la", "856", , "🇱🇦"], ["Latvija", "lv", "371", , "🇱🇻"], ["‫لبنان‬‎", "lb", "961", , "🇱🇧"], ["Lesotho", "ls", "266", , "🇱🇸"], ["Liberia", "lr", "231", , "🇱🇷"], ["‫ليبيا‬‎", "ly", "218", , "🇱🇾"], ["Liechtenstein", "li", "423", , "🇱🇮"], ["Lietuva", "lt", "370", , "🇱🇹"], ["Luxembourg", "lu", "352", , "🇱🇺"], ["澳門", "mo", "853", , "🇲🇴"], ["FYROM", "mk", "389", , "🇲🇰"], ["Madagasikara", "mg", "261", , "🇲🇬"], ["Malawi", "mw", "265", , "🇲🇼"], ["Malaysia", "my", "60", , "🇲🇾"], ["Maldives", "mv", "960", , "🇲🇻"], ["Mali", "ml", "223", , "🇲🇱"], ["Malta", "mt", "356", , "🇲🇹"], ["Marshall Islands", "mh", "692", , "🇲🇭"], ["Martinique", "mq", "596", , "🇲🇶"], ["‫موريتانيا‬‎", "mr", "222", , "🇲🇷"], ["Moris", "mu", "230", , "🇲🇺"], ["Mayotte", "yt", "262", 1, , "🇾🇹"], ["México", "mx", "52", , "🇲🇽"], ["Micronesia", "fm", "691", , "🇫🇲"], ["Republica Moldova", "md", "373", , "🇲🇩"], ["Monaco", "mc", "377", , "🇲🇨"], ["Монгол", "mn", "976", , "🇲🇳"], ["Crna Gora", "me", "382", , "🇲🇪"], ["Montserrat", "ms", "1664", , "🇲🇸"], ["‫المغرب‬‎", "ma", "212", 0, , "🇲🇦"], ["Moçambique", "mz", "258", , "🇲🇿"], ["Burma", "mm", "95", , "🇲🇲"], ["Namibië", "na", "264", , "🇳🇦"], ["Nauru", "nr", "674", , "🇳🇷"], ["नेपाल", "np", "977", , "🇳🇵"], ["Nederland", "nl", "31", , "🇳🇱"], ["Nouvelle-Calédonie", "nc", "687", , "🇳🇨"], ["New Zealand", "nz", "64", , "🇳🇿"], ["Nicaragua", "ni", "505", , "🇳🇮"], ["Nijar", "ne", "227", , "🇳🇪"], ["Nigeria", "ng", "234", , "🇳🇬"], ["Niue", "nu", "683", , "🇳🇺"], ["Norfolk Island", "nf", "672", , "🇳🇫"], ["조선 민주주의 인민 공화국", "kp", "850", , "🇰🇵"], ["Northern Mariana Islands", "mp", "1670", , "🇲🇵"], ["Norge", "no", "47", 0, , "🇳🇴"], ["‫عُمان‬‎", "om", "968", , "🇴🇲"], ["‫پاکستان‬‎", "pk", "92", , "🇵🇰"], ["Palau", "pw", "680", , "🇵🇼"], ["‫فلسطين‬‎", "ps", "970", , "🇵🇸"], ["Panamá", "pa", "507", , "🇵🇦"], ["Papua New Guinea", "pg", "675", , "🇵🇬"], ["Paraguay", "py", "595", , "🇵🇾"], ["Perú", "pe", "51", , "🇵🇪"], ["Philippines", "ph", "63", , "🇵🇭"], ["Polska", "pl", "48", , "🇵🇱"], ["Portugal", "pt", "351", , "🇵🇹"], ["Puerto Rico", "pr", "1", 3, ["787", "939", "🇵🇷"]], ["‫قطر‬‎", "qa", "974", , "🇶🇦"], ["La Réunion", "re", "262", 0, , "🇷🇪"], ["România", "ro", "40", , "🇷🇴"], ["Россия", "ru", "7", 0, , "🇷🇺"], ["Rwanda", "rw", "250", , "🇷🇼"], ["Saint Barthélemy", "bl", "590", 1, , "🇧🇱"], ["Saint Helena", "sh", "290", , "🇸🇭"], ["Saint Kitts and Nevis", "kn", "1869", , "🇰🇳"], ["Saint Lucia", "lc", "1758", , "🇱🇨"], ["Saint-Martin (partie française", "mf", "590", 2, , "🇲🇫"], ["Saint-Pierre-et-Miquelon", "pm", "508", , "🇵🇲"], ["Saint Vincent and the Grenadines", "vc", "1784", , "🇻🇨"], ["Samoa", "ws", "685", , "🇼🇸"], ["San Marino", "sm", "378", , "🇸🇲"], ["São Tomé e Príncipe", "st", "239", , "🇸🇹"], ["‫المملكة العربية السعودية‬‎", "sa", "966", , "🇸🇦"], ["Sénégal", "sn", "221", , "🇸🇳"], ["Србија", "rs", "381", , "🇷🇸"], ["Seychelles", "sc", "248", , "🇸🇨"], ["Sierra Leone", "sl", "232", , "🇸🇱"], ["Singapore", "sg", "65", , "🇸🇬"], ["Sint Maarten", "sx", "1721", , "🇸🇽"], ["Slovensko", "sk", "421", , "🇸🇰"], ["Slovenija", "si", "386", , "🇸🇮"], ["Solomon Islands", "sb", "677", , "🇸🇧"], ["Soomaaliya", "so", "252", , "🇸🇴"], ["South Africa", "za", "27", , "🇿🇦"], ["대한민국", "kr", "82", , "🇰🇷"], ["‫جنوب السودان‬‎", "ss", "211", , "🇸🇸"], ["España", "es", "34", , "🇪🇸"], ["ශ්‍රී ලංකාව", "lk", "94", , "🇱🇰"], ["‫السودان‬‎", "sd", "249", , "🇸🇩"], ["Suriname", "sr", "597", , "🇸🇷"], ["Svalbard and Jan Mayen", "sj", "47", 1, , "🇸🇯"], ["Swaziland", "sz", "268", , "🇸🇿"], ["Sverige", "se", "46", , "🇸🇪"], ["Schweiz", "ch", "41", , "🇨🇭"], ["‫سوريا‬‎", "sy", "963", , "🇸🇾"], ["台灣", "tw", "886", , "🇹🇼"], ["Tajikistan", "tj", "992", , "🇹🇯"], ["Tanzania", "tz", "255", , "🇹🇿"], ["ไทย", "th", "66", , "🇹🇭"], ["Timor-Leste", "tl", "670", , "🇹🇱"], ["Togo", "tg", "228", , "🇹🇬"], ["Tokelau", "tk", "690", , "🇹🇰"], ["Tonga", "to", "676", , "🇹🇴"], ["Trinidad and Tobago", "tt", "1868", , "🇹🇹"], ["‫تونس‬‎", "tn", "216", , "🇹🇳"], ["Türkiye", "tr", "90", , "🇹🇷"], ["Turkmenistan", "tm", "993", , "🇹🇲"], ["Turks and Caicos Islands", "tc", "1649", , "🇹🇨"], ["Tuvalu", "tv", "688", , "🇹🇻"], ["U.S. Virgin Islands", "vi", "1340", , "🇻🇮"], ["Uganda", "ug", "256", , "🇺🇬"], ["Україна", "ua", "380", , "🇺🇦"], ["‫الإمارات العربية المتحدة‬‎", "ae", "971", , "🇦🇪"], ["United Kingdom", "gb", "44", 0, , "🇬🇧"], ["United States", "us", "1", 0, , "🇺🇸"], ["Uruguay", "uy", "598", , "🇺🇾"], ["Oʻzbekiston", "uz", "998", , "🇺🇿"], ["Vanuatu", "vu", "678", , "🇻🇺"], ["Città del Vaticano", "va", "39", 1, , "🇻🇦"], ["Venezuela", "ve", "58", , "🇻🇪"], ["Việt Nam", "vn", "84", , "🇻🇳"], ["Wallis-et-Futuna", "wf", "681", , "🇼🇫"], ["‫الصحراء الغربية‬‎", "eh", "212", 1, , "🇪🇭"], ["‫اليمن‬‎", "ye", "967", , "🇾🇪"], ["Zambia", "zm", "260", , "🇿🇲"], ["Zimbabwe", "zw", "263", , "🇿🇼"], ["Åland Islands", "ax", "358", 1, , "🇦🇽"]], vu = gu.map((e) => ({
  name: e[0],
  iso2: e[1].toUpperCase(),
  dialCode: e[2],
  priority: e[3] || 0,
  areaCodes: e[4] || null,
  flag: e[e.length - 1] || null
})), yu = ["tabindex"], bu = { class: "flex-nowrap flex flex-v-center p-medium vti__selection" }, _u = ["innerHTML"], Eu = {
  key: 1,
  class: "vti__country-code"
}, Ou = ["onClick", "onMousemove"], Cu = ["innerHTML"], Tu = { key: 1 }, Su = ["type", "autocomplete", "autofocus", "disabled", "id", "maxlength", "name", "placeholder", "readonly", "required", "tabindex"], wu = {
  key: 0,
  class: "mn-t-thin mn-b-thin invalid-feedback"
}, Nu = {
  __name: "FieldPhone",
  props: {
    modelValue: { type: String, default: "" },
    badClass: { type: [String, Array, Object], default: "" },
    goodClass: { type: [String, Array, Object], default: "" },
    badStyle: { type: [String, Array, Object], default: "" },
    goodStyle: { type: [String, Array, Object], default: "" },
    badInputClass: { type: [String, Array, Object], default: "" },
    goodInputClass: { type: [String, Array, Object], default: "" },
    badInputStyle: { type: [String, Array, Object], default: "" },
    goodInputStyle: { type: [String, Array, Object], default: "" },
    allCountries: { type: Array, default: () => vu },
    autoFormat: { type: Boolean, default: () => !0 },
    validation: { type: [Boolean, Object], default: !1 },
    customValidate: { type: [Boolean, RegExp], default: () => !1 },
    defaultCountry: { type: String, default: () => "" },
    disabled: { type: Boolean, default: () => !1 },
    autoDefaultCountry: { type: Boolean, default: () => !0 },
    ignoredCountries: { type: Array, default: () => [] },
    invalidMsg: { type: String, default: () => "" },
    mode: { type: String, default: () => "auto" },
    onlyCountries: { type: Array, default: () => [] },
    preferredCountries: { type: Array, default: () => [] },
    validCharactersOnly: { type: Boolean, default: () => !1 },
    rootClass: { type: [String, Array, Object], default: () => "" },
    inputClass: { type: [String, Array, Object], default: () => "" },
    divInputClass: { type: [String, Array, Object], default: () => "" },
    rootStyle: { type: [String, Array, Object], default: () => "" },
    dropdownStyle: { type: [String, Array, Object], default: () => "" },
    listStyle: { type: [String, Array, Object], default: () => "" },
    inputStyle: { type: [String, Array, Object], default: () => "" },
    inputId: { type: [String, Array, Object], default: () => "" },
    Placeholder: { type: [String, Object, Function], default: () => "" },
    dropdownOptions: {
      type: Object,
      default: () => ({
        showDialCodeInList: !0,
        showDialCodeInSelection: !1,
        showFlags: !0,
        tabindex: 0
      })
    },
    inputOptions: {
      type: Object,
      default: () => ({
        autocomplete: "on",
        autofocus: !1,
        id: "",
        maxlength: 25,
        name: "telephone",
        placeholder: "Enter a phone number",
        readonly: !1,
        required: !1,
        tabindex: 0,
        type: "tel",
        styleClasses: ""
      })
    }
  },
  emits: [
    "update:modelValue",
    "change",
    "validate",
    "country-changed",
    "open",
    "close",
    "blur",
    "focus",
    "enter",
    "space"
  ],
  setup(e, { emit: t }) {
    let n = jr;
    const r = e, a = t;
    F(5), F(5), Hs({
      action: null,
      amount: null
    });
    const s = F(r.modelValue ? r.modelValue : ""), o = F(""), i = F(!1), l = F(!1), d = F(null), c = F(""), u = F(null), f = F("below"), v = F(r.Placeholder !== "" ? r.Placeholder : r.inputOptions.placeholder), p = F(null), m = F(null), g = F(null);
    Qe(async () => {
      r.modelValue && (s.value = r.modelValue), Re(), $e().then(() => {
        var D;
        !s.value && ((D = r.inputOptions) != null && D.showDialCode) && o.value && (s.value = `+${o.value}`), a("validate", _.value);
      }).catch(console.error).then(() => {
        l.value = !0;
      });
    });
    const y = ae(() => de(o.value)), S = ae(() => y.value ? y.value.flag : null), $ = ae(() => r.mode === "auto" ? !s.value || s.value[0] !== "+" ? "national" : "international" : ["international", "national"].includes(r.mode) ? r.mode : (console.error('Invalid value of prop "mode"'), "international")), E = ae(() => r.onlyCountries && r.onlyCountries.length ? r.allCountries.filter(({ iso2: D }) => r.onlyCountries.includes(D.toUpperCase())) : r.ignoredCountries && r.ignoredCountries.length ? r.allCountries.filter(
      ({ iso2: D }) => !r.ignoredCountries.includes(D.toUpperCase()) && !r.ignoredCountries.includes(D.toLowerCase())
    ) : r.allCountries), O = ae(() => [...Se(r.preferredCountries).map((N) => ({ ...N, preferred: !0 })), ...E.value]), _ = ae(() => {
      var Ne, He, h;
      let D = {};
      ((Ne = s.value) == null ? void 0 : Ne[0]) === "+" ? D = Qn(s.value) || {} : D = Qn(s.value, o.value) || {};
      const { metadata: N, ...B } = D;
      let te = (He = D.isValid) == null ? void 0 : He.call(D), he = s.value;
      return te && (he = (h = D.format) == null ? void 0 : h.call(D, $.value.toUpperCase(), { nationalPrefix: !1 })), D.country && (r.ignoredCountries.length || r.onlyCountries.length) && (de(D.country) || (te = !1, D = { ...D, country: null })), {
        ...B,
        countryCode: D.country,
        valid: te,
        country: y.value,
        formatted: he
      };
    }), w = ae(() => _.value.valid === !0 ? r.goodClass : _.value.valid === !1 ? r.badClass : void 0), k = ae(() => _.value.valid === !0 ? r.goodStyle : _.value.valid === !1 ? r.badStyle : void 0), C = ae(() => _.value.valid === !0 ? r.goodInputClass : _.value.valid === !1 ? r.badInputClass : void 0), M = ae(() => _.value.valid === !0 ? r.goodInputStyle : _.value.valid === !1 ? r.badInputStyle : void 0);
    Te(y, (D, N) => {
      if (!D && (N != null && N.iso2)) {
        o.value = N.iso2;
        return;
      }
      D != null && D.iso2 && (a("country-changed", D), Y());
    }), Te(() => _.value.countryCode, (D) => {
      o.value = D;
    }), Te(() => _.value.valid, () => {
      a("validate", _.value);
    }), Te(() => _.value.formatted, (D) => {
      !r.autoFormat || r.customValidate || (Pe(D), kt(() => {
        D && !r.modelValue && (s.value = D);
      }));
    }), Te(() => r.inputOptions.placeholder, () => {
      Y();
    }), Te(() => r.modelValue, (D, N) => {
      et() ? s.value = D : kt(() => {
        s.value = N, be();
      });
    }), Te(i, (D) => {
      D ? (G(), a("open")) : a("close");
    });
    function U() {
      return fetch("https://ip2c.org/s").then((D) => D.text()).then((D) => {
        const N = (D || "").toString();
        if (!N || N[0] !== "1")
          throw new Error("unable to fetch the country");
        return N.substr(2, 2);
      });
    }
    function j(D, N) {
      if (D.setSelectionRange)
        D.focus(), D.setSelectionRange(N, N);
      else if (D.createTextRange) {
        const B = D.createTextRange();
        B.collapse(!0), B.moveEnd("character", N), B.moveStart("character", N), B.select();
      }
    }
    function Y() {
      v.value = r.inputOptions.placeholder;
    }
    function $e() {
      return new Promise((D) => {
        var B;
        if (((B = s.value) == null ? void 0 : B[0]) === "+") {
          D();
          return;
        }
        if (r.defaultCountry) {
          ye(r.defaultCountry), D();
          return;
        }
        const N = r.preferredCountries[0] || E.value[0];
        r.autoDefaultCountry ? U().then((te) => {
          ye(te || o.value);
        }).catch((te) => {
          console.warn(te), ye(N);
        }).finally(() => {
          D();
        }) : (ye(N), D());
      });
    }
    function Se(D = []) {
      return D.map((N) => de(N)).filter(Boolean);
    }
    function de(D = "") {
      return E.value.find((N) => N.iso2 === D.toUpperCase());
    }
    function Ue(D, N) {
      const B = d.value === D, te = D === r.preferredCountries.length - 1, he = r.preferredCountries.some((Ne) => Ne.toUpperCase() === N);
      return { highlighted: B, "last-preferred": te, preferred: he };
    }
    function ye(D) {
      var B, te;
      let N = typeof D == "string" ? de(D) : D;
      if (N) {
        if (((B = s.value) == null ? void 0 : B[0]) === "+" && N.iso2 && _.value.nationalNumber) {
          o.value = N.iso2, s.value = Qn(_.value.nationalNumber, N.iso2).formatInternational();
          return;
        }
        if ((te = r.inputOptions) != null && te.showDialCode && N) {
          s.value = `+${N.dialCode}`;
          return;
        }
        o.value = N.iso2, Pe(s.value);
      }
    }
    function Re() {
      const D = s.value;
      if (r.validCharactersOnly) {
        const N = s.value.match(/[()\-+0-9\s]*/g);
        s.value = N.join("");
      }
      if (r.customValidate && r.customValidate instanceof RegExp) {
        const N = s.value.match(r.customValidate);
        s.value = N ? N.join("") : "";
      }
      D !== s.value && Pe(s.value);
    }
    function et() {
      return r.validCharactersOnly && !/^[()\-+0-9\s]*$/.test(s.value) ? !1 : r.customValidate ? Ie() : !0;
    }
    function Ie() {
      return r.customValidate instanceof RegExp ? r.customValidate.test(s.value) : !1;
    }
    function be() {
      g.value.setCustomValidity(_.valid ? "" : r.invalidMsg), Pe(s.value);
    }
    function Pe(D) {
      a("update:modelValue", D), _.value.valid ? (a("change", _.value.number), a("country", _.value.number)) : a("country", null);
    }
    function Ae() {
      a("blur");
    }
    function tt() {
      j(g.value, s.value.length), a("focus");
    }
    function nt() {
      a("enter");
    }
    function Oe() {
      a("space");
    }
    function _e() {
      r.disabled || (i.value = !i.value);
    }
    function Fe() {
      i.value = !1;
    }
    function Ce(D) {
      D.keyCode === 40 ? (D.preventDefault(), i.value = !0, d.value = d.value === null ? 0 : Math.min(O.value.length - 1, d.value + 1), kt(() => {
        const N = m.value.children[d.value];
        N.offsetTop + N.clientHeight > m.value.scrollTop + m.value.clientHeight && (m.value.scrollTop = N.offsetTop - m.value.clientHeight + N.clientHeight);
      })) : D.keyCode === 38 ? (D.preventDefault(), i.value = !0, d.value = d.value === null ? O.value.length - 1 : Math.max(0, d.value - 1), kt(() => {
        const N = m.value.children[d.value];
        N.offsetTop < m.value.scrollTop && (m.value.scrollTop = N.offsetTop);
      })) : D.keyCode === 13 ? (D.preventDefault(), d.value !== null && ye(O.value[d.value]), i.value = !i.value) : (c.value += D.key, clearTimeout(u), u = setTimeout(() => {
        c.value = "";
      }, 700), kt(() => {
        const N = O.value.slice(r.preferredCountries.length).findIndex((B) => B.name.toLowerCase().startsWith(c.value));
        if (N >= 0) {
          d.value = r.preferredCountries.length + N;
          const B = m.value.children[d.value];
          (B.offsetTop < m.value.scrollTop || B.offsetTop + B.clientHeight > m.value.scrollTop + m.value.clientHeight) && (m.value.scrollTop = B.offsetTop - m.value.clientHeight / 2);
        }
      }));
    }
    function ne() {
      d.value = O.value.map((D) => D.iso2).indexOf(o.value), i.value = !1;
    }
    function G() {
      const N = window.innerHeight - p.value.getBoundingClientRect().bottom > 200;
      f.value = N ? "below" : "above";
    }
    return (D, N) => (T(), L(pe, null, [
      P("div", {
        class: X([[
          e.rootClass,
          w.value,
          D.$attrs.class,
          { "bg-fourth-nano": e.validation },
          { disabled: e.disabled }
        ], "vue3-reactive-tel-input"]),
        style: Xe([
          e.rootStyle,
          k.value
        ]),
        ref_key: "rootElement",
        ref: p
      }, [
        Be((T(), L("div", {
          class: X([["vti__dropdown", { open: i.value }], "br-solid br-black-transp br-1px radius-thin"]),
          style: Xe([e.dropdownStyle]),
          tabindex: e.dropdownOptions.tabindex,
          onKeydown: [
            Ce,
            Me(ne, ["esc"])
          ],
          onClick: _e
        }, [
          P("span", bu, [
            e.dropdownOptions.showFlags ? (T(), L("span", {
              key: 0,
              innerHTML: S.value,
              class: "mn-r-nano"
            }, null, 8, _u)) : V("", !0),
            e.dropdownOptions.showDialCodeInSelection ? (T(), L("span", Eu, " +" + W(y.value && y.value.dialCode), 1)) : V("", !0)
          ]),
          Be(P("ul", {
            ref_key: "list",
            ref: m,
            class: X(["bs-black radius-small vti__dropdown-list", f.value]),
            style: Xe([e.listStyle])
          }, [
            (T(!0), L(pe, null, De(O.value, (B, te) => (T(), L("li", {
              class: X(["flex-nowrap flex w-max", ["vti__dropdown-item", Ue(te, B.iso2)]]),
              key: B.iso2 + (B.preferred ? "-preferred" : ""),
              onClick: (he) => ye(B),
              onMousemove: (he) => d.value = te
            }, [
              e.dropdownOptions.showFlags ? (T(), L("span", {
                key: 0,
                innerHTML: B.flag,
                class: "mn-r-thin"
              }, null, 8, Cu)) : V("", !0),
              P("strong", null, W(B.name), 1),
              e.dropdownOptions.showDialCodeInList ? (T(), L("span", Tu, " +" + W(B.dialCode), 1)) : V("", !0)
            ], 42, Ou))), 128))
          ], 6), [
            [ut, i.value]
          ])
        ], 46, yu)), [
          [We(n), Fe]
        ]),
        Be(P("input", {
          "onUpdate:modelValue": N[0] || (N[0] = (B) => s.value = B),
          inputmode: "numeric",
          pattern: "\\d*",
          ref_key: "input",
          ref: g,
          type: e.inputOptions.type,
          autocomplete: e.inputOptions.autocomplete,
          autofocus: e.inputOptions.autofocus,
          class: X(["vti__input", e.inputOptions.styleClasses, e.inputClass, C.value]),
          style: Xe([e.inputStyle, M.value]),
          disabled: e.disabled,
          id: e.inputId !== "" ? e.inputId : e.inputOptions.id,
          maxlength: e.inputOptions.maxlength,
          name: e.inputId !== "" ? e.inputId : e.inputOptions.name,
          placeholder: v.value,
          readonly: e.inputOptions.readonly,
          required: e.inputOptions.required,
          tabindex: e.inputOptions.tabindex,
          onBlur: Ae,
          onFocus: tt,
          onInput: be,
          onKeyup: [
            Me(nt, ["enter"]),
            Me(Oe, ["space"])
          ]
        }, null, 46, Su), [
          [yi, s.value]
        ]),
        J(D.$slots, "default")
      ], 6),
      Q(xe, { name: "fade" }, {
        default: fe(() => [
          e.validation ? (T(), L("div", wu, " * " + W(e.validation.message), 1)) : V("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}, Lu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nu
}, Symbol.toStringTag, { value: "Module" })), Iu = { class: "pos-relative" }, Pu = {
  key: 0,
  class: "i-regular",
  width: "98",
  height: "98",
  viewBox: "0 0 98 98",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Au = {
  __name: "LocationMarker",
  props: {
    location: {
      type: Object,
      default: () => ({ lat: 15.87, lng: 100.9925 })
    },
    address: {
      type: String,
      default: null
    },
    apiKey: String,
    locale: {
      type: String,
      default: "en"
    }
  },
  emits: ["update:location", "update:address", "update:country", "update:state", "update:city"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = F(null), s = F(!1);
    let o, i;
    Qe(() => {
      new Vr({
        apiKey: n.apiKey,
        version: "weekly",
        libraries: ["places"],
        language: n.locale
      }).load().then(() => {
        o = new google.maps.Map(a.value, {
          center: n.location,
          zoom: 15,
          mapTypeControl: !1,
          fullscreenControl: !1,
          disableDefaultUI: !0
        }), i = new google.maps.Marker({
          position: n.location,
          map: o,
          draggable: !0
        }), i.addListener("dragend", (u) => {
          const f = { lat: u.latLng.lat(), lng: u.latLng.lng() };
          r("update:location", f), l(f);
        });
      }).catch((u) => {
        console.error(u);
      });
    }), lr(() => {
      n.location && i && i.setPosition(new google.maps.LatLng(n.location.lat, n.location.lng));
    }), lr(() => {
      if (n.location && o) {
        const c = new google.maps.LatLng(n.location.lat, n.location.lng);
        o.setCenter(c), o.setZoom(15);
      }
    });
    function l(c) {
      new google.maps.Geocoder().geocode({ location: c }, (f, v) => {
        if (v === "OK")
          if (f[0]) {
            r("update:address", f[0].formatted_address);
            let p = "", m = "", g = "";
            f[0].address_components.forEach((y) => {
              y.types.includes("country") && (p = y.long_name), y.types.includes("administrative_area_level_1") && (m = y.long_name), y.types.includes("locality") && (g = y.long_name);
            }), r("update:country", p), r("update:state", m), r("update:city", g);
          } else
            console.error("No results found");
        else
          console.error("Geocoder failed due to: " + v);
      });
    }
    async function d() {
      s.value = !0, navigator.geolocation ? navigator.geolocation.getCurrentPosition((c) => {
        const u = { lat: c.coords.latitude, lng: c.coords.longitude };
        r("update:location", u), l(u), s.value = !1;
      }, () => {
        console.error("Error getting location"), s.value = !1;
      }) : (console.error("Geolocation is not supported by this browser."), s.value = !1);
    }
    return (c, u) => (T(), L("div", Iu, [
      P("div", {
        ref_key: "mapContainer",
        ref: a,
        class: "w-100 h-100"
      }, null, 512),
      P("button", {
        class: "cursor-pointer flex-center flex pos-absolute pos-t-regular pos-r-regular i-semi bg-second pd-nano radius-extra",
        onClick: d
      }, [
        Q(xe, {
          name: "ScaleOut",
          mode: "out-in"
        }, {
          default: fe(() => [
            s.value ? (T(), Le($n, {
              key: 1,
              class: "pos-t-0 pos-l-0 i-small"
            })) : (T(), L("svg", Pu, u[0] || (u[0] = [
              P("path", {
                d: "M50.0004 31.4995C39.7996 31.4995 31.5 39.7991 31.5 49.9999C31.5 60.2007 39.7996 68.5003 50.0004 68.5003C60.2012 68.5003 68.5008 60.2007 68.5008 49.9999C68.5008 39.7991 60.2012 31.4995 50.0004 31.4995ZM50.0004 63.7944C42.3941 63.7944 36.2059 57.6062 36.2059 49.9999C36.2059 42.3936 42.3941 36.2054 50.0004 36.2054C57.6067 36.2054 63.7949 42.3936 63.7949 49.9999C63.7949 57.6062 57.6067 63.7944 50.0004 63.7944Z",
                fill: "rgb(var(--white))"
              }, null, -1),
              P("path", {
                d: "M97.6471 47.6471H84.56C83.3977 30.4141 69.5859 16.6024 52.3529 15.44V2.35294C52.3529 1.05255 51.2988 0 50 0C48.6996 0 47.6471 1.05255 47.6471 2.35294V15.44C30.4141 16.6024 16.6024 30.4141 15.44 47.6471H2.35294C1.05255 47.6471 0 48.6996 0 50C0 51.2988 1.05255 52.3529 2.35294 52.3529H15.44C16.6024 69.5859 30.4141 83.3977 47.6471 84.56V97.6471C47.6471 98.9459 48.6996 100 50 100C51.2988 100 52.3529 98.9459 52.3529 97.6471V84.56C69.5859 83.3977 83.3977 69.5859 84.56 52.3529H97.6471C98.9459 52.3529 100 51.2988 100 50C100 48.6996 98.9459 47.6471 97.6471 47.6471ZM50 79.9435C33.4886 79.9435 20.0565 66.5114 20.0565 50C20.0565 33.4886 33.4886 20.0565 50 20.0565C66.5098 20.0565 79.9435 33.4886 79.9435 50C79.9435 66.5098 66.5098 79.9435 50 79.9435Z",
                fill: "rgb(var(--white))"
              }, null, -1)
            ])))
          ]),
          _: 1
        })
      ])
    ]));
  }
}, ku = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Au
}, Symbol.toStringTag, { value: "Module" })), Du = {
  __name: "Map",
  props: {
    location: Object,
    apiKey: String,
    locale: String
  },
  setup(e) {
    const t = e;
    let n = F(null), r = null, a = null;
    return Qe(async () => {
      new Vr({
        apiKey: t.apiKey,
        version: "weekly",
        libraries: ["places"],
        language: t.locale
      }).load().then(() => {
        r = new google.maps.Map(n.value, {
          zoom: 13,
          center: {
            lat: t.location.lat,
            lng: t.location.lng
          }
        }), a = new google.maps.Marker({
          position: {
            lat: t.location.lat,
            lng: t.location.lng
          },
          map: r
        });
      }).catch((o) => {
        console.error(o);
      });
    }), Te(() => t.location, () => {
      r && a && (a.setPosition(new google.maps.LatLng(t.location.lat, t.location.lng)), r.setCenter(new google.maps.LatLng(t.location.lat, t.location.lng)));
    }, { deep: !0 }), (s, o) => (T(), L("div", {
      ref_key: "gmap",
      ref: n,
      class: "gmap"
    }, null, 512));
  }
}, Ru = /* @__PURE__ */ $t(Du, [["__scopeId", "data-v-786189a4"]]), Fu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ru
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * vue-router v4.4.3
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */
var ja;
(function(e) {
  e.pop = "pop", e.push = "push";
})(ja || (ja = {}));
var Ha;
(function(e) {
  e.back = "back", e.forward = "forward", e.unknown = "";
})(Ha || (Ha = {}));
Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : "");
var Ga;
(function(e) {
  e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})(Ga || (Ga = {}));
Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : "");
const Mu = Symbol(process.env.NODE_ENV !== "production" ? "router" : ""), xu = Symbol(process.env.NODE_ENV !== "production" ? "route location" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view location" : "");
function to() {
  return Mr(Mu);
}
function no(e) {
  return Mr(xu);
}
/*!
  * shared v9.14.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ot = typeof window < "u";
let rt, Ft;
if (process.env.NODE_ENV !== "production") {
  const e = Ot && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (rt = (t) => {
    e.mark(t);
  }, Ft = (t, n, r) => {
    e.measure(t, n, r), e.clearMarks(n), e.clearMarks(r);
  });
}
const Uu = /\{([0-9a-zA-Z]+)\}/g;
function zr(e, ...t) {
  return t.length === 1 && se(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Uu, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const Ct = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Bu = (e, t, n) => Vu({ l: e, k: t, s: n }), Vu = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Ve = (e) => typeof e == "number" && isFinite(e), ju = (e) => ao(e) === "[object Date]", Yt = (e) => ao(e) === "[object RegExp]", xn = (e) => Z(e) && Object.keys(e).length === 0, je = Object.assign;
let Wa;
const _t = () => Wa || (Wa = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Ka(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const Hu = Object.prototype.hasOwnProperty;
function Ln(e, t) {
  return Hu.call(e, t);
}
const we = Array.isArray, me = (e) => typeof e == "function", H = (e) => typeof e == "string", ce = (e) => typeof e == "boolean", se = (e) => e !== null && typeof e == "object", Gu = (e) => se(e) && me(e.then) && me(e.catch), ro = Object.prototype.toString, ao = (e) => ro.call(e), Z = (e) => {
  if (!se(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, Wu = (e) => e == null ? "" : we(e) || Z(e) && e.toString === ro ? JSON.stringify(e, null, 2) : String(e);
function Ku(e, t = "") {
  return e.reduce((n, r, a) => a === 0 ? n + r : n + t + r, "");
}
const Ya = 2;
function Yu(e, t = 0, n = e.length) {
  const r = e.split(/\r?\n/);
  let a = 0;
  const s = [];
  for (let o = 0; o < r.length; o++)
    if (a += r[o].length + 1, a >= t) {
      for (let i = o - Ya; i <= o + Ya || n > a; i++) {
        if (i < 0 || i >= r.length)
          continue;
        const l = i + 1;
        s.push(`${l}${" ".repeat(3 - String(l).length)}|  ${r[i]}`);
        const d = r[i].length;
        if (i === o) {
          const c = t - (a - d) + 1, u = Math.max(1, n > a ? d - c : n - t);
          s.push("   |  " + " ".repeat(c) + "^".repeat(u));
        } else if (i > o) {
          if (n > a) {
            const c = Math.max(Math.min(n - a, d), 1);
            s.push("   |  " + "^".repeat(c));
          }
          a += d + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function Un(e) {
  let t = e;
  return () => ++t;
}
function Tt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const qa = {};
function so(e) {
  qa[e] || (qa[e] = !0, Tt(e));
}
function qu() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, r) {
      const a = e.get(n);
      a && a.push(r) || e.set(n, [r]);
    },
    off(n, r) {
      const a = e.get(n);
      a && a.splice(a.indexOf(r) >>> 0, 1);
    },
    emit(n, r) {
      (e.get(n) || []).slice().map((a) => a(r)), (e.get("*") || []).slice().map((a) => a(n, r));
    }
  };
}
const _n = (e) => !se(e) || we(e);
function Cn(e, t) {
  if (_n(e) || _n(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: a } = n.pop();
    Object.keys(r).forEach((s) => {
      _n(r[s]) || _n(a[s]) ? a[s] = r[s] : n.push({ src: r[s], des: a[s] });
    });
  }
}
/*!
  * message-compiler v9.14.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function zu(e, t, n) {
  return { line: e, column: t, offset: n };
}
function In(e, t, n) {
  return { start: e, end: t };
}
const Xu = /\{([0-9a-zA-Z]+)\}/g;
function oo(e, ...t) {
  return t.length === 1 && Ju(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Xu, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const io = Object.assign, za = (e) => typeof e == "string", Ju = (e) => e !== null && typeof e == "object";
function lo(e, t = "") {
  return e.reduce((n, r, a) => a === 0 ? n + r : n + t + r, "");
}
const Bn = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, Zu = {
  [Bn.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function Qu(e, t, ...n) {
  const r = oo(Zu[e], ...n || []), a = { message: String(r), code: e };
  return t && (a.location = t), a;
}
const q = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, ec = {
  // tokenizer error messages
  [q.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [q.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [q.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [q.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [q.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [q.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [q.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [q.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [q.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [q.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [q.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [q.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [q.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [q.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [q.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [q.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function zt(e, t, n = {}) {
  const { domain: r, messages: a, args: s } = n, o = oo((a || ec)[e] || "", ...s || []), i = new SyntaxError(String(o));
  return i.code = e, t && (i.location = t), i.domain = r, i;
}
function tc(e) {
  throw e;
}
const nc = /<\/?[\w\s="/.':;#-\/]+>/, rc = (e) => nc.test(e), gt = " ", ac = "\r", Ge = `
`, sc = "\u2028", oc = "\u2029";
function ic(e) {
  const t = e;
  let n = 0, r = 1, a = 1, s = 0;
  const o = (w) => t[w] === ac && t[w + 1] === Ge, i = (w) => t[w] === Ge, l = (w) => t[w] === oc, d = (w) => t[w] === sc, c = (w) => o(w) || i(w) || l(w) || d(w), u = () => n, f = () => r, v = () => a, p = () => s, m = (w) => o(w) || l(w) || d(w) ? Ge : t[w], g = () => m(n), y = () => m(n + s);
  function S() {
    return s = 0, c(n) && (r++, a = 0), o(n) && n++, n++, a++, t[n];
  }
  function $() {
    return o(n + s) && s++, s++, t[n + s];
  }
  function E() {
    n = 0, r = 1, a = 1, s = 0;
  }
  function O(w = 0) {
    s = w;
  }
  function _() {
    const w = n + s;
    for (; w !== n; )
      S();
    s = 0;
  }
  return {
    index: u,
    line: f,
    column: v,
    peekOffset: p,
    charAt: m,
    currentChar: g,
    currentPeek: y,
    next: S,
    peek: $,
    reset: E,
    resetPeek: O,
    skipToPeek: _
  };
}
const wt = void 0, lc = ".", Xa = "'", dc = "tokenizer";
function uc(e, t = {}) {
  const n = t.location !== !1, r = ic(e), a = () => r.index(), s = () => zu(r.line(), r.column(), r.index()), o = s(), i = a(), l = {
    currentType: 14,
    offset: i,
    startLoc: o,
    endLoc: o,
    lastType: 14,
    lastOffset: i,
    lastStartLoc: o,
    lastEndLoc: o,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => l, { onError: c } = t;
  function u(h, b, R, ...K) {
    const ue = d();
    if (b.column += R, b.offset += R, c) {
      const oe = n ? In(ue.startLoc, b) : null, re = zt(h, oe, {
        domain: dc,
        args: K
      });
      c(re);
    }
  }
  function f(h, b, R) {
    h.endLoc = s(), h.currentType = b;
    const K = { type: b };
    return n && (K.loc = In(h.startLoc, h.endLoc)), R != null && (K.value = R), K;
  }
  const v = (h) => f(
    h,
    14
    /* TokenTypes.EOF */
  );
  function p(h, b) {
    return h.currentChar() === b ? (h.next(), b) : (u(q.EXPECTED_TOKEN, s(), 0, b), "");
  }
  function m(h) {
    let b = "";
    for (; h.currentPeek() === gt || h.currentPeek() === Ge; )
      b += h.currentPeek(), h.peek();
    return b;
  }
  function g(h) {
    const b = m(h);
    return h.skipToPeek(), b;
  }
  function y(h) {
    if (h === wt)
      return !1;
    const b = h.charCodeAt(0);
    return b >= 97 && b <= 122 || // a-z
    b >= 65 && b <= 90 || // A-Z
    b === 95;
  }
  function S(h) {
    if (h === wt)
      return !1;
    const b = h.charCodeAt(0);
    return b >= 48 && b <= 57;
  }
  function $(h, b) {
    const { currentType: R } = b;
    if (R !== 2)
      return !1;
    m(h);
    const K = y(h.currentPeek());
    return h.resetPeek(), K;
  }
  function E(h, b) {
    const { currentType: R } = b;
    if (R !== 2)
      return !1;
    m(h);
    const K = h.currentPeek() === "-" ? h.peek() : h.currentPeek(), ue = S(K);
    return h.resetPeek(), ue;
  }
  function O(h, b) {
    const { currentType: R } = b;
    if (R !== 2)
      return !1;
    m(h);
    const K = h.currentPeek() === Xa;
    return h.resetPeek(), K;
  }
  function _(h, b) {
    const { currentType: R } = b;
    if (R !== 8)
      return !1;
    m(h);
    const K = h.currentPeek() === ".";
    return h.resetPeek(), K;
  }
  function w(h, b) {
    const { currentType: R } = b;
    if (R !== 9)
      return !1;
    m(h);
    const K = y(h.currentPeek());
    return h.resetPeek(), K;
  }
  function k(h, b) {
    const { currentType: R } = b;
    if (!(R === 8 || R === 12))
      return !1;
    m(h);
    const K = h.currentPeek() === ":";
    return h.resetPeek(), K;
  }
  function C(h, b) {
    const { currentType: R } = b;
    if (R !== 10)
      return !1;
    const K = () => {
      const oe = h.currentPeek();
      return oe === "{" ? y(h.peek()) : oe === "@" || oe === "%" || oe === "|" || oe === ":" || oe === "." || oe === gt || !oe ? !1 : oe === Ge ? (h.peek(), K()) : j(h, !1);
    }, ue = K();
    return h.resetPeek(), ue;
  }
  function M(h) {
    m(h);
    const b = h.currentPeek() === "|";
    return h.resetPeek(), b;
  }
  function U(h) {
    const b = m(h), R = h.currentPeek() === "%" && h.peek() === "{";
    return h.resetPeek(), {
      isModulo: R,
      hasSpace: b.length > 0
    };
  }
  function j(h, b = !0) {
    const R = (ue = !1, oe = "", re = !1) => {
      const A = h.currentPeek();
      return A === "{" ? oe === "%" ? !1 : ue : A === "@" || !A ? oe === "%" ? !0 : ue : A === "%" ? (h.peek(), R(ue, "%", !0)) : A === "|" ? oe === "%" || re ? !0 : !(oe === gt || oe === Ge) : A === gt ? (h.peek(), R(!0, gt, re)) : A === Ge ? (h.peek(), R(!0, Ge, re)) : !0;
    }, K = R();
    return b && h.resetPeek(), K;
  }
  function Y(h, b) {
    const R = h.currentChar();
    return R === wt ? wt : b(R) ? (h.next(), R) : null;
  }
  function $e(h) {
    const b = h.charCodeAt(0);
    return b >= 97 && b <= 122 || // a-z
    b >= 65 && b <= 90 || // A-Z
    b >= 48 && b <= 57 || // 0-9
    b === 95 || // _
    b === 36;
  }
  function Se(h) {
    return Y(h, $e);
  }
  function de(h) {
    const b = h.charCodeAt(0);
    return b >= 97 && b <= 122 || // a-z
    b >= 65 && b <= 90 || // A-Z
    b >= 48 && b <= 57 || // 0-9
    b === 95 || // _
    b === 36 || // $
    b === 45;
  }
  function Ue(h) {
    return Y(h, de);
  }
  function ye(h) {
    const b = h.charCodeAt(0);
    return b >= 48 && b <= 57;
  }
  function Re(h) {
    return Y(h, ye);
  }
  function et(h) {
    const b = h.charCodeAt(0);
    return b >= 48 && b <= 57 || // 0-9
    b >= 65 && b <= 70 || // A-F
    b >= 97 && b <= 102;
  }
  function Ie(h) {
    return Y(h, et);
  }
  function be(h) {
    let b = "", R = "";
    for (; b = Re(h); )
      R += b;
    return R;
  }
  function Pe(h) {
    g(h);
    const b = h.currentChar();
    return b !== "%" && u(q.EXPECTED_TOKEN, s(), 0, b), h.next(), "%";
  }
  function Ae(h) {
    let b = "";
    for (; ; ) {
      const R = h.currentChar();
      if (R === "{" || R === "}" || R === "@" || R === "|" || !R)
        break;
      if (R === "%")
        if (j(h))
          b += R, h.next();
        else
          break;
      else if (R === gt || R === Ge)
        if (j(h))
          b += R, h.next();
        else {
          if (M(h))
            break;
          b += R, h.next();
        }
      else
        b += R, h.next();
    }
    return b;
  }
  function tt(h) {
    g(h);
    let b = "", R = "";
    for (; b = Ue(h); )
      R += b;
    return h.currentChar() === wt && u(q.UNTERMINATED_CLOSING_BRACE, s(), 0), R;
  }
  function nt(h) {
    g(h);
    let b = "";
    return h.currentChar() === "-" ? (h.next(), b += `-${be(h)}`) : b += be(h), h.currentChar() === wt && u(q.UNTERMINATED_CLOSING_BRACE, s(), 0), b;
  }
  function Oe(h) {
    return h !== Xa && h !== Ge;
  }
  function _e(h) {
    g(h), p(h, "'");
    let b = "", R = "";
    for (; b = Y(h, Oe); )
      b === "\\" ? R += Fe(h) : R += b;
    const K = h.currentChar();
    return K === Ge || K === wt ? (u(q.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), K === Ge && (h.next(), p(h, "'")), R) : (p(h, "'"), R);
  }
  function Fe(h) {
    const b = h.currentChar();
    switch (b) {
      case "\\":
      case "'":
        return h.next(), `\\${b}`;
      case "u":
        return Ce(h, b, 4);
      case "U":
        return Ce(h, b, 6);
      default:
        return u(q.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, b), "";
    }
  }
  function Ce(h, b, R) {
    p(h, b);
    let K = "";
    for (let ue = 0; ue < R; ue++) {
      const oe = Ie(h);
      if (!oe) {
        u(q.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${b}${K}${h.currentChar()}`);
        break;
      }
      K += oe;
    }
    return `\\${b}${K}`;
  }
  function ne(h) {
    return h !== "{" && h !== "}" && h !== gt && h !== Ge;
  }
  function G(h) {
    g(h);
    let b = "", R = "";
    for (; b = Y(h, ne); )
      R += b;
    return R;
  }
  function D(h) {
    let b = "", R = "";
    for (; b = Se(h); )
      R += b;
    return R;
  }
  function N(h) {
    const b = (R) => {
      const K = h.currentChar();
      return K === "{" || K === "%" || K === "@" || K === "|" || K === "(" || K === ")" || !K || K === gt ? R : (R += K, h.next(), b(R));
    };
    return b("");
  }
  function B(h) {
    g(h);
    const b = p(
      h,
      "|"
      /* TokenChars.Pipe */
    );
    return g(h), b;
  }
  function te(h, b) {
    let R = null;
    switch (h.currentChar()) {
      case "{":
        return b.braceNest >= 1 && u(q.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), h.next(), R = f(
          b,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), g(h), b.braceNest++, R;
      case "}":
        return b.braceNest > 0 && b.currentType === 2 && u(q.EMPTY_PLACEHOLDER, s(), 0), h.next(), R = f(
          b,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), b.braceNest--, b.braceNest > 0 && g(h), b.inLinked && b.braceNest === 0 && (b.inLinked = !1), R;
      case "@":
        return b.braceNest > 0 && u(q.UNTERMINATED_CLOSING_BRACE, s(), 0), R = he(h, b) || v(b), b.braceNest = 0, R;
      default: {
        let ue = !0, oe = !0, re = !0;
        if (M(h))
          return b.braceNest > 0 && u(q.UNTERMINATED_CLOSING_BRACE, s(), 0), R = f(b, 1, B(h)), b.braceNest = 0, b.inLinked = !1, R;
        if (b.braceNest > 0 && (b.currentType === 5 || b.currentType === 6 || b.currentType === 7))
          return u(q.UNTERMINATED_CLOSING_BRACE, s(), 0), b.braceNest = 0, Ne(h, b);
        if (ue = $(h, b))
          return R = f(b, 5, tt(h)), g(h), R;
        if (oe = E(h, b))
          return R = f(b, 6, nt(h)), g(h), R;
        if (re = O(h, b))
          return R = f(b, 7, _e(h)), g(h), R;
        if (!ue && !oe && !re)
          return R = f(b, 13, G(h)), u(q.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, R.value), g(h), R;
        break;
      }
    }
    return R;
  }
  function he(h, b) {
    const { currentType: R } = b;
    let K = null;
    const ue = h.currentChar();
    switch ((R === 8 || R === 9 || R === 12 || R === 10) && (ue === Ge || ue === gt) && u(q.INVALID_LINKED_FORMAT, s(), 0), ue) {
      case "@":
        return h.next(), K = f(
          b,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), b.inLinked = !0, K;
      case ".":
        return g(h), h.next(), f(
          b,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return g(h), h.next(), f(
          b,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return M(h) ? (K = f(b, 1, B(h)), b.braceNest = 0, b.inLinked = !1, K) : _(h, b) || k(h, b) ? (g(h), he(h, b)) : w(h, b) ? (g(h), f(b, 12, D(h))) : C(h, b) ? (g(h), ue === "{" ? te(h, b) || K : f(b, 11, N(h))) : (R === 8 && u(q.INVALID_LINKED_FORMAT, s(), 0), b.braceNest = 0, b.inLinked = !1, Ne(h, b));
    }
  }
  function Ne(h, b) {
    let R = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (b.braceNest > 0)
      return te(h, b) || v(b);
    if (b.inLinked)
      return he(h, b) || v(b);
    switch (h.currentChar()) {
      case "{":
        return te(h, b) || v(b);
      case "}":
        return u(q.UNBALANCED_CLOSING_BRACE, s(), 0), h.next(), f(
          b,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return he(h, b) || v(b);
      default: {
        if (M(h))
          return R = f(b, 1, B(h)), b.braceNest = 0, b.inLinked = !1, R;
        const { isModulo: ue, hasSpace: oe } = U(h);
        if (ue)
          return oe ? f(b, 0, Ae(h)) : f(b, 4, Pe(h));
        if (j(h))
          return f(b, 0, Ae(h));
        break;
      }
    }
    return R;
  }
  function He() {
    const { currentType: h, offset: b, startLoc: R, endLoc: K } = l;
    return l.lastType = h, l.lastOffset = b, l.lastStartLoc = R, l.lastEndLoc = K, l.offset = a(), l.startLoc = s(), r.currentChar() === wt ? f(
      l,
      14
      /* TokenTypes.EOF */
    ) : Ne(r, l);
  }
  return {
    nextToken: He,
    currentOffset: a,
    currentPosition: s,
    context: d
  };
}
const cc = "parser", fc = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function pc(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function mc(e = {}) {
  const t = e.location !== !1, { onError: n, onWarn: r } = e;
  function a($, E, O, _, ...w) {
    const k = $.currentPosition();
    if (k.offset += _, k.column += _, n) {
      const C = t ? In(O, k) : null, M = zt(E, C, {
        domain: cc,
        args: w
      });
      n(M);
    }
  }
  function s($, E, O, _, ...w) {
    const k = $.currentPosition();
    if (k.offset += _, k.column += _, r) {
      const C = t ? In(O, k) : null;
      r(Qu(E, C, w));
    }
  }
  function o($, E, O) {
    const _ = { type: $ };
    return t && (_.start = E, _.end = E, _.loc = { start: O, end: O }), _;
  }
  function i($, E, O, _) {
    t && ($.end = E, $.loc && ($.loc.end = O));
  }
  function l($, E) {
    const O = $.context(), _ = o(3, O.offset, O.startLoc);
    return _.value = E, i(_, $.currentOffset(), $.currentPosition()), _;
  }
  function d($, E) {
    const O = $.context(), { lastOffset: _, lastStartLoc: w } = O, k = o(5, _, w);
    return k.index = parseInt(E, 10), $.nextToken(), i(k, $.currentOffset(), $.currentPosition()), k;
  }
  function c($, E, O) {
    const _ = $.context(), { lastOffset: w, lastStartLoc: k } = _, C = o(4, w, k);
    return C.key = E, O === !0 && (C.modulo = !0), $.nextToken(), i(C, $.currentOffset(), $.currentPosition()), C;
  }
  function u($, E) {
    const O = $.context(), { lastOffset: _, lastStartLoc: w } = O, k = o(9, _, w);
    return k.value = E.replace(fc, pc), $.nextToken(), i(k, $.currentOffset(), $.currentPosition()), k;
  }
  function f($) {
    const E = $.nextToken(), O = $.context(), { lastOffset: _, lastStartLoc: w } = O, k = o(8, _, w);
    return E.type !== 12 ? (a($, q.UNEXPECTED_EMPTY_LINKED_MODIFIER, O.lastStartLoc, 0), k.value = "", i(k, _, w), {
      nextConsumeToken: E,
      node: k
    }) : (E.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, dt(E)), k.value = E.value || "", i(k, $.currentOffset(), $.currentPosition()), {
      node: k
    });
  }
  function v($, E) {
    const O = $.context(), _ = o(7, O.offset, O.startLoc);
    return _.value = E, i(_, $.currentOffset(), $.currentPosition()), _;
  }
  function p($) {
    const E = $.context(), O = o(6, E.offset, E.startLoc);
    let _ = $.nextToken();
    if (_.type === 9) {
      const w = f($);
      O.modifier = w.node, _ = w.nextConsumeToken || $.nextToken();
    }
    switch (_.type !== 10 && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(_)), _ = $.nextToken(), _.type === 2 && (_ = $.nextToken()), _.type) {
      case 11:
        _.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(_)), O.key = v($, _.value || "");
        break;
      case 5:
        _.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(_)), O.key = c($, _.value || "");
        break;
      case 6:
        _.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(_)), O.key = d($, _.value || "");
        break;
      case 7:
        _.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(_)), O.key = u($, _.value || "");
        break;
      default: {
        a($, q.UNEXPECTED_EMPTY_LINKED_KEY, E.lastStartLoc, 0);
        const w = $.context(), k = o(7, w.offset, w.startLoc);
        return k.value = "", i(k, w.offset, w.startLoc), O.key = k, i(O, w.offset, w.startLoc), {
          nextConsumeToken: _,
          node: O
        };
      }
    }
    return i(O, $.currentOffset(), $.currentPosition()), {
      node: O
    };
  }
  function m($) {
    const E = $.context(), O = E.currentType === 1 ? $.currentOffset() : E.offset, _ = E.currentType === 1 ? E.endLoc : E.startLoc, w = o(2, O, _);
    w.items = [];
    let k = null, C = null;
    do {
      const j = k || $.nextToken();
      switch (k = null, j.type) {
        case 0:
          j.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(j)), w.items.push(l($, j.value || ""));
          break;
        case 6:
          j.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(j)), w.items.push(d($, j.value || ""));
          break;
        case 4:
          C = !0;
          break;
        case 5:
          j.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(j)), w.items.push(c($, j.value || "", !!C)), C && (s($, Bn.USE_MODULO_SYNTAX, E.lastStartLoc, 0, dt(j)), C = null);
          break;
        case 7:
          j.value == null && a($, q.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, dt(j)), w.items.push(u($, j.value || ""));
          break;
        case 8: {
          const Y = p($);
          w.items.push(Y.node), k = Y.nextConsumeToken || null;
          break;
        }
      }
    } while (E.currentType !== 14 && E.currentType !== 1);
    const M = E.currentType === 1 ? E.lastOffset : $.currentOffset(), U = E.currentType === 1 ? E.lastEndLoc : $.currentPosition();
    return i(w, M, U), w;
  }
  function g($, E, O, _) {
    const w = $.context();
    let k = _.items.length === 0;
    const C = o(1, E, O);
    C.cases = [], C.cases.push(_);
    do {
      const M = m($);
      k || (k = M.items.length === 0), C.cases.push(M);
    } while (w.currentType !== 14);
    return k && a($, q.MUST_HAVE_MESSAGES_IN_PLURAL, O, 0), i(C, $.currentOffset(), $.currentPosition()), C;
  }
  function y($) {
    const E = $.context(), { offset: O, startLoc: _ } = E, w = m($);
    return E.currentType === 14 ? w : g($, O, _, w);
  }
  function S($) {
    const E = uc($, io({}, e)), O = E.context(), _ = o(0, O.offset, O.startLoc);
    return t && _.loc && (_.loc.source = $), _.body = y(E), e.onCacheKey && (_.cacheKey = e.onCacheKey($)), O.currentType !== 14 && a(E, q.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, $[O.offset] || ""), i(_, E.currentOffset(), E.currentPosition()), _;
  }
  return { parse: S };
}
function dt(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function hc(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (s) => (n.helpers.add(s), s) };
}
function Ja(e, t) {
  for (let n = 0; n < e.length; n++)
    Xr(e[n], t);
}
function Xr(e, t) {
  switch (e.type) {
    case 1:
      Ja(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Ja(e.items, t);
      break;
    case 6: {
      Xr(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function $c(e, t = {}) {
  const n = hc(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Xr(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function gc(e) {
  const t = e.body;
  return t.type === 2 ? Za(t) : t.cases.forEach((n) => Za(n)), e;
}
function Za(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = lo(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const vc = "minifier";
function Ht(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Ht(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let r = 0; r < n.length; r++)
        Ht(n[r]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let r = 0; r < n.length; r++)
        Ht(n[r]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Ht(t.key), t.k = t.key, delete t.key, t.modifier && (Ht(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      throw zt(q.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: vc,
        args: [e.type]
      });
  }
  delete e.type;
}
const yc = "parser";
function bc(e, t) {
  const { sourceMap: n, filename: r, breakLineCode: a, needIndent: s } = t, o = t.location !== !1, i = {
    filename: r,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: s,
    indentLevel: 0
  };
  o && e.loc && (i.source = e.loc.source);
  const l = () => i;
  function d(g, y) {
    i.code += g;
  }
  function c(g, y = !0) {
    const S = y ? a : "";
    d(s ? S + "  ".repeat(g) : S);
  }
  function u(g = !0) {
    const y = ++i.indentLevel;
    g && c(y);
  }
  function f(g = !0) {
    const y = --i.indentLevel;
    g && c(y);
  }
  function v() {
    c(i.indentLevel);
  }
  return {
    context: l,
    push: d,
    indent: u,
    deindent: f,
    newline: v,
    helper: (g) => `_${g}`,
    needIndent: () => i.needIndent
  };
}
function _c(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), qt(e, t.key), t.modifier ? (e.push(", "), qt(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Ec(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const a = t.items.length;
  for (let s = 0; s < a && (qt(e, t.items[s]), s !== a - 1); s++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function Oc(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const a = t.cases.length;
    for (let s = 0; s < a && (qt(e, t.cases[s]), s !== a - 1); s++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function Cc(e, t) {
  t.body ? qt(e, t.body) : e.push("null");
}
function qt(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Cc(e, t);
      break;
    case 1:
      Oc(e, t);
      break;
    case 2:
      Ec(e, t);
      break;
    case 6:
      _c(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw zt(q.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: yc,
        args: [t.type]
      });
  }
}
const Tc = (e, t = {}) => {
  const n = za(t.mode) ? t.mode : "normal", r = za(t.filename) ? t.filename : "message.intl", a = !!t.sourceMap, s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : n !== "arrow", i = e.helpers || [], l = bc(e, {
    mode: n,
    filename: r,
    sourceMap: a,
    breakLineCode: s,
    needIndent: o
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(o), i.length > 0 && (l.push(`const { ${lo(i.map((u) => `${u}: _${u}`), ", ")} } = ctx`), l.newline()), l.push("return "), qt(l, e), l.deindent(o), l.push("}"), delete e.helpers;
  const { code: d, map: c } = l.context();
  return {
    ast: e,
    code: d,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Sc(e, t = {}) {
  const n = io({}, t), r = !!n.jit, a = !!n.minify, s = n.optimize == null ? !0 : n.optimize, i = mc(n).parse(e);
  return r ? (s && gc(i), a && Ht(i), { ast: i, code: "" }) : ($c(i, n), Tc(i, n));
}
/*!
  * core-base v9.14.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function wc() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (_t().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (_t().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (_t().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const It = [];
It[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
It[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
It[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
It[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
It[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
It[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
It[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Nc = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Lc(e) {
  return Nc.test(e);
}
function Ic(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Pc(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Ac(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Lc(t) ? Ic(t) : "*" + t;
}
function kc(e) {
  const t = [];
  let n = -1, r = 0, a = 0, s, o, i, l, d, c, u;
  const f = [];
  f[
    0
    /* Actions.APPEND */
  ] = () => {
    o === void 0 ? o = i : o += i;
  }, f[
    1
    /* Actions.PUSH */
  ] = () => {
    o !== void 0 && (t.push(o), o = void 0);
  }, f[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    f[
      0
      /* Actions.APPEND */
    ](), a++;
  }, f[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (a > 0)
      a--, r = 4, f[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (a = 0, o === void 0 || (o = Ac(o), o === !1))
        return !1;
      f[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function v() {
    const p = e[n + 1];
    if (r === 5 && p === "'" || r === 6 && p === '"')
      return n++, i = "\\" + p, f[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, s = e[n], !(s === "\\" && v())) {
      if (l = Pc(s), u = It[r], d = u[l] || u.l || 8, d === 8 || (r = d[0], d[1] !== void 0 && (c = f[d[1]], c && (i = s, c() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const Qa = /* @__PURE__ */ new Map();
function Dc(e, t) {
  return se(e) ? e[t] : null;
}
function Rc(e, t) {
  if (!se(e))
    return null;
  let n = Qa.get(t);
  if (n || (n = kc(t), n && Qa.set(t, n)), !n)
    return null;
  const r = n.length;
  let a = e, s = 0;
  for (; s < r; ) {
    const o = a[n[s]];
    if (o === void 0 || me(a))
      return null;
    a = o, s++;
  }
  return a;
}
const Fc = (e) => e, Mc = (e) => "", xc = "text", Uc = (e) => e.length === 0 ? "" : Ku(e), Bc = Wu;
function es(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Vc(e) {
  const t = Ve(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Ve(e.named.count) || Ve(e.named.n)) ? Ve(e.named.count) ? e.named.count : Ve(e.named.n) ? e.named.n : t : t;
}
function jc(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Hc(e = {}) {
  const t = e.locale, n = Vc(e), r = se(e.pluralRules) && H(t) && me(e.pluralRules[t]) ? e.pluralRules[t] : es, a = se(e.pluralRules) && H(t) && me(e.pluralRules[t]) ? es : void 0, s = (y) => y[r(n, y.length, a)], o = e.list || [], i = (y) => o[y], l = e.named || {};
  Ve(e.pluralIndex) && jc(n, l);
  const d = (y) => l[y];
  function c(y) {
    const S = me(e.messages) ? e.messages(y) : se(e.messages) ? e.messages[y] : !1;
    return S || (e.parent ? e.parent.message(y) : Mc);
  }
  const u = (y) => e.modifiers ? e.modifiers[y] : Fc, f = Z(e.processor) && me(e.processor.normalize) ? e.processor.normalize : Uc, v = Z(e.processor) && me(e.processor.interpolate) ? e.processor.interpolate : Bc, p = Z(e.processor) && H(e.processor.type) ? e.processor.type : xc, g = {
    list: i,
    named: d,
    plural: s,
    linked: (y, ...S) => {
      const [$, E] = S;
      let O = "text", _ = "";
      S.length === 1 ? se($) ? (_ = $.modifier || _, O = $.type || O) : H($) && (_ = $ || _) : S.length === 2 && (H($) && (_ = $ || _), H(E) && (O = E || O));
      const w = c(y)(g), k = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        O === "vnode" && we(w) && _ ? w[0] : w
      );
      return _ ? u(_)(k, O) : k;
    },
    message: c,
    type: p,
    interpolate: v,
    normalize: f,
    values: je({}, o, l)
  };
  return g;
}
let dn = null;
function Gc(e) {
  dn = e;
}
function Wc(e, t, n) {
  dn && dn.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Kc = /* @__PURE__ */ Yc(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function Yc(e) {
  return (t) => dn && dn.emit(e, t);
}
const uo = Bn.__EXTEND_POINT__, Pt = Un(uo), Ke = {
  NOT_FOUND_KEY: uo,
  // 2
  FALLBACK_TO_TRANSLATE: Pt(),
  // 3
  CANNOT_FORMAT_NUMBER: Pt(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: Pt(),
  // 5
  CANNOT_FORMAT_DATE: Pt(),
  // 6
  FALLBACK_TO_DATE_FORMAT: Pt(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: Pt(),
  // 8
  __EXTEND_POINT__: Pt()
  // 9
}, qc = {
  [Ke.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Ke.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Ke.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Ke.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Ke.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Ke.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Ke.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Mt(e, ...t) {
  return zr(qc[e], ...t);
}
const co = q.__EXTEND_POINT__, At = Un(co), ke = {
  INVALID_ARGUMENT: co,
  // 17
  INVALID_DATE_ARGUMENT: At(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: At(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: At(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: At(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: At(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: At(),
  // 23
  __EXTEND_POINT__: At()
  // 24
};
function ht(e) {
  return zt(e, null, process.env.NODE_ENV !== "production" ? { messages: zc } : void 0);
}
const zc = {
  [ke.INVALID_ARGUMENT]: "Invalid arguments",
  [ke.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [ke.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [ke.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [ke.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [ke.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [ke.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Jr(e, t) {
  return t.locale != null ? ts(t.locale) : ts(e.locale);
}
let er;
function ts(e) {
  if (H(e))
    return e;
  if (me(e)) {
    if (e.resolvedOnce && er != null)
      return er;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Gu(t))
        throw ht(ke.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return er = t;
    } else
      throw ht(ke.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw ht(ke.NOT_SUPPORT_LOCALE_TYPE);
}
function Xc(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...we(t) ? t : se(t) ? Object.keys(t) : H(t) ? [t] : [n]
  ])];
}
function fo(e, t, n) {
  const r = H(n) ? n : un, a = e;
  a.__localeChainCache || (a.__localeChainCache = /* @__PURE__ */ new Map());
  let s = a.__localeChainCache.get(r);
  if (!s) {
    s = [];
    let o = [n];
    for (; we(o); )
      o = ns(s, o, t);
    const i = we(t) || !Z(t) ? t : t.default ? t.default : null;
    o = H(i) ? [i] : i, we(o) && ns(s, o, !1), a.__localeChainCache.set(r, s);
  }
  return s;
}
function ns(e, t, n) {
  let r = !0;
  for (let a = 0; a < t.length && ce(r); a++) {
    const s = t[a];
    H(s) && (r = Jc(e, t[a], n));
  }
  return r;
}
function Jc(e, t, n) {
  let r;
  const a = t.split("-");
  do {
    const s = a.join("-");
    r = Zc(e, s, n), a.splice(-1, 1);
  } while (a.length && r === !0);
  return r;
}
function Zc(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const a = t.replace(/!/g, "");
    e.push(a), (we(n) || Z(n)) && n[a] && (r = n[a]);
  }
  return r;
}
const Qc = "9.14.0", Vn = -1, un = "en-US", Pn = "", rs = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function e0() {
  return {
    upper: (e, t) => t === "text" && H(e) ? e.toUpperCase() : t === "vnode" && se(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && H(e) ? e.toLowerCase() : t === "vnode" && se(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && H(e) ? rs(e) : t === "vnode" && se(e) && "__v_isVNode" in e ? rs(e.children) : e
  };
}
let po;
function as(e) {
  po = e;
}
let mo;
function t0(e) {
  mo = e;
}
let ho;
function n0(e) {
  ho = e;
}
let $o = null;
const r0 = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  $o = e;
}, a0 = /* @__NO_SIDE_EFFECTS__ */ () => $o;
let go = null;
const ss = (e) => {
  go = e;
}, s0 = () => go;
let os = 0;
function o0(e = {}) {
  const t = me(e.onWarn) ? e.onWarn : Tt, n = H(e.version) ? e.version : Qc, r = H(e.locale) || me(e.locale) ? e.locale : un, a = me(r) ? un : r, s = we(e.fallbackLocale) || Z(e.fallbackLocale) || H(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : a, o = Z(e.messages) ? e.messages : { [a]: {} }, i = Z(e.datetimeFormats) ? e.datetimeFormats : { [a]: {} }, l = Z(e.numberFormats) ? e.numberFormats : { [a]: {} }, d = je({}, e.modifiers || {}, e0()), c = e.pluralRules || {}, u = me(e.missing) ? e.missing : null, f = ce(e.missingWarn) || Yt(e.missingWarn) ? e.missingWarn : !0, v = ce(e.fallbackWarn) || Yt(e.fallbackWarn) ? e.fallbackWarn : !0, p = !!e.fallbackFormat, m = !!e.unresolving, g = me(e.postTranslation) ? e.postTranslation : null, y = Z(e.processor) ? e.processor : null, S = ce(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, $ = !!e.escapeParameter, E = me(e.messageCompiler) ? e.messageCompiler : po;
  process.env.NODE_ENV !== "production" && me(e.messageCompiler) && so(Mt(Ke.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const O = me(e.messageResolver) ? e.messageResolver : mo || Dc, _ = me(e.localeFallbacker) ? e.localeFallbacker : ho || Xc, w = se(e.fallbackContext) ? e.fallbackContext : void 0, k = e, C = se(k.__datetimeFormatters) ? k.__datetimeFormatters : /* @__PURE__ */ new Map(), M = se(k.__numberFormatters) ? k.__numberFormatters : /* @__PURE__ */ new Map(), U = se(k.__meta) ? k.__meta : {};
  os++;
  const j = {
    version: n,
    cid: os,
    locale: r,
    fallbackLocale: s,
    messages: o,
    modifiers: d,
    pluralRules: c,
    missing: u,
    missingWarn: f,
    fallbackWarn: v,
    fallbackFormat: p,
    unresolving: m,
    postTranslation: g,
    processor: y,
    warnHtmlMessage: S,
    escapeParameter: $,
    messageCompiler: E,
    messageResolver: O,
    localeFallbacker: _,
    fallbackContext: w,
    onWarn: t,
    __meta: U
  };
  return j.datetimeFormats = i, j.numberFormats = l, j.__datetimeFormatters = C, j.__numberFormatters = M, process.env.NODE_ENV !== "production" && (j.__v_emitter = k.__v_emitter != null ? k.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Wc(j, n, U), j;
}
function jn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function vo(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Zr(e, t, n, r, a) {
  const { missing: s, onWarn: o } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: a,
      groupId: `${a}:${t}`
    });
  }
  if (s !== null) {
    const i = s(e, n, t, a);
    return H(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && vo(r, t) && o(Mt(Ke.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Qt(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function yo(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function i0(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (yo(e, t[r]))
      return !0;
  return !1;
}
function tr(e) {
  return (n) => l0(n, e);
}
function l0(e, t) {
  const n = t.b || t.body;
  if ((n.t || n.type) === 1) {
    const r = n, a = r.c || r.cases;
    return e.plural(a.reduce((s, o) => [
      ...s,
      is(e, o)
    ], []));
  } else
    return is(e, n);
}
function is(e, t) {
  const n = t.s || t.static;
  if (n)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = (t.i || t.items).reduce((a, s) => [...a, gr(e, s)], []);
    return e.normalize(r);
  }
}
function gr(e, t) {
  const n = t.t || t.type;
  switch (n) {
    case 3: {
      const r = t;
      return r.v || r.value;
    }
    case 9: {
      const r = t;
      return r.v || r.value;
    }
    case 4: {
      const r = t;
      return e.interpolate(e.named(r.k || r.key));
    }
    case 5: {
      const r = t;
      return e.interpolate(e.list(r.i != null ? r.i : r.index));
    }
    case 6: {
      const r = t, a = r.m || r.modifier;
      return e.linked(gr(e, r.k || r.key), a ? gr(e, a) : void 0, e.type);
    }
    case 7: {
      const r = t;
      return r.v || r.value;
    }
    case 8: {
      const r = t;
      return r.v || r.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const d0 = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function bo(e, t) {
  t && rc(e) && Tt(zr(d0, { source: e }));
}
const _o = (e) => e;
let Wt = /* @__PURE__ */ Object.create(null);
function Eo(e) {
  e.code === Bn.USE_MODULO_SYNTAX && Tt(`The use of named interpolation with modulo syntax is deprecated. It will be removed in v10.
reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format 
(message compiler warning message: ${e.message})`);
}
const xt = (e) => se(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function Oo(e, t = {}) {
  let n = !1;
  const r = t.onError || tc;
  return t.onError = (a) => {
    n = !0, r(a);
  }, { ...Sc(e, t), detectError: n };
}
const u0 = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!H(e))
    throw ht(ke.NOT_SUPPORT_NON_STRING_MESSAGE);
  process.env.NODE_ENV !== "production" && (t.onWarn = Eo);
  {
    const n = ce(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && bo(e, n);
    const a = (t.onCacheKey || _o)(e), s = Wt[a];
    if (s)
      return s;
    const { code: o, detectError: i } = Oo(e, t), l = new Function(`return ${o}`)();
    return i ? l : Wt[a] = l;
  }
};
function c0(e, t) {
  if (process.env.NODE_ENV !== "production" && (t.onWarn = Eo), __INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && H(e)) {
    const n = ce(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && bo(e, n);
    const a = (t.onCacheKey || _o)(e), s = Wt[a];
    if (s)
      return s;
    const { ast: o, detectError: i } = Oo(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = tr(o);
    return i ? l : Wt[a] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !xt(e))
      return Tt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const r = Wt[n];
      return r || (Wt[n] = tr(e));
    } else
      return tr(e);
  }
}
const ls = () => "", ot = (e) => me(e);
function ds(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: a, messageCompiler: s, fallbackLocale: o, messages: i } = e, [l, d] = vr(...t), c = ce(d.missingWarn) ? d.missingWarn : e.missingWarn, u = ce(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, f = ce(d.escapeParameter) ? d.escapeParameter : e.escapeParameter, v = !!d.resolvedMessage, p = H(d.default) || ce(d.default) ? ce(d.default) ? s ? l : () => l : d.default : n ? s ? l : () => l : "", m = n || p !== "", g = Jr(e, d);
  f && f0(d);
  let [y, S, $] = v ? [
    l,
    g,
    i[g] || {}
  ] : Co(e, l, g, o, u, c), E = y, O = l;
  if (!v && !(H(E) || xt(E) || ot(E)) && m && (E = p, O = E), !v && (!(H(E) || xt(E) || ot(E)) || !H(S)))
    return a ? Vn : l;
  if (process.env.NODE_ENV !== "production" && H(E) && e.messageCompiler == null)
    return Tt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let _ = !1;
  const w = () => {
    _ = !0;
  }, k = ot(E) ? E : To(e, l, S, E, O, w);
  if (_)
    return E;
  const C = $0(e, S, $, d), M = Hc(C), U = p0(e, k, M), j = r ? r(U, l) : U;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const Y = {
      timestamp: Date.now(),
      key: H(l) ? l : ot(E) ? E.key : "",
      locale: S || (ot(E) ? E.locale : ""),
      format: H(E) ? E : ot(E) ? E.source : "",
      message: j
    };
    Y.meta = je({}, e.__meta, /* @__PURE__ */ a0() || {}), Kc(Y);
  }
  return j;
}
function f0(e) {
  we(e.list) ? e.list = e.list.map((t) => H(t) ? Ka(t) : t) : se(e.named) && Object.keys(e.named).forEach((t) => {
    H(e.named[t]) && (e.named[t] = Ka(e.named[t]));
  });
}
function Co(e, t, n, r, a, s) {
  const { messages: o, onWarn: i, messageResolver: l, localeFallbacker: d } = e, c = d(e, r, n);
  let u = {}, f, v = null, p = n, m = null;
  const g = "translate";
  for (let y = 0; y < c.length; y++) {
    if (f = m = c[y], process.env.NODE_ENV !== "production" && n !== f && !yo(n, f) && jn(a, t) && i(Mt(Ke.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: f
    })), process.env.NODE_ENV !== "production" && n !== f) {
      const O = e.__v_emitter;
      O && O.emit("fallback", {
        type: g,
        key: t,
        from: p,
        to: m,
        groupId: `${g}:${t}`
      });
    }
    u = o[f] || {};
    let S = null, $, E;
    if (process.env.NODE_ENV !== "production" && Ot && (S = window.performance.now(), $ = "intlify-message-resolve-start", E = "intlify-message-resolve-end", rt && rt($)), (v = l(u, t)) === null && (v = u[t]), process.env.NODE_ENV !== "production" && Ot) {
      const O = window.performance.now(), _ = e.__v_emitter;
      _ && S && v && _.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: v,
        time: O - S,
        groupId: `${g}:${t}`
      }), $ && E && rt && Ft && (rt(E), Ft("intlify message resolve", $, E));
    }
    if (H(v) || xt(v) || ot(v))
      break;
    if (!i0(f, c)) {
      const O = Zr(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        f,
        s,
        g
      );
      O !== t && (v = O);
    }
    p = m;
  }
  return [v, f, u];
}
function To(e, t, n, r, a, s) {
  const { messageCompiler: o, warnHtmlMessage: i } = e;
  if (ot(r)) {
    const f = r;
    return f.locale = f.locale || n, f.key = f.key || t, f;
  }
  if (o == null) {
    const f = () => r;
    return f.locale = n, f.key = t, f;
  }
  let l = null, d, c;
  process.env.NODE_ENV !== "production" && Ot && (l = window.performance.now(), d = "intlify-message-compilation-start", c = "intlify-message-compilation-end", rt && rt(d));
  const u = o(r, m0(e, n, a, r, i, s));
  if (process.env.NODE_ENV !== "production" && Ot) {
    const f = window.performance.now(), v = e.__v_emitter;
    v && l && v.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: f - l,
      groupId: `translate:${t}`
    }), d && c && rt && Ft && (rt(c), Ft("intlify message compilation", d, c));
  }
  return u.locale = n, u.key = t, u.source = r, u;
}
function p0(e, t, n) {
  let r = null, a, s;
  process.env.NODE_ENV !== "production" && Ot && (r = window.performance.now(), a = "intlify-message-evaluation-start", s = "intlify-message-evaluation-end", rt && rt(a));
  const o = t(n);
  if (process.env.NODE_ENV !== "production" && Ot) {
    const i = window.performance.now(), l = e.__v_emitter;
    l && r && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: o,
      time: i - r,
      groupId: `translate:${t.key}`
    }), a && s && rt && Ft && (rt(s), Ft("intlify message evaluation", a, s));
  }
  return o;
}
function vr(...e) {
  const [t, n, r] = e, a = {};
  if (!H(t) && !Ve(t) && !ot(t) && !xt(t))
    throw ht(ke.INVALID_ARGUMENT);
  const s = Ve(t) ? String(t) : (ot(t), t);
  return Ve(n) ? a.plural = n : H(n) ? a.default = n : Z(n) && !xn(n) ? a.named = n : we(n) && (a.list = n), Ve(r) ? a.plural = r : H(r) ? a.default = r : Z(r) && je(a, r), [s, a];
}
function m0(e, t, n, r, a, s) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: a,
    onError: (o) => {
      if (s && s(o), process.env.NODE_ENV !== "production") {
        const i = h0(r), l = `Message compilation error: ${o.message}`, d = o.location && i && Yu(i, o.location.start.offset, o.location.end.offset), c = e.__v_emitter;
        c && i && c.emit("compile-error", {
          message: i,
          error: o.message,
          start: o.location && o.location.start.offset,
          end: o.location && o.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(d ? `${l}
${d}` : l);
      } else
        throw o;
    },
    onCacheKey: (o) => Bu(t, n, o)
  };
}
function h0(e) {
  if (H(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function $0(e, t, n, r) {
  const { modifiers: a, pluralRules: s, messageResolver: o, fallbackLocale: i, fallbackWarn: l, missingWarn: d, fallbackContext: c } = e, f = {
    locale: t,
    modifiers: a,
    pluralRules: s,
    messages: (v) => {
      let p = o(n, v);
      if (p == null && c) {
        const [, , m] = Co(c, v, t, i, l, d);
        p = o(m, v);
      }
      if (H(p) || xt(p)) {
        let m = !1;
        const y = To(e, v, t, p, v, () => {
          m = !0;
        });
        return m ? ls : y;
      } else return ot(p) ? p : ls;
    }
  };
  return e.processor && (f.processor = e.processor), r.list && (f.list = r.list), r.named && (f.named = r.named), Ve(r.plural) && (f.pluralIndex = r.plural), f;
}
const us = typeof Intl < "u", So = {
  dateTimeFormat: us && typeof Intl.DateTimeFormat < "u",
  numberFormat: us && typeof Intl.NumberFormat < "u"
};
function cs(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: a, onWarn: s, localeFallbacker: o } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !So.dateTimeFormat)
    return s(Mt(Ke.CANNOT_FORMAT_DATE)), Pn;
  const [l, d, c, u] = yr(...t), f = ce(c.missingWarn) ? c.missingWarn : e.missingWarn, v = ce(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, p = !!c.part, m = Jr(e, c), g = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    m
  );
  if (!H(l) || l === "")
    return new Intl.DateTimeFormat(m, u).format(d);
  let y = {}, S, $ = null, E = m, O = null;
  const _ = "datetime format";
  for (let C = 0; C < g.length; C++) {
    if (S = O = g[C], process.env.NODE_ENV !== "production" && m !== S && jn(v, l) && s(Mt(Ke.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: S
    })), process.env.NODE_ENV !== "production" && m !== S) {
      const M = e.__v_emitter;
      M && M.emit("fallback", {
        type: _,
        key: l,
        from: E,
        to: O,
        groupId: `${_}:${l}`
      });
    }
    if (y = n[S] || {}, $ = y[l], Z($))
      break;
    Zr(e, l, S, f, _), E = O;
  }
  if (!Z($) || !H(S))
    return r ? Vn : l;
  let w = `${S}__${l}`;
  xn(u) || (w = `${w}__${JSON.stringify(u)}`);
  let k = i.get(w);
  return k || (k = new Intl.DateTimeFormat(S, je({}, $, u)), i.set(w, k)), p ? k.formatToParts(d) : k.format(d);
}
const wo = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function yr(...e) {
  const [t, n, r, a] = e, s = {};
  let o = {}, i;
  if (H(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw ht(ke.INVALID_ISO_DATE_ARGUMENT);
    const d = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    i = new Date(d);
    try {
      i.toISOString();
    } catch {
      throw ht(ke.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ju(t)) {
    if (isNaN(t.getTime()))
      throw ht(ke.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (Ve(t))
    i = t;
  else
    throw ht(ke.INVALID_ARGUMENT);
  return H(n) ? s.key = n : Z(n) && Object.keys(n).forEach((l) => {
    wo.includes(l) ? o[l] = n[l] : s[l] = n[l];
  }), H(r) ? s.locale = r : Z(r) && (o = r), Z(a) && (o = a), [s.key || "", i, s, o];
}
function fs(e, t, n) {
  const r = e;
  for (const a in n) {
    const s = `${t}__${a}`;
    r.__datetimeFormatters.has(s) && r.__datetimeFormatters.delete(s);
  }
}
function ps(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: a, onWarn: s, localeFallbacker: o } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !So.numberFormat)
    return s(Mt(Ke.CANNOT_FORMAT_NUMBER)), Pn;
  const [l, d, c, u] = br(...t), f = ce(c.missingWarn) ? c.missingWarn : e.missingWarn, v = ce(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, p = !!c.part, m = Jr(e, c), g = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    m
  );
  if (!H(l) || l === "")
    return new Intl.NumberFormat(m, u).format(d);
  let y = {}, S, $ = null, E = m, O = null;
  const _ = "number format";
  for (let C = 0; C < g.length; C++) {
    if (S = O = g[C], process.env.NODE_ENV !== "production" && m !== S && jn(v, l) && s(Mt(Ke.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: S
    })), process.env.NODE_ENV !== "production" && m !== S) {
      const M = e.__v_emitter;
      M && M.emit("fallback", {
        type: _,
        key: l,
        from: E,
        to: O,
        groupId: `${_}:${l}`
      });
    }
    if (y = n[S] || {}, $ = y[l], Z($))
      break;
    Zr(e, l, S, f, _), E = O;
  }
  if (!Z($) || !H(S))
    return r ? Vn : l;
  let w = `${S}__${l}`;
  xn(u) || (w = `${w}__${JSON.stringify(u)}`);
  let k = i.get(w);
  return k || (k = new Intl.NumberFormat(S, je({}, $, u)), i.set(w, k)), p ? k.formatToParts(d) : k.format(d);
}
const No = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function br(...e) {
  const [t, n, r, a] = e, s = {};
  let o = {};
  if (!Ve(t))
    throw ht(ke.INVALID_ARGUMENT);
  const i = t;
  return H(n) ? s.key = n : Z(n) && Object.keys(n).forEach((l) => {
    No.includes(l) ? o[l] = n[l] : s[l] = n[l];
  }), H(r) ? s.locale = r : Z(r) && (o = r), Z(a) && (o = a), [s.key || "", i, s, o];
}
function ms(e, t, n) {
  const r = e;
  for (const a in n) {
    const s = `${t}__${a}`;
    r.__numberFormatters.has(s) && r.__numberFormatters.delete(s);
  }
}
wc();
/*!
  * vue-i18n v9.14.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const g0 = "9.14.0";
function v0() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (_t().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (_t().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (_t().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (_t().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (_t().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Lo = Ke.__EXTEND_POINT__, vt = Un(Lo), ze = {
  FALLBACK_TO_ROOT: Lo,
  // 9
  NOT_SUPPORTED_PRESERVE: vt(),
  // 10
  NOT_SUPPORTED_FORMATTER: vt(),
  // 11
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: vt(),
  // 12
  NOT_SUPPORTED_GET_CHOICE_INDEX: vt(),
  // 13
  COMPONENT_NAME_LEGACY_COMPATIBLE: vt(),
  // 14
  NOT_FOUND_PARENT_SCOPE: vt(),
  // 15
  IGNORE_OBJ_FLATTEN: vt(),
  // 16
  NOTICE_DROP_ALLOW_COMPOSITION: vt(),
  // 17
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: vt()
  // 18
}, y0 = {
  [ze.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [ze.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [ze.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [ze.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [ze.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [ze.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [ze.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [ze.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [ze.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze",
  [ze.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: "'translateExistCompatible' option will be dropped in the next major version."
};
function An(e, ...t) {
  return zr(y0[e], ...t);
}
const Io = ke.__EXTEND_POINT__, qe = Un(Io), ge = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Io,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: qe(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: qe(),
  // 26
  NOT_INSTALLED: qe(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: qe(),
  // 28
  // directive module errors
  REQUIRED_VALUE: qe(),
  // 29
  INVALID_VALUE: qe(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: qe(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: qe(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: qe(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: qe(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: qe(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: qe(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: qe(),
  // 37
  // for enhancement
  __EXTEND_POINT__: qe()
  // 38
};
function Lt(e, ...t) {
  return zt(e, null, process.env.NODE_ENV !== "production" ? { messages: b0, args: t } : void 0);
}
const b0 = {
  [ge.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ge.INVALID_ARGUMENT]: "Invalid argument",
  [ge.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ge.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ge.UNEXPECTED_ERROR]: "Unexpected error",
  [ge.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [ge.REQUIRED_VALUE]: "Required in value: {0}",
  [ge.INVALID_VALUE]: "Invalid value",
  [ge.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ge.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ge.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ge.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [ge.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [ge.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, _r = /* @__PURE__ */ Ct("__translateVNode"), Er = /* @__PURE__ */ Ct("__datetimeParts"), Or = /* @__PURE__ */ Ct("__numberParts"), Cr = /* @__PURE__ */ Ct("__enableEmitter"), Tr = /* @__PURE__ */ Ct("__disableEmitter"), _0 = Ct("__setPluralRules"), Po = /* @__PURE__ */ Ct("__injectWithOption"), Sr = /* @__PURE__ */ Ct("__dispose");
function cn(e) {
  if (!se(e))
    return e;
  for (const t in e)
    if (Ln(e, t))
      if (!t.includes("."))
        se(e[t]) && cn(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let a = e, s = !1;
        for (let o = 0; o < r; o++) {
          if (n[o] in a || (a[n[o]] = {}), !se(a[n[o]])) {
            process.env.NODE_ENV !== "production" && Tt(An(ze.IGNORE_OBJ_FLATTEN, {
              key: n[o]
            })), s = !0;
            break;
          }
          a = a[n[o]];
        }
        s || (a[n[r]] = e[t], delete e[t]), se(a[n[r]]) && cn(a[n[r]]);
      }
  return e;
}
function Qr(e, t) {
  const { messages: n, __i18n: r, messageResolver: a, flatJson: s } = t, o = Z(n) ? n : we(r) ? {} : { [e]: {} };
  if (we(r) && r.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: l, resource: d } = i;
      l ? (o[l] = o[l] || {}, Cn(d, o[l])) : Cn(d, o);
    } else
      H(i) && Cn(JSON.parse(i), o);
  }), a == null && s)
    for (const i in o)
      Ln(o, i) && cn(o[i]);
  return o;
}
function Ao(e) {
  return e.type;
}
function E0(e, t, n) {
  let r = se(t.messages) ? t.messages : {};
  "__i18nGlobal" in n && (r = Qr(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const a = Object.keys(r);
  a.length && a.forEach((s) => {
    e.mergeLocaleMessage(s, r[s]);
  });
  {
    if (se(t.datetimeFormats)) {
      const s = Object.keys(t.datetimeFormats);
      s.length && s.forEach((o) => {
        e.mergeDateTimeFormat(o, t.datetimeFormats[o]);
      });
    }
    if (se(t.numberFormats)) {
      const s = Object.keys(t.numberFormats);
      s.length && s.forEach((o) => {
        e.mergeNumberFormat(o, t.numberFormats[o]);
      });
    }
  }
}
function hs(e) {
  return Q(_i, null, e, 0);
}
const $s = "__INTLIFY_META__", gs = () => [], O0 = () => !1;
let vs = 0;
function ys(e) {
  return (t, n, r, a) => e(n, r, Ur() || void 0, a);
}
const C0 = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = Ur();
  let t = null;
  return e && (t = Ao(e)[$s]) ? { [$s]: t } : null;
};
function T0(e = {}, t) {
  const { __root: n, __injectWithOption: r } = e, a = n === void 0, s = e.flatJson, o = Ot ? F : an, i = !!e.translateExistCompatible;
  process.env.NODE_ENV !== "production" && i && so(An(ze.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
  let l = ce(e.inheritLocale) ? e.inheritLocale : !0;
  const d = o(
    // prettier-ignore
    n && l ? n.locale.value : H(e.locale) ? e.locale : un
  ), c = o(
    // prettier-ignore
    n && l ? n.fallbackLocale.value : H(e.fallbackLocale) || we(e.fallbackLocale) || Z(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : d.value
  ), u = o(Qr(d.value, e)), f = o(Z(e.datetimeFormats) ? e.datetimeFormats : { [d.value]: {} }), v = o(Z(e.numberFormats) ? e.numberFormats : { [d.value]: {} });
  let p = n ? n.missingWarn : ce(e.missingWarn) || Yt(e.missingWarn) ? e.missingWarn : !0, m = n ? n.fallbackWarn : ce(e.fallbackWarn) || Yt(e.fallbackWarn) ? e.fallbackWarn : !0, g = n ? n.fallbackRoot : ce(e.fallbackRoot) ? e.fallbackRoot : !0, y = !!e.fallbackFormat, S = me(e.missing) ? e.missing : null, $ = me(e.missing) ? ys(e.missing) : null, E = me(e.postTranslation) ? e.postTranslation : null, O = n ? n.warnHtmlMessage : ce(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, _ = !!e.escapeParameter;
  const w = n ? n.modifiers : Z(e.modifiers) ? e.modifiers : {};
  let k = e.pluralRules || n && n.pluralRules, C;
  C = (() => {
    a && ss(null);
    const A = {
      version: g0,
      locale: d.value,
      fallbackLocale: c.value,
      messages: u.value,
      modifiers: w,
      pluralRules: k,
      missing: $ === null ? void 0 : $,
      missingWarn: p,
      fallbackWarn: m,
      fallbackFormat: y,
      unresolving: !0,
      postTranslation: E === null ? void 0 : E,
      warnHtmlMessage: O,
      escapeParameter: _,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    A.datetimeFormats = f.value, A.numberFormats = v.value, A.__datetimeFormatters = Z(C) ? C.__datetimeFormatters : void 0, A.__numberFormatters = Z(C) ? C.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (A.__v_emitter = Z(C) ? C.__v_emitter : void 0);
    const x = o0(A);
    return a && ss(x), x;
  })(), Qt(C, d.value, c.value);
  function U() {
    return [
      d.value,
      c.value,
      u.value,
      f.value,
      v.value
    ];
  }
  const j = ae({
    get: () => d.value,
    set: (A) => {
      d.value = A, C.locale = d.value;
    }
  }), Y = ae({
    get: () => c.value,
    set: (A) => {
      c.value = A, C.fallbackLocale = c.value, Qt(C, d.value, A);
    }
  }), $e = ae(() => u.value), Se = /* @__PURE__ */ ae(() => f.value), de = /* @__PURE__ */ ae(() => v.value);
  function Ue() {
    return me(E) ? E : null;
  }
  function ye(A) {
    E = A, C.postTranslation = A;
  }
  function Re() {
    return S;
  }
  function et(A) {
    A !== null && ($ = ys(A)), S = A, C.missing = $;
  }
  function Ie(A, x) {
    return A !== "translate" || !x.resolvedMessage;
  }
  const be = (A, x, ee, ie, st, St) => {
    U();
    let it;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (C.fallbackContext = n ? s0() : void 0), it = A(C);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (C.fallbackContext = void 0);
    }
    if (ee !== "translate exists" && // for not `te` (e.g `t`)
    Ve(it) && it === Vn || ee === "translate exists" && !it) {
      const [lt, zn] = x();
      if (process.env.NODE_ENV !== "production" && n && H(lt) && Ie(ee, zn) && (g && (jn(m, lt) || vo(p, lt)) && Tt(An(ze.FALLBACK_TO_ROOT, {
        key: lt,
        type: ee
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: bn } = C;
        bn && g && bn.emit("fallback", {
          type: ee,
          key: lt,
          to: "global",
          groupId: `${ee}:${lt}`
        });
      }
      return n && g ? ie(n) : st(lt);
    } else {
      if (St(it))
        return it;
      throw Lt(ge.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Pe(...A) {
    return be((x) => Reflect.apply(ds, null, [x, ...A]), () => vr(...A), "translate", (x) => Reflect.apply(x.t, x, [...A]), (x) => x, (x) => H(x));
  }
  function Ae(...A) {
    const [x, ee, ie] = A;
    if (ie && !se(ie))
      throw Lt(ge.INVALID_ARGUMENT);
    return Pe(x, ee, je({ resolvedMessage: !0 }, ie || {}));
  }
  function tt(...A) {
    return be((x) => Reflect.apply(cs, null, [x, ...A]), () => yr(...A), "datetime format", (x) => Reflect.apply(x.d, x, [...A]), () => Pn, (x) => H(x));
  }
  function nt(...A) {
    return be((x) => Reflect.apply(ps, null, [x, ...A]), () => br(...A), "number format", (x) => Reflect.apply(x.n, x, [...A]), () => Pn, (x) => H(x));
  }
  function Oe(A) {
    return A.map((x) => H(x) || Ve(x) || ce(x) ? hs(String(x)) : x);
  }
  const Fe = {
    normalize: Oe,
    interpolate: (A) => A,
    type: "vnode"
  };
  function Ce(...A) {
    return be(
      (x) => {
        let ee;
        const ie = x;
        try {
          ie.processor = Fe, ee = Reflect.apply(ds, null, [ie, ...A]);
        } finally {
          ie.processor = null;
        }
        return ee;
      },
      () => vr(...A),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x) => x[_r](...A),
      (x) => [hs(x)],
      (x) => we(x)
    );
  }
  function ne(...A) {
    return be(
      (x) => Reflect.apply(ps, null, [x, ...A]),
      () => br(...A),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x) => x[Or](...A),
      gs,
      (x) => H(x) || we(x)
    );
  }
  function G(...A) {
    return be(
      (x) => Reflect.apply(cs, null, [x, ...A]),
      () => yr(...A),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x) => x[Er](...A),
      gs,
      (x) => H(x) || we(x)
    );
  }
  function D(A) {
    k = A, C.pluralRules = k;
  }
  function N(A, x) {
    return be(() => {
      if (!A)
        return !1;
      const ee = H(x) ? x : d.value, ie = he(ee), st = C.messageResolver(ie, A);
      return i ? st != null : xt(st) || ot(st) || H(st);
    }, () => [A], "translate exists", (ee) => Reflect.apply(ee.te, ee, [A, x]), O0, (ee) => ce(ee));
  }
  function B(A) {
    let x = null;
    const ee = fo(C, c.value, d.value);
    for (let ie = 0; ie < ee.length; ie++) {
      const st = u.value[ee[ie]] || {}, St = C.messageResolver(st, A);
      if (St != null) {
        x = St;
        break;
      }
    }
    return x;
  }
  function te(A) {
    const x = B(A);
    return x ?? (n ? n.tm(A) || {} : {});
  }
  function he(A) {
    return u.value[A] || {};
  }
  function Ne(A, x) {
    if (s) {
      const ee = { [A]: x };
      for (const ie in ee)
        Ln(ee, ie) && cn(ee[ie]);
      x = ee[A];
    }
    u.value[A] = x, C.messages = u.value;
  }
  function He(A, x) {
    u.value[A] = u.value[A] || {};
    const ee = { [A]: x };
    if (s)
      for (const ie in ee)
        Ln(ee, ie) && cn(ee[ie]);
    x = ee[A], Cn(x, u.value[A]), C.messages = u.value;
  }
  function h(A) {
    return f.value[A] || {};
  }
  function b(A, x) {
    f.value[A] = x, C.datetimeFormats = f.value, fs(C, A, x);
  }
  function R(A, x) {
    f.value[A] = je(f.value[A] || {}, x), C.datetimeFormats = f.value, fs(C, A, x);
  }
  function K(A) {
    return v.value[A] || {};
  }
  function ue(A, x) {
    v.value[A] = x, C.numberFormats = v.value, ms(C, A, x);
  }
  function oe(A, x) {
    v.value[A] = je(v.value[A] || {}, x), C.numberFormats = v.value, ms(C, A, x);
  }
  vs++, n && Ot && (Te(n.locale, (A) => {
    l && (d.value = A, C.locale = A, Qt(C, d.value, c.value));
  }), Te(n.fallbackLocale, (A) => {
    l && (c.value = A, C.fallbackLocale = A, Qt(C, d.value, c.value));
  }));
  const re = {
    id: vs,
    locale: j,
    fallbackLocale: Y,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(A) {
      l = A, A && n && (d.value = n.locale.value, c.value = n.fallbackLocale.value, Qt(C, d.value, c.value));
    },
    get availableLocales() {
      return Object.keys(u.value).sort();
    },
    messages: $e,
    get modifiers() {
      return w;
    },
    get pluralRules() {
      return k || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return p;
    },
    set missingWarn(A) {
      p = A, C.missingWarn = p;
    },
    get fallbackWarn() {
      return m;
    },
    set fallbackWarn(A) {
      m = A, C.fallbackWarn = m;
    },
    get fallbackRoot() {
      return g;
    },
    set fallbackRoot(A) {
      g = A;
    },
    get fallbackFormat() {
      return y;
    },
    set fallbackFormat(A) {
      y = A, C.fallbackFormat = y;
    },
    get warnHtmlMessage() {
      return O;
    },
    set warnHtmlMessage(A) {
      O = A, C.warnHtmlMessage = A;
    },
    get escapeParameter() {
      return _;
    },
    set escapeParameter(A) {
      _ = A, C.escapeParameter = A;
    },
    t: Pe,
    getLocaleMessage: he,
    setLocaleMessage: Ne,
    mergeLocaleMessage: He,
    getPostTranslationHandler: Ue,
    setPostTranslationHandler: ye,
    getMissingHandler: Re,
    setMissingHandler: et,
    [_0]: D
  };
  return re.datetimeFormats = Se, re.numberFormats = de, re.rt = Ae, re.te = N, re.tm = te, re.d = tt, re.n = nt, re.getDateTimeFormat = h, re.setDateTimeFormat = b, re.mergeDateTimeFormat = R, re.getNumberFormat = K, re.setNumberFormat = ue, re.mergeNumberFormat = oe, re[Po] = r, re[_r] = Ce, re[Er] = G, re[Or] = ne, process.env.NODE_ENV !== "production" && (re[Cr] = (A) => {
    C.__v_emitter = A;
  }, re[Tr] = () => {
    C.__v_emitter = void 0;
  }), re;
}
const ea = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function S0({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, a) => [
    ...r,
    // prettier-ignore
    ...a.type === pe ? a.children : [a]
  ], []) : t.reduce((n, r) => {
    const a = e[r];
    return a && (n[r] = a()), n;
  }, {});
}
function ko(e) {
  return pe;
}
je({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (e) => Ve(e) || !isNaN(e)
  }
}, ea);
function w0(e) {
  return we(e) && !H(e[0]);
}
function Do(e, t, n, r) {
  const { slots: a, attrs: s } = t;
  return () => {
    const o = { part: !0 };
    let i = {};
    e.locale && (o.locale = e.locale), H(e.format) ? o.key = e.format : se(e.format) && (H(e.format.key) && (o.key = e.format.key), i = Object.keys(e.format).reduce((f, v) => n.includes(v) ? je({}, f, { [v]: e.format[v] }) : f, {}));
    const l = r(e.value, o, i);
    let d = [o.key];
    we(l) ? d = l.map((f, v) => {
      const p = a[f.type], m = p ? p({ [f.type]: f.value, index: v, parts: l }) : [f.value];
      return w0(m) && (m[0].key = `${f.type}-${v}`), m;
    }) : H(l) && (d = [l]);
    const c = je({}, s), u = H(e.tag) || se(e.tag) ? e.tag : ko();
    return Gs(u, c, d);
  };
}
je({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ea);
je({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ea);
function bs(e, t) {
}
const N0 = /* @__PURE__ */ Ct("global-vue-i18n");
function Xt(e = {}) {
  const t = Ur();
  if (t == null)
    throw Lt(ge.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Lt(ge.NOT_INSTALLED);
  const n = L0(t), r = P0(n), a = Ao(t), s = I0(e, a);
  if (__VUE_I18N_LEGACY_API__ && n.mode === "legacy" && !e.__useComponent) {
    if (!n.allowComposition)
      throw Lt(ge.NOT_AVAILABLE_IN_LEGACY_MODE);
    return R0(t, s, r, e);
  }
  if (s === "global")
    return E0(r, e, a), r;
  if (s === "parent") {
    let l = A0(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Tt(An(ze.NOT_FOUND_PARENT_SCOPE)), l = r), l;
  }
  const o = n;
  let i = o.__getInstance(t);
  if (i == null) {
    const l = je({}, e);
    "__i18n" in a && (l.__i18n = a.__i18n), r && (l.__root = r), i = T0(l), o.__composerExtend && (i[Sr] = o.__composerExtend(i)), D0(o, t, i), o.__setInstance(t, i);
  }
  return i;
}
function L0(e) {
  {
    const t = Mr(e.isCE ? N0 : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw Lt(e.isCE ? ge.NOT_INSTALLED_WITH_PROVIDE : ge.UNEXPECTED_ERROR);
    return t;
  }
}
function I0(e, t) {
  return xn(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function P0(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function A0(e, t, n = !1) {
  let r = null;
  const a = t.root;
  let s = k0(t, n);
  for (; s != null; ) {
    const o = e;
    if (e.mode === "composition")
      r = o.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = o.__getInstance(s);
      i != null && (r = i.__composer, n && r && !r[Po] && (r = null));
    }
    if (r != null || a === s)
      break;
    s = s.parent;
  }
  return r;
}
function k0(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function D0(e, t, n) {
  let r = null;
  Qe(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, r = qu();
      const a = n;
      a[Cr] && a[Cr](r), r.on("*", bs);
    }
  }, t), Ws(() => {
    const a = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (r && r.off("*", bs), a[Tr] && a[Tr](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const s = a[Sr];
    s && (s(), delete a[Sr]);
  }, t);
}
function R0(e, t, n, r = {}) {
  const a = t === "local", s = an(null);
  if (a && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw Lt(ge.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const o = ce(r.inheritLocale) ? r.inheritLocale : !H(r.locale), i = F(
    // prettier-ignore
    !a || o ? n.locale.value : H(r.locale) ? r.locale : un
  ), l = F(
    // prettier-ignore
    !a || o ? n.fallbackLocale.value : H(r.fallbackLocale) || we(r.fallbackLocale) || Z(r.fallbackLocale) || r.fallbackLocale === !1 ? r.fallbackLocale : i.value
  ), d = F(Qr(i.value, r)), c = F(Z(r.datetimeFormats) ? r.datetimeFormats : { [i.value]: {} }), u = F(Z(r.numberFormats) ? r.numberFormats : { [i.value]: {} }), f = a ? n.missingWarn : ce(r.missingWarn) || Yt(r.missingWarn) ? r.missingWarn : !0, v = a ? n.fallbackWarn : ce(r.fallbackWarn) || Yt(r.fallbackWarn) ? r.fallbackWarn : !0, p = a ? n.fallbackRoot : ce(r.fallbackRoot) ? r.fallbackRoot : !0, m = !!r.fallbackFormat, g = me(r.missing) ? r.missing : null, y = me(r.postTranslation) ? r.postTranslation : null, S = a ? n.warnHtmlMessage : ce(r.warnHtmlMessage) ? r.warnHtmlMessage : !0, $ = !!r.escapeParameter, E = a ? n.modifiers : Z(r.modifiers) ? r.modifiers : {}, O = r.pluralRules || a && n.pluralRules;
  function _() {
    return [
      i.value,
      l.value,
      d.value,
      c.value,
      u.value
    ];
  }
  const w = ae({
    get: () => s.value ? s.value.locale.value : i.value,
    set: (N) => {
      s.value && (s.value.locale.value = N), i.value = N;
    }
  }), k = ae({
    get: () => s.value ? s.value.fallbackLocale.value : l.value,
    set: (N) => {
      s.value && (s.value.fallbackLocale.value = N), l.value = N;
    }
  }), C = ae(() => s.value ? s.value.messages.value : d.value), M = ae(() => c.value), U = ae(() => u.value);
  function j() {
    return s.value ? s.value.getPostTranslationHandler() : y;
  }
  function Y(N) {
    s.value && s.value.setPostTranslationHandler(N);
  }
  function $e() {
    return s.value ? s.value.getMissingHandler() : g;
  }
  function Se(N) {
    s.value && s.value.setMissingHandler(N);
  }
  function de(N) {
    return _(), N();
  }
  function Ue(...N) {
    return s.value ? de(() => Reflect.apply(s.value.t, null, [...N])) : de(() => "");
  }
  function ye(...N) {
    return s.value ? Reflect.apply(s.value.rt, null, [...N]) : "";
  }
  function Re(...N) {
    return s.value ? de(() => Reflect.apply(s.value.d, null, [...N])) : de(() => "");
  }
  function et(...N) {
    return s.value ? de(() => Reflect.apply(s.value.n, null, [...N])) : de(() => "");
  }
  function Ie(N) {
    return s.value ? s.value.tm(N) : {};
  }
  function be(N, B) {
    return s.value ? s.value.te(N, B) : !1;
  }
  function Pe(N) {
    return s.value ? s.value.getLocaleMessage(N) : {};
  }
  function Ae(N, B) {
    s.value && (s.value.setLocaleMessage(N, B), d.value[N] = B);
  }
  function tt(N, B) {
    s.value && s.value.mergeLocaleMessage(N, B);
  }
  function nt(N) {
    return s.value ? s.value.getDateTimeFormat(N) : {};
  }
  function Oe(N, B) {
    s.value && (s.value.setDateTimeFormat(N, B), c.value[N] = B);
  }
  function _e(N, B) {
    s.value && s.value.mergeDateTimeFormat(N, B);
  }
  function Fe(N) {
    return s.value ? s.value.getNumberFormat(N) : {};
  }
  function Ce(N, B) {
    s.value && (s.value.setNumberFormat(N, B), u.value[N] = B);
  }
  function ne(N, B) {
    s.value && s.value.mergeNumberFormat(N, B);
  }
  const G = {
    get id() {
      return s.value ? s.value.id : -1;
    },
    locale: w,
    fallbackLocale: k,
    messages: C,
    datetimeFormats: M,
    numberFormats: U,
    get inheritLocale() {
      return s.value ? s.value.inheritLocale : o;
    },
    set inheritLocale(N) {
      s.value && (s.value.inheritLocale = N);
    },
    get availableLocales() {
      return s.value ? s.value.availableLocales : Object.keys(d.value);
    },
    get modifiers() {
      return s.value ? s.value.modifiers : E;
    },
    get pluralRules() {
      return s.value ? s.value.pluralRules : O;
    },
    get isGlobal() {
      return s.value ? s.value.isGlobal : !1;
    },
    get missingWarn() {
      return s.value ? s.value.missingWarn : f;
    },
    set missingWarn(N) {
      s.value && (s.value.missingWarn = N);
    },
    get fallbackWarn() {
      return s.value ? s.value.fallbackWarn : v;
    },
    set fallbackWarn(N) {
      s.value && (s.value.missingWarn = N);
    },
    get fallbackRoot() {
      return s.value ? s.value.fallbackRoot : p;
    },
    set fallbackRoot(N) {
      s.value && (s.value.fallbackRoot = N);
    },
    get fallbackFormat() {
      return s.value ? s.value.fallbackFormat : m;
    },
    set fallbackFormat(N) {
      s.value && (s.value.fallbackFormat = N);
    },
    get warnHtmlMessage() {
      return s.value ? s.value.warnHtmlMessage : S;
    },
    set warnHtmlMessage(N) {
      s.value && (s.value.warnHtmlMessage = N);
    },
    get escapeParameter() {
      return s.value ? s.value.escapeParameter : $;
    },
    set escapeParameter(N) {
      s.value && (s.value.escapeParameter = N);
    },
    t: Ue,
    getPostTranslationHandler: j,
    setPostTranslationHandler: Y,
    getMissingHandler: $e,
    setMissingHandler: Se,
    rt: ye,
    d: Re,
    n: et,
    tm: Ie,
    te: be,
    getLocaleMessage: Pe,
    setLocaleMessage: Ae,
    mergeLocaleMessage: tt,
    getDateTimeFormat: nt,
    setDateTimeFormat: Oe,
    mergeDateTimeFormat: _e,
    getNumberFormat: Fe,
    setNumberFormat: Ce,
    mergeNumberFormat: ne
  };
  function D(N) {
    N.locale.value = i.value, N.fallbackLocale.value = l.value, Object.keys(d.value).forEach((B) => {
      N.mergeLocaleMessage(B, d.value[B]);
    }), Object.keys(c.value).forEach((B) => {
      N.mergeDateTimeFormat(B, c.value[B]);
    }), Object.keys(u.value).forEach((B) => {
      N.mergeNumberFormat(B, u.value[B]);
    }), N.escapeParameter = $, N.fallbackFormat = m, N.fallbackRoot = p, N.fallbackWarn = v, N.missingWarn = f, N.warnHtmlMessage = S;
  }
  return bi(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw Lt(ge.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const N = s.value = e.proxy.$i18n.__composer;
    t === "global" ? (i.value = N.locale.value, l.value = N.fallbackLocale.value, d.value = N.messages.value, c.value = N.datetimeFormats.value, u.value = N.numberFormats.value) : a && D(N);
  }), G;
}
v0();
__INTLIFY_JIT_COMPILATION__ ? as(c0) : as(u0);
t0(Rc);
n0(fo);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = _t();
  e.__INTLIFY__ = !0, Gc(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const F0 = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M0 = ["fill"], ta = {
  __name: "IconCross",
  props: {
    fill: {
      type: String,
      default: "rgb(var(--black))"
    }
  },
  setup(e) {
    return (t, n) => (T(), L("svg", F0, [
      P("path", {
        fill: e.fill,
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.9996 10.8L22.8994 0.900244L25.0993 3.1002L15.1995 13L25.0993 22.8998L22.8994 25.0998L12.9996 15.2L3.09976 25.0998L0.899801 22.8998L10.7996 13L0.899801 3.1002L3.09976 0.900244L12.9996 10.8Z"
      }, null, 8, M0)
    ]));
  }
}, x0 = {
  key: "popup-content",
  class: "pd-small z-index-6 popup-wrapper"
}, U0 = {
  key: 0,
  class: "mn-b-small"
}, B0 = {
  __name: "Popup",
  props: {
    isPopupOpen: {
      type: Boolean,
      default: !1
    },
    style: String,
    title: String
  },
  emits: ["close-popup"],
  setup(e, { emit: t }) {
    const n = e, r = t;
    function a() {
      r("close-popup");
    }
    return Te(() => n.isPopupOpen, (o) => {
      o ? document.body.classList.add("no-scroll") : document.body.classList.remove("no-scroll");
    }), no(), to(), Xt({
      messages: {
        en: {},
        ru: {}
      }
    }), (o, i) => (T(), Le(xe, {
      name: "TransitionTranslateY",
      appear: ""
    }, {
      default: fe(() => [
        e.isPopupOpen ? (T(), Le(Ei, {
          key: 0,
          to: "body"
        }, [
          e.isPopupOpen ? (T(), L("div", x0, [
            Q(xe, {
              name: "TransitionTranslateY",
              mode: "out-in"
            }, {
              default: fe(() => [
                P("section", js({ class: "pos-relative z-index-4" }, o.$attrs, {
                  class: o.$attrs.class
                }), [
                  e.title ? (T(), L("h4", U0, W(e.title), 1)) : V("", !0),
                  Q(ta, {
                    fill: "rgb(var(--white))",
                    onClick: i[0] || (i[0] = (l) => a()),
                    class: "cursor-pointer bg-second pd-micro radius-extra pos-absolute pos-t-0 pos-r-0 mn-t-semi mn-r-semi hover-scale-1 i-medium z-index-5"
                  }),
                  J(o.$slots, "default")
                ], 16)
              ]),
              _: 3
            }),
            P("div", {
              onClick: i[1] || (i[1] = (l) => a()),
              class: X([{ active: e.isPopupOpen === !0 }, "color-overlay z-index-3"])
            }, null, 2)
          ])) : V("", !0)
        ])) : V("", !0)
      ]),
      _: 3
    }));
  }
}, V0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B0
}, Symbol.toStringTag, { value: "Module" })), j0 = { class: "flex-v-center flex-nowrap flex" }, H0 = {
  key: 0,
  class: "br-solid br-2px br-grey-transp-25 pos-absolute pos-t-0 pos-r-0 radius-extra w-100 h-100"
}, G0 = {
  key: 0,
  class: "mn-r-auto t-transp mn-r-small"
}, W0 = ["name", "value", "checked"], Ro = {
  __name: "Radio",
  props: {
    label: String,
    name: String,
    value: !1,
    radio: [Object, String]
  },
  emits: ["update:radio"],
  setup(e, { emit: t }) {
    const n = t;
    return (r, a) => (T(), L("label", j0, [
      P("div", {
        class: X(["cursor-pointer mn-r-thin radius-extra pd-micro h-100 aspect-1x1 pos-relative", {
          "bg-main": e.radio === e.value
        }])
      }, [
        P("div", {
          class: X(["radius-extra pd-micro w-100 h-100", {
            "bg-white": e.radio === e.value
          }])
        }, null, 2),
        e.radio !== e.value ? (T(), L("div", H0)) : V("", !0)
      ], 2),
      e.label ? (T(), L("div", G0, [
        P("span", null, W(e.label), 1)
      ])) : V("", !0),
      P("input", {
        onInput: a[0] || (a[0] = (s) => r.text = n("update:radio", s.target.value)),
        class: "round radiobutton",
        type: "checkbox",
        name: e.name,
        value: e.value,
        checked: e.value === e.radio
      }, null, 40, W0)
    ]));
  }
}, K0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ro
}, Symbol.toStringTag, { value: "Module" })), Y0 = {
  key: 0,
  class: "t-transp mn-r-small"
}, q0 = { class: "w-100" }, z0 = ["onClick"], X0 = {
  key: 0,
  class: "w-100"
}, J0 = {
  key: 0,
  class: "mn-t-thin invalid-feedback"
}, Z0 = {
  __name: "Select",
  props: {
    label: String,
    placeholder: { type: String, default: "Please select an item" },
    select: [String, Object],
    property: String,
    options: { type: Array, default: () => [] },
    validation: Boolean
  },
  emits: [
    "update:select",
    "focus",
    "blur"
  ],
  setup(e, { emit: t }) {
    let n = jr;
    const r = t, a = e, s = F(!1), o = F(
      a.property ? u(a.select, a.property, a.options) : a.select
    ), i = ae(() => a.select ? a.options.filter((f) => f !== a.select) : a.options);
    Te(() => a.select, (f) => {
      o.value = a.property ? u(a.select, a.property, a.options) : a.select;
    });
    const l = () => {
      s.value = !s.value, r(s.value ? "focus" : "blur");
    };
    function d() {
      s.value = !1;
    }
    const c = (f) => {
      o.value = f, l(), a.property ? r("update:select", o.value[a.property]) : r("update:select", o.value);
    };
    function u(f, v, p) {
      for (const m of p)
        if (m[v] === f || m === f)
          return m;
      return null;
    }
    return (f, v) => {
      var p, m;
      return T(), L(pe, null, [
        Be((T(), L("div", {
          onClick: le(l, ["stop"]),
          class: X([f.$attrs.class, "cursor-pointer flex-v-center flex-nowrap flex pos-relative"])
        }, [
          e.label ? (T(), L("div", Y0, [
            P("span", null, W(e.label), 1)
          ])) : V("", !0),
          P("li", q0, [
            P("span", null, W((p = o.value) != null && p.name ? (m = o.value) == null ? void 0 : m.name : o.value || e.placeholder), 1)
          ]),
          Q(xe, {
            mode: "out-in",
            name: "TransitionTranslateY"
          }, {
            default: fe(() => [
              Be(P("ul", {
                class: X([f.$attrs.class, "bs-black pos-absolute pos-t-100 pos-l-0 z-index-5 w-100 mn-t-thin"]),
                style: { "min-width": "max-content" }
              }, [
                (T(!0), L(pe, null, De(i.value, (g) => (T(), L("li", {
                  onClick: le((y) => c(g), ["stop"])
                }, [
                  g ? (T(), L("span", X0, W(g.name || g), 1)) : V("", !0)
                ], 8, z0))), 256))
              ], 2), [
                [ut, s.value]
              ])
            ]),
            _: 1
          })
        ], 2)), [
          [We(n), d]
        ]),
        Q(xe, {
          mode: "out-in",
          name: "fade"
        }, {
          default: fe(() => [
            e.validation ? (T(), L("div", J0, " * " + W(e.validation.message), 1)) : V("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}, Q0 = /* @__PURE__ */ $t(Z0, [["__scopeId", "data-v-bf25c24d"]]), e1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Q0
}, Symbol.toStringTag, { value: "Module" }));
function nr(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function t1(e) {
  return (...t) => !e(...t);
}
function n1(e, t) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(t.trim()) !== -1;
}
function Fo(e, t, n, r) {
  return t ? e.filter((a) => n1(r(a, n), t)).sort((a, s) => r(a, n).length - r(s, n).length) : e;
}
function r1(e) {
  return e.filter((t) => !t.$isLabel);
}
function rr(e, t) {
  return (n) => n.reduce((r, a) => a[e] && a[e].length ? (r.push({
    $groupLabel: a[t],
    $isLabel: !0
  }), r.concat(a[e])) : r, []);
}
function a1(e, t, n, r, a) {
  return (s) => s.map((o) => {
    if (!o[n])
      return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
    const i = Fo(o[n], e, t, a);
    return i.length ? {
      [r]: o[r],
      [n]: i
    } : [];
  });
}
const _s = (...e) => (t) => e.reduce((n, r) => r(n), t), s1 = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, t) {
        return nr(e) ? "" : t ? e[t] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
    */
    preventAutofocus: {
      type: Boolean,
      default: !1
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", t = e.toLowerCase().trim();
      let n = this.options.concat();
      return this.internalSearch ? n = this.groupValues ? this.filterAndFlat(n, t, this.label) : Fo(n, t, this.label, this.customLabel) : n = this.groupValues ? rr(this.groupValues, this.groupLabel)(n) : n, n = this.hideSelected ? n.filter(t1(this.isSelected)) : n, this.taggable && t.length && !this.isExistingOption(t) && (this.tagPosition === "bottom" ? n.push({ isTag: !0, label: e }) : n.unshift({ isTag: !0, label: e })), n.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((t) => this.customLabel(t, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, t, n) {
      return _s(
        a1(t, n, this.groupValues, this.groupLabel, this.customLabel),
        rr(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return _s(
        rr(this.groupValues, this.groupLabel),
        r1
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const t = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(t) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (nr(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const t = this.customLabel(e, this.label);
      return nr(t) ? "" : t;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, t) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(t) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(t === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            t !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const t = this.options.find((n) => n[this.groupLabel] === e.$groupLabel);
      if (t) {
        if (this.wholeGroupSelected(t)) {
          this.$emit("remove", t[this.groupValues], this.id);
          const n = this.internalValue.filter(
            (r) => t[this.groupValues].indexOf(r) === -1
          );
          this.$emit("update:modelValue", n);
        } else {
          let n = t[this.groupValues].filter(
            (r) => !(this.isOptionDisabled(r) || this.isSelected(r))
          );
          this.max && n.splice(this.max - this.internalValue.length), this.$emit("select", n, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(n)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (t) => this.isSelected(t) || this.isOptionDisabled(t)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, t = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const n = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const r = this.internalValue.slice(0, n).concat(this.internalValue.slice(n + 1));
        this.$emit("update:modelValue", r);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && t && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, t = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      t > this.maxHeight || t > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(t - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    }
  }
}, o1 = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, t) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(t)
      };
    },
    groupHighlight(e, t) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": t.$isLabel }
        ];
      const n = this.options.find((r) => r[this.groupLabel] === t.$groupLabel);
      return n && !this.wholeGroupDisabled(n) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(n) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, i1 = {
  name: "vue-multiselect",
  mixins: [s1, o1],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    }
  }
}, l1 = ["tabindex", "aria-owns"], d1 = {
  ref: "tags",
  class: "multiselect__tags"
}, u1 = { class: "multiselect__tags-wrap" }, c1 = ["textContent"], f1 = ["onKeypress", "onMousedown"], p1 = ["textContent"], m1 = { class: "multiselect__spinner" }, h1 = ["name", "id", "placeholder", "value", "disabled", "tabindex", "aria-controls"], $1 = ["id"], g1 = { key: 0 }, v1 = { class: "multiselect__option" }, y1 = ["id", "role"], b1 = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], _1 = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], E1 = { class: "multiselect__option" }, O1 = { class: "multiselect__option" };
function C1(e, t, n, r, a, s) {
  return T(), L("div", {
    tabindex: e.searchable ? -1 : n.tabindex,
    class: X([{ "multiselect--active": e.isOpen, "multiselect--disabled": n.disabled, "multiselect--above": s.isAbove, "multiselect--has-options-group": s.hasOptionGroup }, "multiselect flex flex-v-center"]),
    onFocus: t[13] || (t[13] = (o) => e.activate()),
    onBlur: t[14] || (t[14] = (o) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      t[15] || (t[15] = Me(le((o) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      t[16] || (t[16] = Me(le((o) => e.pointerBackward(), ["self", "prevent"]), ["up"]))
    ],
    onKeypress: t[17] || (t[17] = Me(le((o) => e.addPointerElement(o), ["stop", "self"]), ["enter", "tab"])),
    onKeyup: t[18] || (t[18] = Me((o) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-owns": "listbox-" + e.id
  }, [
    J(e.$slots, "caret", { toggle: e.toggle }, () => [
      P("div", {
        onMousedown: t[0] || (t[0] = le((o) => e.toggle(), ["prevent", "stop"])),
        class: "multiselect__select"
      }, null, 32)
    ]),
    J(e.$slots, "clear", { search: e.search }),
    P("div", d1, [
      J(e.$slots, "selection", {
        search: e.search,
        remove: e.removeElement,
        values: s.visibleValues,
        isOpen: e.isOpen
      }, () => [
        Be(P("div", u1, [
          (T(!0), L(pe, null, De(s.visibleValues, (o, i) => J(e.$slots, "tag", {
            option: o,
            search: e.search,
            remove: e.removeElement
          }, () => [
            (T(), L("span", {
              class: "multiselect__tag",
              key: i
            }, [
              P("span", {
                textContent: W(e.getOptionLabel(o))
              }, null, 8, c1),
              P("i", {
                tabindex: "1",
                onKeypress: Me(le((l) => e.removeElement(o), ["prevent"]), ["enter"]),
                onMousedown: le((l) => e.removeElement(o), ["prevent"]),
                class: "multiselect__tag-icon"
              }, null, 40, f1)
            ]))
          ])), 256))
        ], 512), [
          [ut, s.visibleValues.length > 0]
        ]),
        e.internalValue && e.internalValue.length > n.limit ? J(e.$slots, "limit", { key: 0 }, () => [
          P("strong", {
            class: "multiselect__strong",
            textContent: W(n.limitText(e.internalValue.length - n.limit))
          }, null, 8, p1)
        ]) : V("", !0)
      ]),
      Q(xe, { name: "multiselect__loading" }, {
        default: fe(() => [
          J(e.$slots, "loading", {}, () => [
            Be(P("div", m1, null, 512), [
              [ut, n.loading]
            ])
          ])
        ]),
        _: 3
      }),
      e.searchable ? (T(), L("input", {
        key: 0,
        ref: "search",
        name: n.name,
        id: e.id,
        type: "text",
        autocomplete: "off",
        spellcheck: "false",
        placeholder: e.placeholder,
        style: Xe(s.inputStyle),
        value: e.search,
        disabled: n.disabled,
        tabindex: n.tabindex,
        onInput: t[1] || (t[1] = (o) => e.updateSearch(o.target.value)),
        onFocus: t[2] || (t[2] = le((o) => e.activate(), ["prevent"])),
        onBlur: t[3] || (t[3] = le((o) => e.deactivate(), ["prevent"])),
        onKeyup: t[4] || (t[4] = Me((o) => e.deactivate(), ["esc"])),
        onKeydown: [
          t[5] || (t[5] = Me(le((o) => e.pointerForward(), ["prevent"]), ["down"])),
          t[6] || (t[6] = Me(le((o) => e.pointerBackward(), ["prevent"]), ["up"])),
          t[8] || (t[8] = Me(le((o) => e.removeLastElement(), ["stop"]), ["delete"]))
        ],
        onKeypress: t[7] || (t[7] = Me(le((o) => e.addPointerElement(o), ["prevent", "stop", "self"]), ["enter"])),
        class: "multiselect__input",
        "aria-controls": "listbox-" + e.id
      }, null, 44, h1)) : V("", !0),
      s.isSingleLabelVisible ? (T(), L("span", {
        key: 1,
        class: "multiselect__single",
        onMousedown: t[9] || (t[9] = le((...o) => e.toggle && e.toggle(...o), ["prevent"]))
      }, [
        J(e.$slots, "singleLabel", { option: s.singleValue }, () => [
          mt(W(e.currentOptionLabel), 1)
        ])
      ], 32)) : V("", !0),
      s.isPlaceholderVisible ? (T(), L("span", {
        key: 2,
        class: "multiselect__placeholder",
        onMousedown: t[10] || (t[10] = le((...o) => e.toggle && e.toggle(...o), ["prevent"]))
      }, [
        J(e.$slots, "placeholder", {}, () => [
          mt(W(e.placeholder), 1)
        ])
      ], 32)) : V("", !0)
    ], 512),
    Q(xe, { name: "multiselect" }, {
      default: fe(() => [
        Be(P("div", {
          class: X(["multiselect__content-wrapper", e.$attrs.class]),
          onFocus: t[11] || (t[11] = (...o) => e.activate && e.activate(...o)),
          tabindex: "-1",
          onMousedown: t[12] || (t[12] = le(() => {
          }, ["prevent"])),
          style: Xe({ maxHeight: e.optimizedHeight + "px" }),
          ref: "list"
        }, [
          P("ul", {
            class: "multiselect__content",
            style: Xe(s.contentStyle),
            role: "listbox",
            id: "listbox-" + e.id
          }, [
            J(e.$slots, "beforeList"),
            e.multiple && e.max === e.internalValue.length ? (T(), L("li", g1, [
              P("span", v1, [
                J(e.$slots, "maxElements", {}, () => [
                  mt("Maximum of " + W(e.max) + " options selected. First remove a selected option to select another.", 1)
                ])
              ])
            ])) : V("", !0),
            !e.max || e.internalValue.length < e.max ? (T(!0), L(pe, { key: 1 }, De(e.filteredOptions, (o, i) => (T(), L("li", {
              class: "multiselect__element",
              key: i,
              id: e.id + "-" + i,
              role: o && (o.$isLabel || o.$isDisabled) ? null : "option"
            }, [
              o && (o.$isLabel || o.$isDisabled) ? V("", !0) : (T(), L("span", {
                key: 0,
                class: X([e.optionHighlight(i, o), "multiselect__option"]),
                onClick: le((l) => e.select(o), ["stop"]),
                onMouseenter: le((l) => e.pointerSet(i), ["self"]),
                "data-select": o && o.isTag ? e.tagPlaceholder : s.selectLabelText,
                "data-selected": s.selectedLabelText,
                "data-deselect": s.deselectLabelText
              }, [
                J(e.$slots, "option", {
                  option: o,
                  search: e.search,
                  index: i
                }, () => [
                  P("span", null, W(e.getOptionLabel(o)), 1)
                ])
              ], 42, b1)),
              o && (o.$isLabel || o.$isDisabled) ? (T(), L("span", {
                key: 1,
                "data-select": e.groupSelect && s.selectGroupLabelText,
                "data-deselect": e.groupSelect && s.deselectGroupLabelText,
                class: X([e.groupHighlight(i, o), "multiselect__option"]),
                onMouseenter: le((l) => e.groupSelect && e.pointerSet(i), ["self"]),
                onMousedown: le((l) => e.selectGroup(o), ["prevent"])
              }, [
                J(e.$slots, "option", {
                  option: o,
                  search: e.search,
                  index: i
                }, () => [
                  P("span", null, W(e.getOptionLabel(o)), 1)
                ])
              ], 42, _1)) : V("", !0)
            ], 8, y1))), 128)) : V("", !0),
            Be(P("li", null, [
              P("span", E1, [
                J(e.$slots, "noResult", { search: e.search }, () => [
                  t[19] || (t[19] = mt("No elements found. Consider changing the search query."))
                ])
              ])
            ], 512), [
              [ut, n.showNoResults && e.filteredOptions.length === 0 && e.search && !n.loading]
            ]),
            Be(P("li", null, [
              P("span", O1, [
                J(e.$slots, "noOptions", {}, () => [
                  t[20] || (t[20] = mt("List is empty."))
                ])
              ])
            ], 512), [
              [ut, n.showNoOptions && (e.options.length === 0 || s.hasOptionGroup === !0 && e.filteredOptions.length === 0) && !e.search && !n.loading]
            ]),
            J(e.$slots, "afterList")
          ], 12, $1)
        ], 38), [
          [ut, e.isOpen]
        ])
      ]),
      _: 3
    })
  ], 42, l1);
}
const T1 = /* @__PURE__ */ $t(i1, [["render", C1]]), S1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: T1
}, Symbol.toStringTag, { value: "Module" })), w1 = { class: "spoiler" }, Mo = {
  __name: "Spoiler",
  props: {
    status: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = F(!1);
    return t.status && (n.value = t.status), (r, a) => (T(), L("div", null, [
      P("div", {
        onClick: a[0] || (a[0] = (s) => n.value = !n.value),
        class: "flex-v-center flex-nowrap flex"
      }, [
        J(r.$slots, "header", { isOpen: n.value })
      ]),
      Q(xe, { name: "collapse" }, {
        default: fe(() => [
          Be(P("div", w1, [
            J(r.$slots, "content")
          ], 512), [
            [ut, n.value]
          ])
        ]),
        _: 3
      })
    ]));
  }
}, N1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mo
}, Symbol.toStringTag, { value: "Module" })), L1 = { class: "flex-nowrap flex-v-center gap-micro pd-micro flex pos-relative" }, I1 = ["onClick"], P1 = { class: "" }, A1 = {
  __name: "Tab",
  props: {
    tabs: Array,
    tabClass: String,
    selected: String,
    callback: Function
  },
  emits: ["update:selected"],
  setup(e, { emit: t }) {
    const n = t, r = e, a = F(0);
    if (r.selected) {
      const o = r.tabs.findIndex((i) => i.value === r.selected);
      o !== -1 && (a.value = o);
    }
    function s(o, i) {
      a.value = o, n("update:selected", i.value), r.callback && r.callback();
    }
    return (o, i) => (T(), L("div", L1, [
      (T(!0), L(pe, null, De(e.tabs, (l, d) => (T(), L("div", {
        key: d,
        onClick: (c) => s(d, l),
        class: X(["z-index-1 t-center", [
          d !== a.value ? "bg-white" : "bg-main",
          e.tabClass ? e.tabClass : "pd-small pd-r-medium pd-l-medium w-max pd-small radius-small"
        ]])
      }, [
        P("label", P1, W(l.name), 1)
      ], 10, I1))), 128))
    ]));
  }
}, k1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A1
}, Symbol.toStringTag, { value: "Module" })), D1 = {
  __name: "Tooltip",
  props: {
    text: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = F(!1), n = Hs({
      position: "absolute",
      width: "max-content",
      zIndex: 1e3,
      background: "#333",
      color: "#fff",
      padding: "5px 10px",
      borderRadius: "3px",
      fontSize: "14px",
      display: "none"
    });
    function r(s) {
      t.value = !0, n.left = `${s.clientX / 100 + 10}px`, n.top = `${s.clientY / 100 + 10}px`, n.display = "block";
    }
    function a() {
      t.value = !1, n.display = "none";
    }
    return (s, o) => (T(), L("div", {
      class: "cursor-pointer tooltip-container",
      onMouseover: r,
      onMouseleave: a
    }, [
      J(s.$slots, "default"),
      P("div", {
        class: "tooltip-content",
        style: Xe(n)
      }, W(e.text), 5)
    ], 32));
  }
}, R1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D1
}, Symbol.toStringTag, { value: "Module" })), F1 = {
  key: 0,
  class: "cursor-pointer t-second"
}, M1 = {
  __name: "Text",
  props: {
    maxLen: { type: Number, required: !0 },
    text: { type: String, required: !0 },
    showToggleText: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = F(!1), r = ae(() => t.text.length > t.maxLen ? t.text.slice(0, t.maxLen) + "..." : t.text), a = ae(() => t.text), s = () => {
      n.value = !n.value;
    }, o = ae(() => n.value ? a.value : r.value), i = ae(() => t.text.length > t.maxLen), l = ae(() => n.value ? "Hide" : "Show more");
    return (d, c) => (T(), L("span", {
      onClick: s,
      class: ""
    }, [
      mt(W(o.value) + " ", 1),
      i.value && e.showToggleText ? (T(), L("span", F1, W(l.value), 1)) : V("", !0)
    ]));
  }
}, x1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M1
}, Symbol.toStringTag, { value: "Module" }));
function xo(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: U1 } = Object.prototype, { getPrototypeOf: na } = Object, Hn = /* @__PURE__ */ ((e) => (t) => {
  const n = U1.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), pt = (e) => (e = e.toLowerCase(), (t) => Hn(t) === e), Gn = (e) => (t) => typeof t === e, { isArray: Jt } = Array, fn = Gn("undefined");
function B1(e) {
  return e !== null && !fn(e) && e.constructor !== null && !fn(e.constructor) && at(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Uo = pt("ArrayBuffer");
function V1(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Uo(e.buffer), t;
}
const j1 = Gn("string"), at = Gn("function"), Bo = Gn("number"), Wn = (e) => e !== null && typeof e == "object", H1 = (e) => e === !0 || e === !1, Tn = (e) => {
  if (Hn(e) !== "object")
    return !1;
  const t = na(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, G1 = pt("Date"), W1 = pt("File"), K1 = pt("Blob"), Y1 = pt("FileList"), q1 = (e) => Wn(e) && at(e.pipe), z1 = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || at(e.append) && ((t = Hn(e)) === "formdata" || // detect form-data instance
  t === "object" && at(e.toString) && e.toString() === "[object FormData]"));
}, X1 = pt("URLSearchParams"), [J1, Z1, Q1, ef] = ["ReadableStream", "Request", "Response", "Headers"].map(pt), tf = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function gn(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, a;
  if (typeof e != "object" && (e = [e]), Jt(e))
    for (r = 0, a = e.length; r < a; r++)
      t.call(null, e[r], r, e);
  else {
    const s = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = s.length;
    let i;
    for (r = 0; r < o; r++)
      i = s[r], t.call(null, e[i], i, e);
  }
}
function Vo(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], t === a.toLowerCase())
      return a;
  return null;
}
const Dt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, jo = (e) => !fn(e) && e !== Dt;
function wr() {
  const { caseless: e } = jo(this) && this || {}, t = {}, n = (r, a) => {
    const s = e && Vo(t, a) || a;
    Tn(t[s]) && Tn(r) ? t[s] = wr(t[s], r) : Tn(r) ? t[s] = wr({}, r) : Jt(r) ? t[s] = r.slice() : t[s] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && gn(arguments[r], n);
  return t;
}
const nf = (e, t, n, { allOwnKeys: r } = {}) => (gn(t, (a, s) => {
  n && at(a) ? e[s] = xo(a, n) : e[s] = a;
}, { allOwnKeys: r }), e), rf = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), af = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, sf = (e, t, n, r) => {
  let a, s, o;
  const i = {};
  if (t = t || {}, e == null) return t;
  do {
    for (a = Object.getOwnPropertyNames(e), s = a.length; s-- > 0; )
      o = a[s], (!r || r(o, e, t)) && !i[o] && (t[o] = e[o], i[o] = !0);
    e = n !== !1 && na(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, of = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, lf = (e) => {
  if (!e) return null;
  if (Jt(e)) return e;
  let t = e.length;
  if (!Bo(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, df = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && na(Uint8Array)), uf = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = r.next()) && !a.done; ) {
    const s = a.value;
    t.call(e, s[0], s[1]);
  }
}, cf = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, ff = pt("HTMLFormElement"), pf = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, a) {
    return r.toUpperCase() + a;
  }
), Es = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), mf = pt("RegExp"), Ho = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  gn(n, (a, s) => {
    let o;
    (o = t(a, s, e)) !== !1 && (r[s] = o || a);
  }), Object.defineProperties(e, r);
}, hf = (e) => {
  Ho(e, (t, n) => {
    if (at(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (at(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, $f = (e, t) => {
  const n = {}, r = (a) => {
    a.forEach((s) => {
      n[s] = !0;
    });
  };
  return Jt(e) ? r(e) : r(String(e).split(t)), n;
}, gf = () => {
}, vf = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, ar = "abcdefghijklmnopqrstuvwxyz", Os = "0123456789", Go = {
  DIGIT: Os,
  ALPHA: ar,
  ALPHA_DIGIT: ar + ar.toUpperCase() + Os
}, yf = (e = 16, t = Go.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function bf(e) {
  return !!(e && at(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const _f = (e) => {
  const t = new Array(10), n = (r, a) => {
    if (Wn(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[a] = r;
        const s = Jt(r) ? [] : {};
        return gn(r, (o, i) => {
          const l = n(o, a + 1);
          !fn(l) && (s[i] = l);
        }), t[a] = void 0, s;
      }
    }
    return r;
  };
  return n(e, 0);
}, Ef = pt("AsyncFunction"), Of = (e) => e && (Wn(e) || at(e)) && at(e.then) && at(e.catch), Wo = ((e, t) => e ? setImmediate : t ? ((n, r) => (Dt.addEventListener("message", ({ source: a, data: s }) => {
  a === Dt && s === n && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), Dt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  at(Dt.postMessage)
), Cf = typeof queueMicrotask < "u" ? queueMicrotask.bind(Dt) : typeof process < "u" && process.nextTick || Wo, I = {
  isArray: Jt,
  isArrayBuffer: Uo,
  isBuffer: B1,
  isFormData: z1,
  isArrayBufferView: V1,
  isString: j1,
  isNumber: Bo,
  isBoolean: H1,
  isObject: Wn,
  isPlainObject: Tn,
  isReadableStream: J1,
  isRequest: Z1,
  isResponse: Q1,
  isHeaders: ef,
  isUndefined: fn,
  isDate: G1,
  isFile: W1,
  isBlob: K1,
  isRegExp: mf,
  isFunction: at,
  isStream: q1,
  isURLSearchParams: X1,
  isTypedArray: df,
  isFileList: Y1,
  forEach: gn,
  merge: wr,
  extend: nf,
  trim: tf,
  stripBOM: rf,
  inherits: af,
  toFlatObject: sf,
  kindOf: Hn,
  kindOfTest: pt,
  endsWith: of,
  toArray: lf,
  forEachEntry: uf,
  matchAll: cf,
  isHTMLForm: ff,
  hasOwnProperty: Es,
  hasOwnProp: Es,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ho,
  freezeMethods: hf,
  toObjectSet: $f,
  toCamelCase: pf,
  noop: gf,
  toFiniteNumber: vf,
  findKey: Vo,
  global: Dt,
  isContextDefined: jo,
  ALPHABET: Go,
  generateString: yf,
  isSpecCompliantForm: bf,
  toJSONObject: _f,
  isAsyncFn: Ef,
  isThenable: Of,
  setImmediate: Wo,
  asap: Cf
};
function z(e, t, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), a && (this.response = a, this.status = a.status ? a.status : null);
}
I.inherits(z, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: I.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ko = z.prototype, Yo = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Yo[e] = { value: e };
});
Object.defineProperties(z, Yo);
Object.defineProperty(Ko, "isAxiosError", { value: !0 });
z.from = (e, t, n, r, a, s) => {
  const o = Object.create(Ko);
  return I.toFlatObject(e, o, function(l) {
    return l !== Error.prototype;
  }, (i) => i !== "isAxiosError"), z.call(o, e.message, t, n, r, a), o.cause = e, o.name = e.name, s && Object.assign(o, s), o;
};
const Tf = null;
function Nr(e) {
  return I.isPlainObject(e) || I.isArray(e);
}
function qo(e) {
  return I.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Cs(e, t, n) {
  return e ? e.concat(t).map(function(a, s) {
    return a = qo(a), !n && s ? "[" + a + "]" : a;
  }).join(n ? "." : "") : t;
}
function Sf(e) {
  return I.isArray(e) && !e.some(Nr);
}
const wf = I.toFlatObject(I, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Kn(e, t, n) {
  if (!I.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = I.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, g) {
    return !I.isUndefined(g[m]);
  });
  const r = n.metaTokens, a = n.visitor || c, s = n.dots, o = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && I.isSpecCompliantForm(t);
  if (!I.isFunction(a))
    throw new TypeError("visitor must be a function");
  function d(p) {
    if (p === null) return "";
    if (I.isDate(p))
      return p.toISOString();
    if (!l && I.isBlob(p))
      throw new z("Blob is not supported. Use a Buffer instead.");
    return I.isArrayBuffer(p) || I.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function c(p, m, g) {
    let y = p;
    if (p && !g && typeof p == "object") {
      if (I.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), p = JSON.stringify(p);
      else if (I.isArray(p) && Sf(p) || (I.isFileList(p) || I.endsWith(m, "[]")) && (y = I.toArray(p)))
        return m = qo(m), y.forEach(function($, E) {
          !(I.isUndefined($) || $ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Cs([m], E, s) : o === null ? m : m + "[]",
            d($)
          );
        }), !1;
    }
    return Nr(p) ? !0 : (t.append(Cs(g, m, s), d(p)), !1);
  }
  const u = [], f = Object.assign(wf, {
    defaultVisitor: c,
    convertValue: d,
    isVisitable: Nr
  });
  function v(p, m) {
    if (!I.isUndefined(p)) {
      if (u.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      u.push(p), I.forEach(p, function(y, S) {
        (!(I.isUndefined(y) || y === null) && a.call(
          t,
          y,
          I.isString(S) ? S.trim() : S,
          m,
          f
        )) === !0 && v(y, m ? m.concat(S) : [S]);
      }), u.pop();
    }
  }
  if (!I.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), t;
}
function Ts(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function ra(e, t) {
  this._pairs = [], e && Kn(e, this, t);
}
const zo = ra.prototype;
zo.append = function(t, n) {
  this._pairs.push([t, n]);
};
zo.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Ts);
  } : Ts;
  return this._pairs.map(function(a) {
    return n(a[0]) + "=" + n(a[1]);
  }, "").join("&");
};
function Nf(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Xo(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Nf, a = n && n.serialize;
  let s;
  if (a ? s = a(t, n) : s = I.isURLSearchParams(t) ? t.toString() : new ra(t, n).toString(r), s) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class Ss {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    I.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Jo = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Lf = typeof URLSearchParams < "u" ? URLSearchParams : ra, If = typeof FormData < "u" ? FormData : null, Pf = typeof Blob < "u" ? Blob : null, Af = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Lf,
    FormData: If,
    Blob: Pf
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, aa = typeof window < "u" && typeof document < "u", Lr = typeof navigator == "object" && navigator || void 0, kf = aa && (!Lr || ["ReactNative", "NativeScript", "NS"].indexOf(Lr.product) < 0), Df = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Rf = aa && window.location.href || "http://localhost", Ff = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: aa,
  hasStandardBrowserEnv: kf,
  hasStandardBrowserWebWorkerEnv: Df,
  navigator: Lr,
  origin: Rf
}, Symbol.toStringTag, { value: "Module" })), Je = {
  ...Ff,
  ...Af
};
function Mf(e, t) {
  return Kn(e, new Je.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, s) {
      return Je.isNode && I.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function xf(e) {
  return I.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Uf(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const a = n.length;
  let s;
  for (r = 0; r < a; r++)
    s = n[r], t[s] = e[s];
  return t;
}
function Zo(e) {
  function t(n, r, a, s) {
    let o = n[s++];
    if (o === "__proto__") return !0;
    const i = Number.isFinite(+o), l = s >= n.length;
    return o = !o && I.isArray(a) ? a.length : o, l ? (I.hasOwnProp(a, o) ? a[o] = [a[o], r] : a[o] = r, !i) : ((!a[o] || !I.isObject(a[o])) && (a[o] = []), t(n, r, a[o], s) && I.isArray(a[o]) && (a[o] = Uf(a[o])), !i);
  }
  if (I.isFormData(e) && I.isFunction(e.entries)) {
    const n = {};
    return I.forEachEntry(e, (r, a) => {
      t(xf(r), a, n, 0);
    }), n;
  }
  return null;
}
function Bf(e, t, n) {
  if (I.isString(e))
    try {
      return (t || JSON.parse)(e), I.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const vn = {
  transitional: Jo,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", a = r.indexOf("application/json") > -1, s = I.isObject(t);
    if (s && I.isHTMLForm(t) && (t = new FormData(t)), I.isFormData(t))
      return a ? JSON.stringify(Zo(t)) : t;
    if (I.isArrayBuffer(t) || I.isBuffer(t) || I.isStream(t) || I.isFile(t) || I.isBlob(t) || I.isReadableStream(t))
      return t;
    if (I.isArrayBufferView(t))
      return t.buffer;
    if (I.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let i;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Mf(t, this.formSerializer).toString();
      if ((i = I.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Kn(
          i ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return s || a ? (n.setContentType("application/json", !1), Bf(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || vn.transitional, r = n && n.forcedJSONParsing, a = this.responseType === "json";
    if (I.isResponse(t) || I.isReadableStream(t))
      return t;
    if (t && I.isString(t) && (r && !this.responseType || a)) {
      const o = !(n && n.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (i) {
        if (o)
          throw i.name === "SyntaxError" ? z.from(i, z.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Je.classes.FormData,
    Blob: Je.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
I.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  vn.headers[e] = {};
});
const Vf = I.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), jf = (e) => {
  const t = {};
  let n, r, a;
  return e && e.split(`
`).forEach(function(o) {
    a = o.indexOf(":"), n = o.substring(0, a).trim().toLowerCase(), r = o.substring(a + 1).trim(), !(!n || t[n] && Vf[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, ws = Symbol("internals");
function en(e) {
  return e && String(e).trim().toLowerCase();
}
function Sn(e) {
  return e === !1 || e == null ? e : I.isArray(e) ? e.map(Sn) : String(e);
}
function Hf(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Gf = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function sr(e, t, n, r, a) {
  if (I.isFunction(r))
    return r.call(this, t, n);
  if (a && (t = n), !!I.isString(t)) {
    if (I.isString(r))
      return t.indexOf(r) !== -1;
    if (I.isRegExp(r))
      return r.test(t);
  }
}
function Wf(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Kf(e, t) {
  const n = I.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(a, s, o) {
        return this[r].call(this, t, a, s, o);
      },
      configurable: !0
    });
  });
}
class Ze {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const a = this;
    function s(i, l, d) {
      const c = en(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = I.findKey(a, c);
      (!u || a[u] === void 0 || d === !0 || d === void 0 && a[u] !== !1) && (a[u || l] = Sn(i));
    }
    const o = (i, l) => I.forEach(i, (d, c) => s(d, c, l));
    if (I.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (I.isString(t) && (t = t.trim()) && !Gf(t))
      o(jf(t), n);
    else if (I.isHeaders(t))
      for (const [i, l] of t.entries())
        s(l, i, r);
    else
      t != null && s(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = en(t), t) {
      const r = I.findKey(this, t);
      if (r) {
        const a = this[r];
        if (!n)
          return a;
        if (n === !0)
          return Hf(a);
        if (I.isFunction(n))
          return n.call(this, a, r);
        if (I.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = en(t), t) {
      const r = I.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || sr(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let a = !1;
    function s(o) {
      if (o = en(o), o) {
        const i = I.findKey(r, o);
        i && (!n || sr(r, r[i], i, n)) && (delete r[i], a = !0);
      }
    }
    return I.isArray(t) ? t.forEach(s) : s(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, a = !1;
    for (; r--; ) {
      const s = n[r];
      (!t || sr(this, this[s], s, t, !0)) && (delete this[s], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, r = {};
    return I.forEach(this, (a, s) => {
      const o = I.findKey(r, s);
      if (o) {
        n[o] = Sn(a), delete n[s];
        return;
      }
      const i = t ? Wf(s) : String(s).trim();
      i !== s && delete n[s], n[i] = Sn(a), r[i] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return I.forEach(this, (r, a) => {
      r != null && r !== !1 && (n[a] = t && I.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((a) => r.set(a)), r;
  }
  static accessor(t) {
    const r = (this[ws] = this[ws] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function s(o) {
      const i = en(o);
      r[i] || (Kf(a, o), r[i] = !0);
    }
    return I.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
Ze.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
I.reduceDescriptors(Ze.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
I.freezeMethods(Ze);
function or(e, t) {
  const n = this || vn, r = t || n, a = Ze.from(r.headers);
  let s = r.data;
  return I.forEach(e, function(i) {
    s = i.call(n, s, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), s;
}
function Qo(e) {
  return !!(e && e.__CANCEL__);
}
function Zt(e, t, n) {
  z.call(this, e ?? "canceled", z.ERR_CANCELED, t, n), this.name = "CanceledError";
}
I.inherits(Zt, z, {
  __CANCEL__: !0
});
function ei(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new z(
    "Request failed with status code " + n.status,
    [z.ERR_BAD_REQUEST, z.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Yf(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function qf(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let a = 0, s = 0, o;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const d = Date.now(), c = r[s];
    o || (o = d), n[a] = l, r[a] = d;
    let u = s, f = 0;
    for (; u !== a; )
      f += n[u++], u = u % e;
    if (a = (a + 1) % e, a === s && (s = (s + 1) % e), d - o < t)
      return;
    const v = c && d - c;
    return v ? Math.round(f * 1e3 / v) : void 0;
  };
}
function zf(e, t) {
  let n = 0, r = 1e3 / t, a, s;
  const o = (d, c = Date.now()) => {
    n = c, a = null, s && (clearTimeout(s), s = null), e.apply(null, d);
  };
  return [(...d) => {
    const c = Date.now(), u = c - n;
    u >= r ? o(d, c) : (a = d, s || (s = setTimeout(() => {
      s = null, o(a);
    }, r - u)));
  }, () => a && o(a)];
}
const kn = (e, t, n = 3) => {
  let r = 0;
  const a = qf(50, 250);
  return zf((s) => {
    const o = s.loaded, i = s.lengthComputable ? s.total : void 0, l = o - r, d = a(l), c = o <= i;
    r = o;
    const u = {
      loaded: o,
      total: i,
      progress: i ? o / i : void 0,
      bytes: l,
      rate: d || void 0,
      estimated: d && i && c ? (i - o) / d : void 0,
      event: s,
      lengthComputable: i != null,
      [t ? "download" : "upload"]: !0
    };
    e(u);
  }, n);
}, Ns = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Ls = (e) => (...t) => I.asap(() => e(...t)), Xf = Je.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = Je.navigator && /(msie|trident)/i.test(Je.navigator.userAgent), n = document.createElement("a");
    let r;
    function a(s) {
      let o = s;
      return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = a(window.location.href), function(o) {
      const i = I.isString(o) ? a(o) : o;
      return i.protocol === r.protocol && i.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Jf = Je.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, a, s) {
      const o = [e + "=" + encodeURIComponent(t)];
      I.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), I.isString(r) && o.push("path=" + r), I.isString(a) && o.push("domain=" + a), s === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Zf(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Qf(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function ti(e, t) {
  return e && !Zf(t) ? Qf(e, t) : t;
}
const Is = (e) => e instanceof Ze ? { ...e } : e;
function Ut(e, t) {
  t = t || {};
  const n = {};
  function r(d, c, u) {
    return I.isPlainObject(d) && I.isPlainObject(c) ? I.merge.call({ caseless: u }, d, c) : I.isPlainObject(c) ? I.merge({}, c) : I.isArray(c) ? c.slice() : c;
  }
  function a(d, c, u) {
    if (I.isUndefined(c)) {
      if (!I.isUndefined(d))
        return r(void 0, d, u);
    } else return r(d, c, u);
  }
  function s(d, c) {
    if (!I.isUndefined(c))
      return r(void 0, c);
  }
  function o(d, c) {
    if (I.isUndefined(c)) {
      if (!I.isUndefined(d))
        return r(void 0, d);
    } else return r(void 0, c);
  }
  function i(d, c, u) {
    if (u in t)
      return r(d, c);
    if (u in e)
      return r(void 0, d);
  }
  const l = {
    url: s,
    method: s,
    data: s,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: i,
    headers: (d, c) => a(Is(d), Is(c), !0)
  };
  return I.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const u = l[c] || a, f = u(e[c], t[c], c);
    I.isUndefined(f) && u !== i || (n[c] = f);
  }), n;
}
const ni = (e) => {
  const t = Ut({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: s, headers: o, auth: i } = t;
  t.headers = o = Ze.from(o), t.url = Xo(ti(t.baseURL, t.url), e.params, e.paramsSerializer), i && o.set(
    "Authorization",
    "Basic " + btoa((i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : ""))
  );
  let l;
  if (I.isFormData(n)) {
    if (Je.hasStandardBrowserEnv || Je.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [d, ...c] = l ? l.split(";").map((u) => u.trim()).filter(Boolean) : [];
      o.setContentType([d || "multipart/form-data", ...c].join("; "));
    }
  }
  if (Je.hasStandardBrowserEnv && (r && I.isFunction(r) && (r = r(t)), r || r !== !1 && Xf(t.url))) {
    const d = a && s && Jf.read(s);
    d && o.set(a, d);
  }
  return t;
}, e2 = typeof XMLHttpRequest < "u", t2 = e2 && function(e) {
  return new Promise(function(n, r) {
    const a = ni(e);
    let s = a.data;
    const o = Ze.from(a.headers).normalize();
    let { responseType: i, onUploadProgress: l, onDownloadProgress: d } = a, c, u, f, v, p;
    function m() {
      v && v(), p && p(), a.cancelToken && a.cancelToken.unsubscribe(c), a.signal && a.signal.removeEventListener("abort", c);
    }
    let g = new XMLHttpRequest();
    g.open(a.method.toUpperCase(), a.url, !0), g.timeout = a.timeout;
    function y() {
      if (!g)
        return;
      const $ = Ze.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), O = {
        data: !i || i === "text" || i === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: $,
        config: e,
        request: g
      };
      ei(function(w) {
        n(w), m();
      }, function(w) {
        r(w), m();
      }, O), g = null;
    }
    "onloadend" in g ? g.onloadend = y : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, g.onabort = function() {
      g && (r(new z("Request aborted", z.ECONNABORTED, e, g)), g = null);
    }, g.onerror = function() {
      r(new z("Network Error", z.ERR_NETWORK, e, g)), g = null;
    }, g.ontimeout = function() {
      let E = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const O = a.transitional || Jo;
      a.timeoutErrorMessage && (E = a.timeoutErrorMessage), r(new z(
        E,
        O.clarifyTimeoutError ? z.ETIMEDOUT : z.ECONNABORTED,
        e,
        g
      )), g = null;
    }, s === void 0 && o.setContentType(null), "setRequestHeader" in g && I.forEach(o.toJSON(), function(E, O) {
      g.setRequestHeader(O, E);
    }), I.isUndefined(a.withCredentials) || (g.withCredentials = !!a.withCredentials), i && i !== "json" && (g.responseType = a.responseType), d && ([f, p] = kn(d, !0), g.addEventListener("progress", f)), l && g.upload && ([u, v] = kn(l), g.upload.addEventListener("progress", u), g.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (c = ($) => {
      g && (r(!$ || $.type ? new Zt(null, e, g) : $), g.abort(), g = null);
    }, a.cancelToken && a.cancelToken.subscribe(c), a.signal && (a.signal.aborted ? c() : a.signal.addEventListener("abort", c)));
    const S = Yf(a.url);
    if (S && Je.protocols.indexOf(S) === -1) {
      r(new z("Unsupported protocol " + S + ":", z.ERR_BAD_REQUEST, e));
      return;
    }
    g.send(s || null);
  });
}, n2 = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), a;
    const s = function(d) {
      if (!a) {
        a = !0, i();
        const c = d instanceof Error ? d : this.reason;
        r.abort(c instanceof z ? c : new Zt(c instanceof Error ? c.message : c));
      }
    };
    let o = t && setTimeout(() => {
      o = null, s(new z(`timeout ${t} of ms exceeded`, z.ETIMEDOUT));
    }, t);
    const i = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(s) : d.removeEventListener("abort", s);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", s));
    const { signal: l } = r;
    return l.unsubscribe = () => I.asap(i), l;
  }
}, r2 = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + t, yield e.slice(r, a), r = a;
}, a2 = async function* (e, t) {
  for await (const n of s2(e))
    yield* r2(n, t);
}, s2 = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, Ps = (e, t, n, r) => {
  const a = a2(e, t);
  let s = 0, o, i = (l) => {
    o || (o = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: d, value: c } = await a.next();
        if (d) {
          i(), l.close();
          return;
        }
        let u = c.byteLength;
        if (n) {
          let f = s += u;
          n(f);
        }
        l.enqueue(new Uint8Array(c));
      } catch (d) {
        throw i(d), d;
      }
    },
    cancel(l) {
      return i(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Yn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", ri = Yn && typeof ReadableStream == "function", o2 = Yn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), ai = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, i2 = ri && ai(() => {
  let e = !1;
  const t = new Request(Je.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), As = 64 * 1024, Ir = ri && ai(() => I.isReadableStream(new Response("").body)), Dn = {
  stream: Ir && ((e) => e.body)
};
Yn && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Dn[t] && (Dn[t] = I.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new z(`Response type '${t}' is not supported`, z.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const l2 = async (e) => {
  if (e == null)
    return 0;
  if (I.isBlob(e))
    return e.size;
  if (I.isSpecCompliantForm(e))
    return (await new Request(Je.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (I.isArrayBufferView(e) || I.isArrayBuffer(e))
    return e.byteLength;
  if (I.isURLSearchParams(e) && (e = e + ""), I.isString(e))
    return (await o2(e)).byteLength;
}, d2 = async (e, t) => {
  const n = I.toFiniteNumber(e.getContentLength());
  return n ?? l2(t);
}, u2 = Yn && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: a,
    cancelToken: s,
    timeout: o,
    onDownloadProgress: i,
    onUploadProgress: l,
    responseType: d,
    headers: c,
    withCredentials: u = "same-origin",
    fetchOptions: f
  } = ni(e);
  d = d ? (d + "").toLowerCase() : "text";
  let v = n2([a, s && s.toAbortSignal()], o), p;
  const m = v && v.unsubscribe && (() => {
    v.unsubscribe();
  });
  let g;
  try {
    if (l && i2 && n !== "get" && n !== "head" && (g = await d2(c, r)) !== 0) {
      let O = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), _;
      if (I.isFormData(r) && (_ = O.headers.get("content-type")) && c.setContentType(_), O.body) {
        const [w, k] = Ns(
          g,
          kn(Ls(l))
        );
        r = Ps(O.body, As, w, k);
      }
    }
    I.isString(u) || (u = u ? "include" : "omit");
    const y = "credentials" in Request.prototype;
    p = new Request(t, {
      ...f,
      signal: v,
      method: n.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: y ? u : void 0
    });
    let S = await fetch(p);
    const $ = Ir && (d === "stream" || d === "response");
    if (Ir && (i || $ && m)) {
      const O = {};
      ["status", "statusText", "headers"].forEach((C) => {
        O[C] = S[C];
      });
      const _ = I.toFiniteNumber(S.headers.get("content-length")), [w, k] = i && Ns(
        _,
        kn(Ls(i), !0)
      ) || [];
      S = new Response(
        Ps(S.body, As, w, () => {
          k && k(), m && m();
        }),
        O
      );
    }
    d = d || "text";
    let E = await Dn[I.findKey(Dn, d) || "text"](S, e);
    return !$ && m && m(), await new Promise((O, _) => {
      ei(O, _, {
        data: E,
        headers: Ze.from(S.headers),
        status: S.status,
        statusText: S.statusText,
        config: e,
        request: p
      });
    });
  } catch (y) {
    throw m && m(), y && y.name === "TypeError" && /fetch/i.test(y.message) ? Object.assign(
      new z("Network Error", z.ERR_NETWORK, e, p),
      {
        cause: y.cause || y
      }
    ) : z.from(y, y && y.code, e, p);
  }
}), Pr = {
  http: Tf,
  xhr: t2,
  fetch: u2
};
I.forEach(Pr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ks = (e) => `- ${e}`, c2 = (e) => I.isFunction(e) || e === null || e === !1, si = {
  getAdapter: (e) => {
    e = I.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const a = {};
    for (let s = 0; s < t; s++) {
      n = e[s];
      let o;
      if (r = n, !c2(n) && (r = Pr[(o = String(n)).toLowerCase()], r === void 0))
        throw new z(`Unknown adapter '${o}'`);
      if (r)
        break;
      a[o || "#" + s] = r;
    }
    if (!r) {
      const s = Object.entries(a).map(
        ([i, l]) => `adapter ${i} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? s.length > 1 ? `since :
` + s.map(ks).join(`
`) : " " + ks(s[0]) : "as no adapter specified";
      throw new z(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Pr
};
function ir(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Zt(null, e);
}
function Ds(e) {
  return ir(e), e.headers = Ze.from(e.headers), e.data = or.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), si.getAdapter(e.adapter || vn.adapter)(e).then(function(r) {
    return ir(e), r.data = or.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Ze.from(r.headers), r;
  }, function(r) {
    return Qo(r) || (ir(e), r && r.response && (r.response.data = or.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Ze.from(r.response.headers))), Promise.reject(r);
  });
}
const oi = "1.7.7", sa = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  sa[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Rs = {};
sa.transitional = function(t, n, r) {
  function a(s, o) {
    return "[Axios v" + oi + "] Transitional option '" + s + "'" + o + (r ? ". " + r : "");
  }
  return (s, o, i) => {
    if (t === !1)
      throw new z(
        a(o, " has been removed" + (n ? " in " + n : "")),
        z.ERR_DEPRECATED
      );
    return n && !Rs[o] && (Rs[o] = !0, console.warn(
      a(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(s, o, i) : !0;
  };
};
function f2(e, t, n) {
  if (typeof e != "object")
    throw new z("options must be an object", z.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let a = r.length;
  for (; a-- > 0; ) {
    const s = r[a], o = t[s];
    if (o) {
      const i = e[s], l = i === void 0 || o(i, s, e);
      if (l !== !0)
        throw new z("option " + s + " must be " + l, z.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new z("Unknown option " + s, z.ERR_BAD_OPTION);
  }
}
const Ar = {
  assertOptions: f2,
  validators: sa
}, Nt = Ar.validators;
class Rt {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Ss(),
      response: new Ss()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let a;
        Error.captureStackTrace ? Error.captureStackTrace(a = {}) : a = new Error();
        const s = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Ut(this.defaults, n);
    const { transitional: r, paramsSerializer: a, headers: s } = n;
    r !== void 0 && Ar.assertOptions(r, {
      silentJSONParsing: Nt.transitional(Nt.boolean),
      forcedJSONParsing: Nt.transitional(Nt.boolean),
      clarifyTimeoutError: Nt.transitional(Nt.boolean)
    }, !1), a != null && (I.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : Ar.assertOptions(a, {
      encode: Nt.function,
      serialize: Nt.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = s && I.merge(
      s.common,
      s[n.method]
    );
    s && I.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete s[p];
      }
    ), n.headers = Ze.concat(o, s);
    const i = [];
    let l = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (l = l && m.synchronous, i.unshift(m.fulfilled, m.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(m) {
      d.push(m.fulfilled, m.rejected);
    });
    let c, u = 0, f;
    if (!l) {
      const p = [Ds.bind(this), void 0];
      for (p.unshift.apply(p, i), p.push.apply(p, d), f = p.length, c = Promise.resolve(n); u < f; )
        c = c.then(p[u++], p[u++]);
      return c;
    }
    f = i.length;
    let v = n;
    for (u = 0; u < f; ) {
      const p = i[u++], m = i[u++];
      try {
        v = p(v);
      } catch (g) {
        m.call(this, g);
        break;
      }
    }
    try {
      c = Ds.call(this, v);
    } catch (p) {
      return Promise.reject(p);
    }
    for (u = 0, f = d.length; u < f; )
      c = c.then(d[u++], d[u++]);
    return c;
  }
  getUri(t) {
    t = Ut(this.defaults, t);
    const n = ti(t.baseURL, t.url);
    return Xo(n, t.params, t.paramsSerializer);
  }
}
I.forEach(["delete", "get", "head", "options"], function(t) {
  Rt.prototype[t] = function(n, r) {
    return this.request(Ut(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
I.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(s, o, i) {
      return this.request(Ut(i || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: o
      }));
    };
  }
  Rt.prototype[t] = n(), Rt.prototype[t + "Form"] = n(!0);
});
class oa {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners) return;
      let s = r._listeners.length;
      for (; s-- > 0; )
        r._listeners[s](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let s;
      const o = new Promise((i) => {
        r.subscribe(i), s = i;
      }).then(a);
      return o.cancel = function() {
        r.unsubscribe(s);
      }, o;
    }, t(function(s, o, i) {
      r.reason || (r.reason = new Zt(s, o, i), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new oa(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
}
function p2(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function m2(e) {
  return I.isObject(e) && e.isAxiosError === !0;
}
const kr = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(kr).forEach(([e, t]) => {
  kr[t] = e;
});
function ii(e) {
  const t = new Rt(e), n = xo(Rt.prototype.request, t);
  return I.extend(n, Rt.prototype, t, { allOwnKeys: !0 }), I.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(a) {
    return ii(Ut(e, a));
  }, n;
}
const Ee = ii(vn);
Ee.Axios = Rt;
Ee.CanceledError = Zt;
Ee.CancelToken = oa;
Ee.isCancel = Qo;
Ee.VERSION = oi;
Ee.toFormData = Kn;
Ee.AxiosError = z;
Ee.Cancel = Ee.CanceledError;
Ee.all = function(t) {
  return Promise.all(t);
};
Ee.spread = p2;
Ee.isAxiosError = m2;
Ee.mergeConfig = Ut;
Ee.AxiosHeaders = Ze;
Ee.formToJSON = (e) => Zo(I.isHTMLForm(e) ? new FormData(e) : e);
Ee.getAdapter = si.getAdapter;
Ee.HttpStatusCode = kr;
Ee.default = Ee;
const h2 = {
  key: 0,
  class: "t-transp mn-r-small"
}, $2 = {
  key: 1,
  class: "flex-nowrap flex w-100 flex-v-center"
}, g2 = ["href"], v2 = {
  key: 2,
  class: "w-100"
}, y2 = ["placeholder", "multiple"], b2 = {
  key: 0,
  class: "mn-t-thin mn-b-thin invalid-feedback"
}, _2 = {
  __name: "Upload",
  props: {
    field: String,
    label: null,
    type: {
      type: String,
      default: "file"
    },
    placeholder: "Upload a file",
    validation: !1,
    uploadPath: {
      type: String,
      default: "/files"
    },
    multiple: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:field", "focus", "blur", "file-change"],
  setup(e, { emit: t }) {
    const n = t, r = e, a = F(r.field);
    F(null), Te(() => r.field, (i) => {
      a.value = i;
    });
    async function s(i) {
      let l = i.target.files[0], d = new FormData();
      d.append("file", l);
      try {
        let u = await Ee.create({ baseURL: process.env.API_URL, withCredentials: !0 }).post(`/api/upload/${r.type}?folderName=${encodeURIComponent(r.uploadPath)}`, d, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        a.value = u.data[0].filepath, n("file-change", a.value);
      } catch (c) {
        console.error(c);
      }
    }
    const o = () => {
      a.value = null, n("update:field", null), n("file-change", null);
    };
    return (i, l) => (T(), L(pe, null, [
      P("div", {
        class: X([[i.$attrs.class, { "bg-fourth-nano": e.validation }], "flex-center flex-nowrap flex"])
      }, [
        e.label ? (T(), L("div", h2, [
          P("span", null, W(e.label), 1)
        ])) : V("", !0),
        a.value ? (T(), L("div", $2, [
          P("a", {
            href: a.value,
            class: "w-100",
            target: "_blank"
          }, W(a.value), 9, g2),
          Q(ta, {
            onClick: o,
            class: "cursor-pointer t-center flex-center flex radius-extra i-medium bg-red pd-micro"
          })
        ])) : (T(), L("div", v2, [
          P("input", {
            onChange: s,
            type: "file",
            class: "w-100",
            placeholder: e.placeholder,
            multiple: e.multiple,
            id: "photo",
            name: "photo"
          }, null, 40, y2)
        ]))
      ], 2),
      Q(xe, {
        mode: "out-in",
        name: "fade"
      }, {
        default: fe(() => [
          e.validation ? (T(), L("div", b2, " * " + W(e.validation.message), 1)) : V("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}, E2 = /* @__PURE__ */ $t(_2, [["__scopeId", "data-v-516f3e07"]]), O2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E2
}, Symbol.toStringTag, { value: "Module" })), C2 = ["src"], T2 = {
  key: 1,
  class: "flex-v-center flex-h-center flex w-100 h-100 bg-second"
}, S2 = {
  __name: "UploadImage",
  props: [
    "uploadPath",
    // only necessary prop
    "photo"
    // new prop for holding the image url
  ],
  emits: ["update:photo", "error"],
  setup(e, { emit: t }) {
    const n = F(null), r = F(null), a = e, s = t;
    Te(a, ({ photo: d }) => {
      d && (n.value = d);
    });
    function o() {
      r.value.click();
    }
    async function i(d) {
      let c = d.target.files[0];
      if (!c) {
        console.error("No file selected");
        return;
      }
      let u = new FormData();
      u.append("file", c), console.log("Sending file:", c.name);
      try {
        let v = await Ee.create({ baseURL: process.env.API_URL, withCredentials: !0 }).post(`/api/upload/multiple?folderName=${encodeURIComponent(a.uploadPath)}`, u);
        console.log("Upload response:", v), n.value = v.data[0].filepath, s("update:photo", n.value);
      } catch (f) {
        s("error", f), console.error("Upload error:", f);
      }
    }
    function l(d) {
      d.preventDefault(), i({
        target: {
          files: d.dataTransfer.files
        }
      });
    }
    return (d, c) => (T(), L("div", {
      onClick: o,
      onDrop: l,
      onDragover: c[0] || (c[0] = le(() => {
      }, ["prevent"])),
      class: "image-upload-area flex-v-center flex-h-center flex"
    }, [
      n.value || e.photo ? (T(), L("img", {
        key: 0,
        loading: "lazy",
        src: (d.FILE_SERVER_URL || "") + (n.value || e.photo),
        alt: "Uploaded image",
        class: "w-100 h-100 object-fit-cover"
      }, null, 8, C2)) : (T(), L("div", T2, c[1] || (c[1] = [
        P("svg", {
          class: "i-medium",
          width: "104",
          height: "104",
          viewBox: "0 0 104 104",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          P("path", {
            fill: "rgb(var(--white))",
            d: "M21.2784 37.2973C18.8466 34.6628 18.8466 30.6098 21.2784 27.9753L47.2179 2.03584C48.6364 0.81993 50.2577 0.211974 51.8789 0.211974C53.5001 0.211974 55.1213 0.81993 56.5399 2.03584L82.4793 27.9753C84.9111 30.6098 84.9111 34.6628 82.4793 37.2973C79.8448 39.7291 75.7918 39.7291 73.1573 37.2973L58.3637 22.301V71.5454C58.3637 75.1932 55.5266 78.0303 51.8789 78.0303C48.2311 78.0303 45.394 75.1932 45.394 71.5454V22.301L30.6004 37.2973C27.966 39.7291 23.9129 39.7291 21.2784 37.2973ZM97.2729 71.5454C100.921 71.5454 103.758 74.3825 103.758 78.0303V97.4849C103.758 101.133 100.921 103.97 97.2729 103.97H6.48486C2.83713 103.97 0 101.133 0 97.4849V78.0303C0 74.3825 2.83713 71.5454 6.48486 71.5454H38.9092C38.9092 78.6382 44.7861 84.5151 51.8789 84.5151C58.9717 84.5151 64.8486 78.6382 64.8486 71.5454H97.2729ZM87.5456 92.6212C90.1801 92.6212 92.4092 90.392 92.4092 87.7576C92.4092 85.1231 90.1801 82.8939 87.5456 82.8939C84.9111 82.8939 82.682 85.1231 82.682 87.7576C82.682 90.392 84.9111 92.6212 87.5456 92.6212Z"
          })
        ], -1)
      ]))),
      P("input", {
        type: "file",
        name: "file",
        ref_key: "fileInput",
        ref: r,
        onChange: i,
        style: { display: "none" }
      }, null, 544)
    ], 32));
  }
}, w2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S2
}, Symbol.toStringTag, { value: "Module" })), N2 = {
  width: "49",
  height: "35",
  viewBox: "0 0 49 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, L2 = ["fill"], I2 = ["fill"], P2 = {
  __name: "IconUpload",
  props: {
    fill: {
      type: String,
      default: "rgb(var(--black))"
    }
  },
  setup(e) {
    return (t, n) => (T(), L("svg", N2, [
      P("path", {
        fill: e.fill,
        d: "M18.0196 16.645C17.3501 17.3144 17.3501 18.3999 18.0196 19.0693C18.689 19.7388 19.7745 19.7388 20.4439 19.0693L22.6603 16.8529V26.4286C22.6603 27.3754 23.4278 28.1429 24.3746 28.1429C25.3214 28.1429 26.0889 27.3754 26.0889 26.4286V16.8529L28.3053 19.0693C28.9747 19.7388 30.0602 19.7388 30.7296 19.0693C31.399 18.3999 31.399 17.3144 30.7296 16.645L25.5868 11.5021C24.9173 10.8327 23.8318 10.8327 23.1624 11.5021L18.0196 16.645Z"
      }, null, 8, L2),
      P("path", {
        fill: e.fill,
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M24.3746 0.714294C16.9516 0.714294 10.7548 5.95521 9.27936 12.9394C4.19731 13.976 0.374592 18.4695 0.374592 23.8572C0.374592 30.0113 5.36342 35 11.5174 35H37.2317C43.3857 35 48.3746 30.0113 48.3746 23.8572C48.3746 18.4695 44.5519 13.976 39.4699 12.9394C37.9944 5.95521 31.7976 0.714294 24.3746 0.714294ZM12.4643 14.6667C13.1906 8.73646 18.2474 4.14287 24.3746 4.14287C30.5018 4.14287 35.5586 8.73646 36.2849 14.6667C36.384 15.4757 37.0387 16.1029 37.8511 16.1672C41.821 16.4818 44.946 19.8053 44.946 23.8572C44.946 28.1177 41.4922 31.5714 37.2317 31.5714H11.5174C7.25697 31.5714 3.80316 28.1177 3.80316 23.8572C3.80316 19.8053 6.92808 16.4818 10.8981 16.1672C11.7104 16.1029 12.3652 15.4757 12.4643 14.6667Z"
      }, null, 8, I2)
    ]));
  }
}, A2 = {
  key: 0,
  class: "t-center"
}, k2 = {
  key: 0,
  class: "mn-t-thin mn-b-thin d-block h3 t-black"
}, D2 = {
  key: 1,
  class: "mn-b-thin t-transp d-block"
}, R2 = {
  key: 2,
  class: "mn-b-thin uppercase p-small t-medium d-block"
}, F2 = {
  key: 3,
  class: "cursor-pointer mn-b-small br-2px br-main br-solid radius-extra pd-l-thin pd-r-thin t-main"
}, M2 = {
  key: 4,
  class: "uppercase p-small t-medium d-block"
}, x2 = {
  __name: "UploadImageMultiple",
  props: {
    uploadPath: {
      type: Object,
      required: !0
    },
    options: {
      type: Object,
      default: () => ({
        mimeType: ["jpg", "png", "gif"],
        maxSize: 10 * 1024 * 1024,
        showText: !0,
        showTitle: !0
      })
    },
    text: {
      type: Object,
      default: () => ({
        title: "Drag & Drop Your Images Here",
        subtitle: "Files supported: JPG, PNG, GIF"
      })
    }
  },
  emits: ["update:images"],
  setup(e, { emit: t }) {
    const n = F([]), r = F(!1), a = F(null), s = e, o = t;
    function i() {
      a.value.click();
    }
    async function l(c) {
      r.value = !0;
      let u = c.target.files, f = new FormData();
      for (const v of u)
        f.append("file", v);
      try {
        (await Ee.create({ baseURL: process.env.API_URL, withCredentials: !0 }).post(`/api/upload/multiple?folderName=${encodeURIComponent(s.uploadPath)}`, f, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })).data.forEach((m) => {
          n.value.push(m.filepath);
        }), o("update:images", n.value), r.value = !1;
      } catch (v) {
        console.error(v), r.value = !1;
      }
    }
    function d(c) {
      c.preventDefault(), l({
        target: {
          files: c.dataTransfer.files
        }
      });
    }
    return (c, u) => (T(), L("div", {
      onClick: i,
      onDrop: d,
      onDragover: u[0] || (u[0] = le(() => {
      }, ["prevent"])),
      class: "cursor-pointer t-black w-100 flex-v-center flex-h-center flex pos-relative"
    }, [
      Q(xe, {
        name: "moveFromTop",
        mode: "out-in"
      }, {
        default: fe(() => [
          r.value ? (T(), Le($n, {
            key: 1,
            class: "pos-absolute"
          })) : (T(), L("div", A2, [
            Q(P2, {
              style: { "max-height": "4rem" },
              class: "w-100 h-100",
              fill: "rgb(var(--main))"
            }),
            e.options.showText || e.options.showTitle ? (T(), L("span", k2, W(e.text.title), 1)) : V("", !0),
            e.options.showText ? (T(), L("span", D2, W(e.text.subtitle), 1)) : V("", !0),
            e.options.showText ? (T(), L("span", R2, "or")) : V("", !0),
            e.options.showText ? (T(), L("button", F2, "Browse Files")) : V("", !0),
            e.options.showText ? (T(), L("span", M2, "Maximum size: 2MB")) : V("", !0)
          ]))
        ]),
        _: 1
      }),
      P("input", {
        type: "file",
        ref_key: "fileInput",
        ref: a,
        onChange: l,
        multiple: "",
        style: { display: "none" }
      }, null, 544)
    ], 32));
  }
}, U2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: x2
}, Symbol.toStringTag, { value: "Module" })), B2 = {
  class: "breadcrumbs flex-row flex-nowrap flex-left flex",
  "aria-label": "breadcrumbs"
}, V2 = {
  key: 0,
  class: "i-small mn-r-thin",
  viewBox: "0 0 10 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j2 = { key: 2 }, H2 = {
  key: 3,
  class: "i-small chevron",
  viewBox: "0 0 4 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G2 = {
  __name: "Breadcrumbs",
  setup(e) {
    const t = no(), { t: n, locale: r } = Xt();
    function a(i, l) {
      return i.map((d) => {
        if (d.startsWith(":")) {
          let c = d.replace(/[:?]/g, "");
          return l.params[c] || null;
        }
        return d;
      }).filter((d) => d !== null).join("/");
    }
    const s = F([]);
    function o() {
      s.value = t.matched.map((i) => {
        var v, p, m;
        const l = (v = i.meta) == null ? void 0 : v.title, d = r == null ? void 0 : r.value, c = l && d && l[d];
        let u = i.path.split("/");
        u = a(u, t);
        const f = (m = (p = i.meta) == null ? void 0 : p.breadcrumbs) == null ? void 0 : m.hidden;
        return { name: c, path: u, isHidden: f };
      }).filter((i) => i.name && !i.isHidden);
    }
    return Te(
      () => t.matched,
      () => {
        o();
      },
      { immediate: !0 }
    ), (i, l) => {
      const d = Ks("router-link");
      return T(), L("ol", B2, [
        (T(!0), L(pe, null, De(s.value, (c, u) => (T(), L("li", {
          key: u,
          class: X(["flex-v-center flex-nowrap flex", { "t-main": u === s.value.length - 1 }])
        }, [
          u === 0 ? (T(), L("svg", V2, l[0] || (l[0] = [
            P("path", {
              fill: "rgb(var(--black))",
              d: "M0.494141 4.26391C0.494141 4.48862 0.659906 4.66912 0.928813 4.66912C1.05037 4.66912 1.16825 4.6065 1.27139 4.52177L1.64344 4.20866V7.56448C1.64344 8.13545 1.98971 8.47803 2.5791 8.47803H7.56678C8.15616 8.47803 8.50243 8.13545 8.50243 7.56448V4.19392L8.8929 4.52177C8.99604 4.6065 9.11392 4.66912 9.23916 4.66912C9.48597 4.66912 9.67015 4.5144 9.67015 4.27128C9.67015 4.1313 9.61121 4.01343 9.5007 3.92133L8.50243 3.08146V1.47538C8.50243 1.30961 8.3956 1.1991 8.22984 1.1991H7.63308C7.46732 1.1991 7.35313 1.30961 7.35313 1.47538V2.11634L5.66969 0.70181C5.31606 0.403433 4.85928 0.403433 4.50197 0.70181L0.663589 3.92133C0.553079 4.01711 0.494141 4.14235 0.494141 4.26391ZM6.13752 5.26219C6.13752 5.08906 6.02701 4.97855 5.85387 4.97855H4.31779C4.14097 4.97855 4.02678 5.08906 4.02678 5.26219V7.63447H2.83327C2.60856 7.63447 2.48332 7.50922 2.48332 7.28084V3.5014L4.90349 1.47538C5.01768 1.37592 5.15029 1.37592 5.26817 1.47538L7.66255 3.48298V7.28084C7.66255 7.50922 7.53731 7.63447 7.3126 7.63447H6.13752V5.26219Z"
            }, null, -1)
          ]))) : V("", !0),
          u !== s.value.length - 1 ? (T(), Le(d, {
            key: 1,
            to: u === 0 ? "/" : c.path
          }, {
            default: fe(() => [
              mt(W(c.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])) : (T(), L("a", j2, W(c.name), 1)),
          u !== s.value.length - 1 ? (T(), L("svg", H2, l[1] || (l[1] = [
            P("path", {
              d: "M4 3.99992C4 3.83673 3.94307 3.70391 3.81025 3.57867L0.899431 0.732369C0.800759 0.629902 0.679317 0.580566 0.531309 0.580566C0.239089 0.580566 0 0.815861 0 1.10808C0 1.25229 0.0607211 1.38512 0.166983 1.49138L2.74763 3.99613L0.166983 6.50846C0.0607211 6.61093 0 6.74375 0 6.89176C0 7.18398 0.239089 7.41928 0.531309 7.41928C0.675522 7.41928 0.800759 7.36994 0.899431 7.26747L3.81025 4.42117C3.94307 4.29594 4 4.15931 4 3.99992Z",
              fill: "rgb(var(--black))"
            }, null, -1)
          ]))) : V("", !0)
        ], 2))), 128))
      ]);
    };
  }
}, W2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G2
}, Symbol.toStringTag, { value: "Module" })), K2 = { class: "t-trimmed font-main" }, Y2 = { class: "font-main t-truncate" }, q2 = {
  key: 1,
  class: "pd-b-micro pd-t-micro pd-r-thin pd-l-thin radius-small t-semi bg-white"
}, z2 = {
  __name: "Chips",
  props: ["chips"],
  setup(e) {
    return (t, n) => {
      var r;
      return T(), L("div", K2, [
        (r = e.chips) != null && r.length ? (T(!0), L(pe, { key: 0 }, De(e.chips, (a, s) => (T(), L("span", {
          class: X([t.$attrs.class || "p-medium", "mn-r-nano d-inline-block w-max pd-b-micro pd-t-micro pd-r-thin pd-l-thin radius-small t-medium bg-main"])
        }, [
          P("span", Y2, W(a.text ? a.text : a), 1)
        ], 2))), 256)) : (T(), L("div", q2, [
          J(t.$slots, "default")
        ]))
      ]);
    };
  }
}, X2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z2
}, Symbol.toStringTag, { value: "Module" })), J2 = { class: "gap-thin flex-nowrap flex flex-center" }, Z2 = {
  key: 0,
  class: "flex-child-grow-1 flex-child-shrink-0 flex-child-basis-auto pd-medium bg-blur-small bg-white-transp-5 radius-small"
}, Q2 = {
  key: 1,
  class: "flex-child-grow-1 flex-child-shrink-0 flex-child-basis-auto pd-nano bg-blur-small bg-white-transp-5 radius-small"
}, e3 = { class: "p-big" }, t3 = {
  key: 2,
  class: "flex-child-grow-1 flex-child-shrink-0 flex-child-basis-auto pd-nano bg-blur-small bg-white-transp-5 radius-small"
}, n3 = { class: "p-big" }, r3 = {
  key: 3,
  class: "flex-child-grow-1 flex-child-shrink-0 flex-child-basis-auto pd-nano bg-blur-small bg-white-transp-5 radius-small"
}, a3 = { class: "p-big" }, s3 = {
  key: 4,
  class: "flex-child-grow-1 flex-child-shrink-0 flex-child-basis-auto pd-nano bg-blur-small bg-white-transp-5 radius-small"
}, o3 = { class: "p-big" }, i3 = {
  __name: "Countdown",
  props: [
    "date"
  ],
  setup(e) {
    const t = e, n = new Date(t.date).getTime(), r = F((/* @__PURE__ */ new Date()).getTime());
    let a;
    const s = F(0), o = F(0), i = F(0), l = F(0), d = F(!1), c = () => {
      const u = n - r.value;
      u <= 0 ? (s.value = 0, o.value = 0, i.value = 0, l.value = 0, d.value = !0, clearInterval(a)) : (s.value = Math.floor(u / (1e3 * 60 * 60 * 24)), o.value = Math.floor(u % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)), i.value = Math.floor(u % (1e3 * 60 * 60) / (1e3 * 60)), l.value = Math.floor(u % (1e3 * 60) / 1e3));
    };
    return c(), Qe(() => {
      a = setInterval(() => {
        r.value = (/* @__PURE__ */ new Date()).getTime(), c();
      }, 1e3);
    }), Br(() => {
      clearInterval(a);
    }), (u, f) => (T(), L("div", J2, [
      d.value ? (T(), L("div", Z2, f[0] || (f[0] = [
        P("p", { class: "p-small t-transp" }, "Offer is over", -1)
      ]))) : V("", !0),
      d.value ? V("", !0) : (T(), L("div", Q2, [
        P("p", e3, W(s.value), 1),
        f[1] || (f[1] = P("p", { class: "p-small t-transp" }, "Days", -1))
      ])),
      d.value ? V("", !0) : (T(), L("div", t3, [
        P("p", n3, W(o.value), 1),
        f[2] || (f[2] = P("p", { class: "p-small t-transp" }, "hours", -1))
      ])),
      d.value ? V("", !0) : (T(), L("div", r3, [
        P("p", a3, W(i.value), 1),
        f[3] || (f[3] = P("p", { class: "p-small t-transp" }, "minutes", -1))
      ])),
      d.value ? V("", !0) : (T(), L("div", s3, [
        P("p", o3, W(l.value), 1),
        f[4] || (f[4] = P("p", { class: "p-small t-transp" }, "seconds", -1))
      ]))
    ]));
  }
}, l3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: i3
}, Symbol.toStringTag, { value: "Module" })), d3 = ["onClick"], u3 = { class: "t-transp" }, c3 = {
  __name: "DatePicker",
  props: ["date", "locale"],
  setup(e, { emit: t }) {
    const n = t, r = e, a = F(null);
    let s;
    if (r.date) {
      const f = parseInt(r.date.substring(0, 2)), v = parseInt(r.date.substring(2, 4)) - 1, p = parseInt(r.date.substring(4));
      s = new Date(p, v, f), console.log("Data" + s);
    } else
      s = /* @__PURE__ */ new Date(), console.log("No data" + s);
    s.setHours(0, 0, 0, 0);
    const o = F(new Date(s)), i = u(s, 30);
    Qe(() => {
      if (a.value) {
        const f = a.value.getElementsByClassName("selected")[0] || a.value.getElementsByClassName("bg-main")[0];
        f && (a.value.scrollLeft = f.offsetLeft - a.value.offsetWidth / 2 + f.offsetWidth / 2);
      }
    });
    function l(f) {
      o.value = f;
      const v = d(f);
      n("update:date", v);
    }
    function d(f) {
      return `${f.getDate().toString().padStart(2, "0")}${(f.getMonth() + 1).toString().padStart(2, "0")}${f.getFullYear()}`;
    }
    function c(f) {
      return f.toLocaleDateString(r.locale ? r.locale : "en", { weekday: "narrow" }).toUpperCase();
    }
    function u(f, v) {
      const p = [];
      for (let m = -15; m < v - 15; m++) {
        const g = new Date(f);
        g.setDate(f.getDate() + m), g.setHours(0, 0, 0, 0), p.push(g);
      }
      return p;
    }
    return (f, v) => (T(), L("div", null, [
      P("div", {
        class: "w-100 scroller o-scroll scroll-snap-type-x-mandatory scroll-pd-regular scroll-hide flex-nowrap flex",
        ref_key: "scrollContainer",
        ref: a
      }, [
        (T(!0), L(pe, null, De(We(i), (p) => (T(), L("div", {
          key: p.toString(),
          onClick: (m) => l(p),
          class: X([{
            selected: o.value.toDateString() === p.toDateString()
          }, "cursor-pointer scroll-snap-align-start mn-r-small mn-l-small flex-column flex-center flex"])
        }, [
          P("span", u3, W(c(p)), 1),
          P("span", {
            class: X([{
              "bg-main": o.value.toDateString() === p.toDateString()
            }, "transition-ease-in-out t-semi flex-center flex radius-big i-semi day-number"])
          }, W(p.getDate()), 3)
        ], 10, d3))), 128))
      ], 512)
    ]));
  }
}, f3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c3
}, Symbol.toStringTag, { value: "Module" })), p3 = { class: "mn-b-regular" }, m3 = { class: "mn-b-small t-transp p-medium" }, li = {
  __name: "EmptyState",
  props: {
    title: {
      type: String,
      default: "У вас еще нет организации"
    },
    description: {
      type: String,
      default: "Для использования сервиса, вам необходимо добавить вашу организацию."
    },
    action: {
      type: String
    },
    callback: {
      type: Function,
      default: () => {
      }
    }
  },
  setup(e) {
    return (t, n) => (T(), L("section", null, [
      P("h3", p3, W(e.title), 1),
      P("p", m3, W(e.description), 1),
      e.action ? (T(), L("button", {
        key: 0,
        onClick: n[0] || (n[0] = (...r) => e.callback && e.callback(...r)),
        class: "t-white bg-second w-100 button"
      }, W(e.action), 1)) : V("", !0)
    ]));
  }
}, h3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: li
}, Symbol.toStringTag, { value: "Module" })), $3 = {}, g3 = {
  width: "100%",
  height: "16rem",
  xmlns: "http://www.w3.org/2000/svg"
};
function v3(e, t) {
  return T(), L("svg", g3, t[0] || (t[0] = [
    Oi('<rect x="0" y="0" rx="5" ry="5" width="100%" height="100%" fill="rgb(var(--light))"></rect><rect x="15" y="15" rx="4" ry="4" width="40%" height="20" fill="rgba(var(--black),0.05)"></rect><rect x="15" y="45" rx="5" ry="5" width="70%" height="50" fill="rgba(var(--black),0.05)"></rect><rect x="15" y="110" rx="3" ry="3" width="90%" height="6" fill="rgba(var(--black),0.05)"></rect><rect x="15" y="130" rx="3" ry="3" width="70%" height="6" fill="rgba(var(--black),0.05)"></rect><rect x="-25%" y="0" width="25%" height="100%" fill="rgb(var(--white))" mask="url(#myMask)" opacity="0.3"><animate attributeName="x" from="-25%" to="100%" dur="2s" repeatCount="indefinite"></animate></rect>', 6)
  ]));
}
const y3 = /* @__PURE__ */ $t($3, [["render", v3]]), b3 = { class: "calendar" }, _3 = {
  key: 0,
  class: "br-b br-solid br-grey-transp-25 gap-thin flex flex-nowrap pd-thin"
}, E3 = { class: "pd-thin flex flex-nowrap flex-v-center flex-justify-between" }, O3 = { class: "t-semi" }, C3 = { class: "pd-thin calendar__body" }, T3 = { class: "calendar__week" }, S3 = { class: "gap-micro calendar__dates" }, w3 = ["onClick"], N3 = {
  __name: "Calendar",
  props: /* @__PURE__ */ sn({
    modelValue: [Date, Object],
    allowRange: Boolean
  }, {
    date: {},
    dateModifiers: {}
  }),
  emits: /* @__PURE__ */ sn(["update:modelValue"], ["update:date"]),
  setup(e, { emit: t }) {
    const n = e, r = bt(e, "date"), s = F(/* @__PURE__ */ new Date()), o = F(null), i = F(null), l = F(null), d = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], c = (C) => new Date(Date.UTC(C.getFullYear(), C.getMonth(), C.getDate())), u = (C) => new Date(Date.UTC(C.getFullYear(), C.getMonth(), C.getDate(), 23, 59, 59)), f = ae(() => {
      const C = s.value.toLocaleString("default", { month: "long", timeZone: "UTC" }), M = s.value.getUTCFullYear();
      return `${C} ${M}`;
    }), v = ae(() => {
      const C = [], M = new Date(Date.UTC(
        s.value.getUTCFullYear(),
        s.value.getUTCMonth(),
        1
      )), U = new Date(Date.UTC(
        s.value.getUTCFullYear(),
        s.value.getUTCMonth() + 1,
        0
      )), j = M.getUTCDay();
      let Y = new Date(M);
      Y.setUTCDate(Y.getUTCDate() - j);
      for (let de = 0; de < j; de++)
        C.push({
          date: new Date(Y),
          day: Y.getUTCDate(),
          isToday: p(Y)
        }), Y.setUTCDate(Y.getUTCDate() + 1);
      let $e = 1;
      for (Y = M; Y <= U; Y.setUTCDate(Y.getUTCDate() + 1))
        C.push({
          date: new Date(Y),
          day: $e,
          isToday: p(Y)
        }), $e++;
      const Se = C[C.length - 1].date.getUTCDay();
      for (let de = Se + 1; de <= 6; de++)
        C.push({
          date: new Date(Y),
          day: Y.getUTCDate(),
          isToday: p(Y)
        }), Y.setUTCDate(Y.getUTCDate() + 1);
      return C;
    }), p = (C) => {
      const M = /* @__PURE__ */ new Date();
      return C.getUTCDate() === M.getUTCDate() && C.getUTCMonth() === M.getUTCMonth() && C.getUTCFullYear() === M.getUTCFullYear();
    }, m = (C) => C.getUTCMonth() === s.value.getUTCMonth() && C.getUTCFullYear() === s.value.getUTCFullYear(), g = (C) => {
      if (n.allowRange) {
        if (i.value && l.value)
          return C >= new Date(i.value) && u(C) <= new Date(l.value);
        if (i.value)
          return C.getTime() === new Date(i.value).getTime();
      } else
        return o.value && C.getTime() === new Date(o.value).getTime();
    }, y = (C) => i.value && l.value ? C > i.value && u(C) < l.value : !1, S = (C) => {
      const M = c(C);
      if (!n.allowRange)
        o.value = M, r.value = M;
      else if (!i.value && !l.value)
        i.value = M, r.value.start = M;
      else if (l.value)
        i.value = M, l.value = null, r.value = { start: M, end: null };
      else {
        if (l.value = u(C), M < i.value) {
          const U = u(i.value);
          i.value = M, l.value = U;
        }
        r.value = { start: i.value, end: l.value };
      }
    }, $ = () => {
      s.value = new Date(Date.UTC(
        s.value.getUTCFullYear(),
        s.value.getUTCMonth() - 1,
        1
      ));
    }, E = () => {
      s.value = new Date(Date.UTC(
        s.value.getUTCFullYear(),
        s.value.getUTCMonth() + 1,
        1
      ));
    }, O = () => {
      const C = /* @__PURE__ */ new Date(), M = new Date(Date.UTC(C.getUTCFullYear(), C.getUTCMonth(), C.getUTCDate(), 0, 0, 0, 0)), U = new Date(Date.UTC(C.getUTCFullYear(), C.getUTCMonth(), C.getUTCDate(), 23, 59, 59, 999));
      i.value = M.toISOString(), l.value = U.toISOString(), r.value = { start: i.value, end: l.value };
    }, _ = () => {
      const C = /* @__PURE__ */ new Date(), M = new Date(C);
      M.setUTCDate(C.getUTCDate() - 7), M.setUTCHours(0, 0, 0, 0), i.value = M, l.value = u(C), C.setUTCHours(23, 59, 59, 999);
      const U = M.toISOString(), j = C.toISOString();
      r.value = { start: U, end: j };
    }, w = () => {
      const C = /* @__PURE__ */ new Date(), M = new Date(C);
      M.setUTCMonth(C.getUTCMonth() - 1), M.setUTCHours(0, 0, 0, 0), i.value = M, l.value = u(C), C.setUTCHours(23, 59, 59, 999);
      const U = M.toISOString(), j = C.toISOString();
      r.value = { start: U, end: j };
    }, k = () => {
      i.value = null, l.value = null, r.value = { start: null, end: null };
    };
    return (C, M) => (T(), L("div", b3, [
      e.allowRange ? (T(), L("div", _3, [
        P("button", {
          onClick: O,
          class: "font-second t-nowrap pd-thin bg-main-transp-10 radius-small"
        }, "Today"),
        P("button", {
          onClick: _,
          class: "font-second t-nowrap pd-thin bg-main-transp-10 radius-small"
        }, "Last Week"),
        P("button", {
          onClick: w,
          class: "font-second t-nowrap pd-thin bg-main-transp-10 radius-small"
        }, "Last Month"),
        P("button", {
          onClick: k,
          class: "font-second t-nowrap pd-thin bg-main-transp-10 radius-small"
        }, "All time")
      ])) : V("", !0),
      P("div", E3, [
        P("button", {
          onClick: le($, ["stop"]),
          class: "aspect-ratio-1x1 w-10 pd-thin bg-main-transp-10 radius-small"
        }, "<"),
        P("span", O3, W(f.value), 1),
        P("button", {
          onClick: le(E, ["stop"]),
          class: "aspect-ratio-1x1 w-10 pd-thin bg-main-transp-10 radius-small"
        }, ">")
      ]),
      P("div", C3, [
        P("div", T3, [
          (T(), L(pe, null, De(d, (U, j) => P("div", {
            key: j,
            class: "calendar__weekday"
          }, W(U), 1)), 64))
        ]),
        P("div", S3, [
          (T(!0), L(pe, null, De(v.value, (U) => (T(), L("div", {
            key: U.date,
            class: X([
              "flex flex-center cursor-pointer aspect-ratio-1x1 radius-small",
              { "bg-main t-white": U.isToday },
              { "calendar__date--selected": g(U.date) },
              { "calendar__date--range": y(U.date) },
              { "calendar__date--disabled": !m(U.date) }
            ]),
            onClick: le((j) => S(U.date), ["stop"])
          }, W(U.day), 11, w3))), 128))
        ])
      ])
    ]));
  }
}, L3 = {
  __name: "BottomSheet",
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Object,
      default: {
        position: !1
      }
    }
  },
  emits: [
    "toggle"
  ],
  setup(e, { emit: t }) {
    const n = t, r = F(null), a = F(0), s = F(0), o = F(!1);
    function i(c) {
      o.value = !0, a.value = c.touches ? c.touches[0].clientY : c.clientY, s.value = a.value;
    }
    function l(c) {
      if (!o.value) return;
      c.preventDefault(), s.value = c.touches ? c.touches[0].clientY : c.clientY;
      const u = s.value - a.value;
      u > 0 && (r.value.style.top = `${u}px`);
    }
    function d() {
      if (!o.value) return;
      o.value = !1;
      const c = s.value - a.value, u = window.innerHeight * 0.2;
      c < u ? r.value.style.top = "" : n("toggle");
    }
    return (c, u) => (T(), Le(xe, {
      name: "slideY",
      mode: "out-in"
    }, {
      default: fe(() => [
        P("section", {
          ref_key: "wrapper",
          ref: r,
          class: "w-100 h-100vh",
          style: Xe(c.MOBILE_APP === "ios" ? "padding-top: 6rem;" : "")
        }, [
          P("div", {
            onClick: u[0] || (u[0] = (f) => n("toggle")),
            onMousedown: i,
            onTouchstart: i,
            onMousemove: l,
            onTouchmove: l,
            onMouseup: d,
            onTouchend: d,
            onMouseleave: d,
            class: "bs-black d-block p-medium pos-relative bg-white flex-center flex uppercase z-index-2"
          }, u[1] || (u[1] = [
            P("div", { class: "radius-extra pd-small t-black p-medium" }, [
              P("div", { class: "radius-extra pd-nano w-3r h-1r t-black p-medium bg-black-transp-10" })
            ], -1)
          ]), 32),
          J(c.$slots, "default")
        ], 4)
      ]),
      _: 3
    }));
  }
}, I3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, P3 = ["fill"], A3 = {
  __name: "IconSearch",
  props: {
    fill: {
      type: String,
      default: "rgb(var(--black))"
    }
  },
  setup(e) {
    return (t, n) => (T(), L("svg", I3, [
      P("path", {
        fill: e.fill,
        d: "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6 .1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
      }, null, 8, P3)
    ]));
  }
}, k3 = { class: "flex-v-center flex-nowrap flex pd-small bg-light w-100 radius-big" }, D3 = {
  __name: "BlockSearch",
  props: {
    placeholder: {
      type: String,
      default: "Enter shop or product name"
    },
    button: {
      type: String,
      default: "Search"
    }
  },
  emits: ["search"],
  setup(e, { emit: t }) {
    const n = t;
    F(null);
    const r = (a) => {
      n("search", a);
    };
    return (a, s) => (T(), L("div", k3, [
      Q(A3, { class: "i-medium t-transp mn-r-thin" }),
      Q(Hr, {
        placeholder: e.placeholder,
        "onUpdate:field": s[0] || (s[0] = (o) => r(o)),
        class: "w-100"
      }, null, 8, ["placeholder"])
    ]));
  }
}, R3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}, F3 = ["width", "fill"], M3 = ["width", "fill"], x3 = ["width", "fill"], U3 = ["width", "fill"], Dr = {
  __name: "IconSort",
  props: {
    fill: {
      type: String,
      default: "rgb(var(--black))"
    },
    order: {
      type: String,
      default: "desc"
    }
  },
  setup(e) {
    return (t, n) => (T(), L("svg", R3, [
      P("rect", {
        y: "0",
        width: e.order === "desc" ? 32 : 8,
        height: "5",
        rx: "2.5",
        fill: e.fill,
        class: "transition-linear"
      }, null, 8, F3),
      P("rect", {
        y: "9",
        width: e.order === "desc" ? 24 : 16,
        height: "5",
        rx: "2.5",
        fill: e.fill,
        class: "transition-linear"
      }, null, 8, M3),
      P("rect", {
        y: "18",
        width: e.order === "desc" ? 16 : 24,
        height: "5",
        rx: "2.5",
        fill: e.fill,
        class: "transition-linear"
      }, null, 8, x3),
      P("rect", {
        y: "27",
        width: e.order === "desc" ? 8 : 32,
        height: "5",
        rx: "2.5",
        fill: e.fill,
        class: "transition-linear"
      }, null, 8, U3)
    ]));
  }
}, B3 = {
  __name: "ButtonSort",
  props: {
    action: {
      type: Function
    },
    order: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, { action: n, order: r } = Ys(t), a = () => {
      n.value && n.value();
    };
    return (s, o) => (T(), L("div", {
      onClick: a,
      class: "cursor-pointer t-center t-black radius-small flex-center flex aspect-1x1"
    }, [
      Q(Dr, {
        order: We(r),
        class: "w-100 h-auto"
      }, null, 8, ["order"])
    ]));
  }
}, V3 = { class: "w-100 o-hidden" }, j3 = { class: "mn-b-thin" }, H3 = { class: "w-100 flex-nowrap flex gap-micro" }, G3 = {
  __name: "BlockSorting",
  props: /* @__PURE__ */ sn({
    title: {
      type: String,
      default: "Sorting Options"
    },
    options: {
      type: Array,
      default: [{
        label: "Date",
        value: "createdAt"
      }, {
        label: "Popularity",
        value: "popularity"
      }, {
        label: "Creator",
        value: "creator"
      }]
    }
  }, {
    param: {},
    paramModifiers: {},
    order: {},
    orderModifiers: {}
  }),
  emits: ["update:param", "update:order"],
  setup(e) {
    const t = bt(e, "param"), n = bt(e, "order");
    return (r, a) => (T(), L("div", V3, [
      P("h4", j3, W(e.title), 1),
      (T(!0), L(pe, null, De(e.options, (s) => (T(), Le(Ro, {
        radio: t.value,
        "onUpdate:radio": a[0] || (a[0] = (o) => t.value = o),
        label: s.label,
        value: s.value,
        class: "w-100 mn-b-thin"
      }, null, 8, ["radio", "label", "value"]))), 256)),
      P("div", H3, [
        P("button", {
          onClick: a[1] || (a[1] = le(() => n.value = "asc", ["stop"])),
          class: X([{
            "bg-white t-black": n.value === "asc"
          }, "radius-semi flex-center w-100 uppercase p-small flex-nowrap flex gap-thin pd-thin br-solid br-1px br-grey-transp-25 w-100"])
        }, [
          Q(Dr, {
            order: "asc",
            fill: n.value === "asc" ? "rgb(var(--black))" : "rgb(var(--white))",
            class: "i-small"
          }, null, 8, ["fill"]),
          a[3] || (a[3] = mt(" Ascending "))
        ], 2),
        P("button", {
          onClick: a[2] || (a[2] = le(() => n.value = "desc", ["stop"])),
          class: X([{
            "bg-white t-black": n.value === "desc"
          }, "radius-semi flex-center w-100 uppercase p-small flex-nowrap flex gap-thin pd-thin br-solid br-1px br-grey-transp-25 w-100"])
        }, [
          Q(Dr, {
            order: "desc",
            fill: n.value === "desc" ? "rgb(var(--black))" : "rgb(var(--white))",
            class: "i-small"
          }, null, 8, ["fill"]),
          a[4] || (a[4] = mt(" Descending "))
        ], 2)
      ])
    ]));
  }
}, W3 = {
  props: {
    fill: {
      type: String,
      default: "rgb(var(--black)"
    }
  }
}, K3 = {
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y3 = { transform: "rotate(90 40 40)" }, q3 = ["fill"];
function z3(e, t, n, r, a, s) {
  return T(), L("svg", K3, [
    P("g", Y3, [
      P("path", {
        fill: n.fill,
        d: "M16.25 9.375L20 5.9375C21.5625 4.53125 23.9062 4.6875 25.3125 6.25L54.2188 37.8125C55.3125 39.0625 55.3125 40.9375 54.2188 42.1875L25.3125 73.75C23.9062 75.3125 21.5625 75.4688 20 74.0625L16.25 70.625C14.6875 69.375 14.5312 66.875 15.9375 65.4688L39.375 40L15.9375 14.5312C14.5312 13.125 14.6875 10.625 16.25 9.375Z"
      }, null, 8, q3)
    ])
  ]);
}
const X3 = /* @__PURE__ */ $t(W3, [["render", z3]]), J3 = { class: "w-100 o-scroll" }, Z3 = { class: "cursor-pointer w-100 flex-v-center flex-nowrap flex" }, Q3 = { class: "w-100" }, ep = {
  __name: "BlockFilter",
  props: /* @__PURE__ */ sn({
    title: {
      type: String,
      default: "Sorting Options"
    },
    options: {
      type: Array
    }
  }, {
    filter: {},
    filterModifiers: {}
  }),
  emits: ["update:filter"],
  setup(e) {
    const t = bt(e, "filter");
    return (n, r) => (T(), L("div", J3, [
      (T(!0), L(pe, null, De(e.options, (a) => (T(), Le(Mo, {
        class: "o-hidden bg-white pd-medium radius-big mn-b-small",
        status: !0
      }, {
        header: fe(({ isOpen: s }) => [
          P("div", Z3, [
            P("h4", Q3, W(a.title), 1),
            Q(X3, {
              class: X([{ "rotate-180": s }, "radius-big pd-micro bg-light i-semi"]),
              fill: "rgb(var(--black))"
            }, null, 8, ["class"])
          ])
        ]),
        content: fe(() => [
          (T(!0), L(pe, null, De(a.options, (s, o) => (T(), Le(qs, {
            key: o,
            label: s.label,
            value: s.value,
            class: "w-100 mn-t-small mn-b-small br-1px br-solid br-light radius-small pd-small",
            radio: t.value.selected[a.value],
            "onUpdate:radio": (i) => t.value.selected[a.value] = i
          }, null, 8, ["label", "value", "radio", "onUpdate:radio"]))), 128))
        ]),
        _: 2
      }, 1024))), 256)),
      P("button", {
        onClick: r[0] || (r[0] = () => t.value.selected = {}),
        class: "bg-main w-100 button"
      }, "Reset Filters")
    ]));
  }
}, tp = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}, np = ["fill"], rp = {
  __name: "IconCalendar",
  props: {
    fill: {
      type: String,
      default: "rgb(var(--black))"
    },
    order: {
      type: String,
      default: "desc"
    }
  },
  setup(e) {
    return (t, n) => (T(), L("svg", tp, [
      P("path", {
        d: "M3 43.5V18H45V43.5C45 45.9375 42.9375 48 40.5 48H7.5C5.0625 48 3 45.9375 3 43.5ZM33 25.5V28.5C33 29.3438 33.6562 30 34.5 30H37.5C38.3438 30 39 29.3438 39 28.5V25.5C39 24.6562 38.3438 24 37.5 24H34.5C33.6562 24 33 24.6562 33 25.5ZM33 37.5V40.5C33 41.3438 33.6562 42 34.5 42H37.5C38.3438 42 39 41.3438 39 40.5V37.5C39 36.6562 38.3438 36 37.5 36H34.5C33.6562 36 33 36.6562 33 37.5ZM21 25.5V28.5C21 29.3438 21.6562 30 22.5 30H25.5C26.3438 30 27 29.3438 27 28.5V25.5C27 24.6562 26.3438 24 25.5 24H22.5C21.6562 24 21 24.6562 21 25.5ZM21 37.5V40.5C21 41.3438 21.6562 42 22.5 42H25.5C26.3438 42 27 41.3438 27 40.5V37.5C27 36.6562 26.3438 36 25.5 36H22.5C21.6562 36 21 36.6562 21 37.5ZM9 25.5V28.5C9 29.3438 9.65625 30 10.5 30H13.5C14.3438 30 15 29.3438 15 28.5V25.5C15 24.6562 14.3438 24 13.5 24H10.5C9.65625 24 9 24.6562 9 25.5ZM9 37.5V40.5C9 41.3438 9.65625 42 10.5 42H13.5C14.3438 42 15 41.3438 15 40.5V37.5C15 36.6562 14.3438 36 13.5 36H10.5C9.65625 36 9 36.6562 9 37.5ZM40.5 6C42.9375 6 45 8.0625 45 10.5V15H3V10.5C3 8.0625 5.0625 6 7.5 6H12V1.5C12 0.65625 12.6562 0 13.5 0H16.5C17.3438 0 18 0.65625 18 1.5V6H30V1.5C30 0.65625 30.6562 0 31.5 0H34.5C35.3438 0 36 0.65625 36 1.5V6H40.5Z",
        fill: e.fill
      }, null, 8, np)
    ]));
  }
}, ap = { class: "t-semi" }, sp = {
  __name: "ButtonDate",
  props: {
    action: {
      type: Function
    },
    date: {
      type: Object
    }
  },
  setup(e) {
    const t = e, { action: n, date: r } = Ys(t), a = ae(() => o(r.value)), s = () => {
      n.value && n.value();
    };
    function o(i) {
      const l = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], { start: d, end: c } = i;
      if (d === null && c === null)
        return "All Time";
      const u = new Date(d), f = u.getUTCDate(), v = l[u.getUTCMonth()], p = u.getUTCFullYear();
      if (!c)
        return `${f} ${v} ${p}`;
      const m = new Date(c), g = m.getUTCDate(), y = l[m.getUTCMonth()], S = m.getUTCFullYear();
      return `${f} ${v} - ${g} ${y} ${S}`;
    }
    return (i, l) => (T(), L("div", {
      onClick: s,
      class: "cursor-pointer flex-center flex"
    }, [
      Q(rp, { class: "w-1r mn-r-thin h-auto" }),
      P("span", ap, W(a.value), 1)
    ]));
  }
}, op = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}, ip = ["fill"], lp = {
  __name: "IconFilter",
  props: {
    fill: {
      type: String,
      default: "rgb(var(--black))"
    },
    order: {
      type: String,
      default: "desc"
    }
  },
  setup(e) {
    return (t, n) => (T(), L("svg", op, [
      P("path", {
        d: "M46.4267 13.1341L29.226 30.2782V43.1433C29.2272 43.5293 29.1102 43.9065 28.8907 44.2239C28.6711 44.5414 28.3596 44.784 27.998 44.9191L20.5831 47.6868C20.2976 47.7934 19.9905 47.8294 19.6881 47.7917C19.3856 47.754 19.0968 47.6437 18.8462 47.4701C18.5957 47.2966 18.3908 47.065 18.2492 46.7952C18.1075 46.5253 18.0332 46.2252 18.0327 45.9204V30.2498L1.50259 13.0491C0.772898 12.2954 0.281511 11.3434 0.0898392 10.312C-0.101832 9.28058 0.0147126 8.21558 0.424909 7.25005C0.835106 6.28453 1.52076 5.46131 2.39619 4.88327C3.27161 4.30523 4.29798 3.99801 5.34702 4.00001H42.6579C43.7158 4.00084 44.7497 4.31552 45.6287 4.90422C46.5077 5.49291 47.1923 6.32916 47.5958 7.30712C47.9993 8.28507 48.1036 9.36075 47.8955 10.398C47.6874 11.4353 47.1763 12.3875 46.4267 13.1341Z",
        fill: e.fill
      }, null, 8, ip)
    ]));
  }
}, dp = {
  key: 0,
  class: "flex-nowrap flex gap-thin"
}, up = {
  key: 5,
  class: "col-w-100 w-100 pos-relative"
}, cp = {
  __name: "Feed",
  props: /* @__PURE__ */ sn({
    showLoadMore: {
      type: Boolean,
      default: !0
    },
    search: {
      type: [Boolean, Object],
      default: !1
    },
    states: {
      type: Object,
      default: () => ({
        empty: {
          title: String,
          description: String
        }
      })
    },
    store: {
      type: Object,
      default: () => ({
        read: Function,
        state: Object
      })
    },
    external: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Object,
      default: () => ({
        category: null,
        limit: 20,
        skip: 0,
        owner: null,
        creator: null,
        user: null,
        status: null,
        period: null,
        contain: null
      })
    }
  }, {
    search: {},
    searchModifiers: {},
    sort: {},
    sortModifiers: {},
    filter: {},
    filterModifiers: {},
    date: {},
    dateModifiers: {},
    items: {},
    itemsModifiers: {}
  }),
  emits: ["update:search", "update:sort", "update:filter", "update:date", "update:items"],
  setup(e) {
    const t = bt(e, "search"), n = bt(e, "sort"), r = bt(e, "filter"), a = bt(e, "date"), s = bt(e, "items"), o = e, i = an(s.value || []), l = F(!1);
    let d = F(!0), c = F(!1), u = F(null), f = F(o.options.skip ? o.options.skip : 0), v = F(o.options.limit ? o.options.limit : 10), p = F("");
    function m(O, _) {
      let w = null;
      return (...k) => {
        clearTimeout(w), w = setTimeout(() => O(...k), _);
      };
    }
    const g = m((O) => {
      p.value = O, f.value = 0, v.value = 10, $();
    }, 300);
    function y(O) {
      g(O);
    }
    const S = async () => {
      if (c.value = !0, l.value) {
        f.value += v.value;
        const O = await o.store.read({
          skip: f.value,
          limit: v.value,
          search: p.value,
          dateStart: a.value ? a.value.start : null,
          dateEnd: a.value ? a.value.end : null,
          sortParam: n.value ? n.value.param : null,
          sortOrder: n.value ? n.value.order : null,
          ...o.options
        });
        O.length === 0 || O.length < v.value ? l.value = !1 : l.value = !0, i.value = [...i.value, ...O], s.value && (s.value = i.value);
      }
      c.value = !1;
    }, $ = async () => {
      d.value = !0;
      const O = await o.store.read({
        skip: f.value,
        limit: v.value,
        dateStart: a.value ? a.value.start : null,
        dateEnd: a.value ? a.value.end : null,
        sortParam: n.value ? n.value.param : null,
        sortOrder: n.value ? n.value.order : null,
        search: p.value,
        ...o.options
      });
      O.length === 0 || O.length < v.value ? l.value = !1 : l.value = !0, i.value = O, s.value && (s.value = i.value), d.value = !1;
    };
    Te(
      () => [o.external, a.value, n.value, o.options],
      ([O, _, w, k], [C, M, U, j]) => {
        (O !== C || _ !== M || (w == null ? void 0 : w.order) !== (U == null ? void 0 : U.order) || (w == null ? void 0 : w.param) !== (U == null ? void 0 : U.param) || JSON.stringify(k) !== JSON.stringify(j)) && (f.value = 0, $());
      },
      { deep: !0 }
    );
    let E = null;
    return Qe(async () => {
      await $(), typeof window < "u" && !o.showLoadMore && (E = new IntersectionObserver((O) => {
        O.some((_) => _.isIntersecting) && S();
      }), u.value && E.observe(u.value));
    }), Ws(() => {
      E && E.disconnect();
    }), (O, _) => (T(), L(pe, null, [
      t.value || a.value || n.value && !n.value.hideButton ? (T(), L("div", dp, [
        t.value ? (T(), Le(D3, {
          key: 0,
          placeholder: t.value.placeholder || "Search...",
          class: X(t.value.class || "bg-light"),
          onSearch: y
        }, null, 8, ["placeholder", "class"])) : V("", !0),
        r.value ? (T(), L(pe, { key: 1 }, [
          P("div", {
            class: X([r.value.class || "bg-light", "flex-center flex pd-thin bg-light radius-extra aspect-1x1 h-100"])
          }, [
            Q(lp, {
              onClick: _[0] || (_[0] = () => r.value.active = !r.value.active),
              class: "w-1r h-auto"
            })
          ], 2),
          r.value.active ? (T(), Le(L3, {
            key: 0,
            show: r.value.active,
            onToggle: _[2] || (_[2] = () => r.value.active = !1),
            class: X(["z-index-10 pos-fixed pos-t-0 pos-r-0", {
              "pos-t-0": r.value.active,
              "pos-t-100": !r.value.active
            }])
          }, {
            default: fe(() => [
              Q(ep, {
                filter: r.value,
                "onUpdate:filter": _[1] || (_[1] = (w) => r.value = w),
                options: r.value.options,
                class: "h-100 w-100 pd-small bg-light"
              }, null, 8, ["filter", "options"])
            ]),
            _: 1
          }, 8, ["show", "class"])) : V("", !0)
        ], 64)) : V("", !0),
        a.value ? (T(), Le(ur, {
          key: 2,
          label: {
            component: sp,
            props: { date: a.value }
          },
          class: X([a.value.class || "bg-light", "flex-child flex-child-shrink-0 pd-r-small pd-l-small pd-thin bg-light radius-big"]),
          align: t.value ? "right" : "left"
        }, {
          default: fe(() => [
            Q(N3, {
              date: a.value,
              "onUpdate:date": _[3] || (_[3] = (w) => a.value = w),
              locale: O.$i18n.locale,
              allowRange: !0,
              class: "radius-semi w-100 o-hidden bg-light"
            }, null, 8, ["date", "locale"])
          ]),
          _: 1
        }, 8, ["label", "class", "align"])) : V("", !0),
        n.value && !n.value.hideButton ? (T(), Le(ur, {
          key: 3,
          label: {
            component: B3,
            props: { order: n.value.order },
            class: "w-1r"
          },
          class: X([n.value.class || "bg-light", "radius-extra aspect-1x1 h-100"]),
          align: t.value ? "right" : "left"
        }, {
          default: fe(() => [
            Q(G3, {
              param: n.value.param,
              "onUpdate:param": _[4] || (_[4] = (w) => n.value.param = w),
              order: n.value.order,
              "onUpdate:order": _[5] || (_[5] = (w) => n.value.order = w),
              options: n.value.options,
              class: "h-100 pd-small radius-semi t-white bg-black"
            }, null, 8, ["param", "order", "options"])
          ]),
          _: 1
        }, 8, ["label", "class", "align"])) : V("", !0)
      ])) : V("", !0),
      We(d) ? (T(), Le(Xn, {
        key: 1,
        tag: "ul",
        name: "scaleTransition"
      }, {
        default: fe(() => [
          We(d) ? (T(!0), L(pe, { key: 0 }, De(We(v), (w) => (T(), Le(y3, {
            key: "skeleton-" + w,
            class: "mn-b-small radius-big o-hidden d-block"
          }))), 128)) : V("", !0)
        ]),
        _: 1
      })) : V("", !0),
      !We(d) && i.value.length < 1 ? (T(), Le(Xn, {
        key: 2,
        tag: "ul",
        name: "feed"
      }, {
        default: fe(() => [
          !We(d) && i.value.length < 1 ? (T(), Le(li, {
            key: 0,
            title: e.states.empty.title,
            description: e.states.empty.description,
            action: e.states.empty.action,
            callback: e.states.empty.callback,
            class: "pd-medium mn-b-thin bg-light radius-big"
          }, null, 8, ["title", "description", "action", "callback"])) : V("", !0)
        ]),
        _: 1
      })) : V("", !0),
      Q(Xn, {
        tag: "ul",
        name: "feed",
        class: X(O.$attrs.class)
      }, {
        default: fe(() => [
          !We(d) && i.value.length > 0 ? J(O.$slots, "default", {
            key: 0,
            items: i.value
          }) : V("", !0)
        ]),
        _: 3
      }, 8, ["class"]),
      e.showLoadMore && l.value && i.value.length > 0 && !We(c) ? (T(), L("button", {
        key: 3,
        onClick: S,
        class: "col-w-100 mn-t-thin w-100 t-black bg-main button"
      }, " Load More ")) : (T(), L("div", {
        key: "sentinel",
        ref_key: "sentinel",
        ref: u,
        class: "sentinel"
      }, null, 512)),
      We(c) ? (T(), L("div", up, [
        Q($n)
      ])) : V("", !0)
    ], 64));
  }
}, fp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cp
}, Symbol.toStringTag, { value: "Module" })), pp = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none"
}, mp = ["fill", "transform"], hp = {
  __name: "IconArrow",
  props: {
    fill: {
      type: String,
      default: "rgb(var(--black))"
    },
    rotation: {
      type: Number,
      default: 0
    }
  },
  setup(e) {
    return (t, n) => (T(), L("svg", pp, [
      P("path", {
        fill: e.fill,
        transform: `rotate(${e.rotation}, 24, 24)`,
        d: "M42.4938 21.6042L29.8525 8.96288C29.568 8.66354 29.2265 8.42416 28.8481 8.25884C28.4696 8.09352 28.062 8.0056 27.649 8.00026C27.2361 7.99492 26.8263 8.07226 26.4437 8.22774C26.0612 8.38322 25.7136 8.61368 25.4214 8.90556C25.1293 9.19743 24.8985 9.54482 24.7427 9.92725C24.5869 10.3097 24.5092 10.7194 24.5142 11.1324C24.5192 11.5453 24.6067 11.953 24.7717 12.3316C24.9367 12.7102 25.1758 13.0519 25.4749 13.3366L32.9475 20.7978H8.09504C7.27418 20.7978 6.48695 21.1238 5.90652 21.7043C5.32608 22.2847 5 23.0719 5 23.8928C5 24.7137 5.32608 25.5009 5.90652 26.0813C6.48695 26.6618 7.27418 26.9878 8.09504 26.9878H32.8784L25.4749 34.4029C24.9186 34.9882 24.6131 35.7677 24.6236 36.5751C24.634 37.3825 24.9596 38.1538 25.5308 38.7245C26.102 39.2952 26.8736 39.6201 27.681 39.6299C28.4884 39.6396 29.2677 39.3334 29.8525 38.7766L42.4938 26.1354C42.7822 25.8487 43.0108 25.5076 43.1664 25.1318C43.3219 24.7561 43.4013 24.3532 43.4 23.9466C43.402 23.921 43.402 23.8953 43.4 23.8698C43.4018 23.8442 43.4018 23.8185 43.4 23.793C43.3997 22.9721 43.0738 22.1849 42.4938 21.6042Z"
      }, null, 8, mp)
    ]));
  }
}, $p = { class: "pd-thin radius-extra flex-nowrap flex" }, gp = {
  __name: "FieldBig",
  props: {
    input: String,
    placeholder: {
      type: String
    },
    action: {
      type: String,
      default: "Action"
    },
    placeholderTexts: {
      type: Object,
      default: () => ({
        en: [
          "Lowest THC, please!",
          "Something with banana flavors?",
          "I'm in the mood for trippy vibes."
        ],
        ru: [
          "Я хочу самый низкий THC",
          "Я хочу чего-нибудь бананового",
          "Я хочу курнуть хейза"
        ]
      })
    },
    typingSpeed: {
      type: Number,
      default: 200
    },
    loopTyping: {
      type: Boolean,
      default: !1
    },
    enableTyping: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:input", "action"],
  setup(e, { emit: t }) {
    const n = e, { t: r, locale: a } = Xt();
    let s = F(0), o = F(n.input), i = F(n.placeholder), l = F(n.enableTyping), d = F(null), c = F(""), u = F(!0), f = null;
    const v = t;
    function p() {
      v("action");
    }
    function m(E) {
      v("update:input", E), c.value = E;
    }
    function g() {
      s.value = (s.value + 1) % n.placeholderTexts[a.value].length;
    }
    function y() {
      l.value = !1, clearInterval(d.value), i.value = n.placeholder, c.value || (o.value = "");
    }
    function S() {
      !c.value && n.enableTyping && (l.value = !0, i.value = "", $());
    }
    function $() {
      let E = n.placeholderTexts[a.value][s.value], O = 0, _ = !1;
      f = setInterval(() => {
        u.value = !u.value;
      }, 200), d.value = setInterval(() => {
        l.value && (_ ? (o.value = o.value.slice(0, -1), o.value = E.substring(0, O) + (u.value && O % 2 ? "|" : ""), O--) : (o.value = E.substring(0, O) + (u.value && O % 2 ? "|" : ""), O++), O > E.length && n.loopTyping && setTimeout(() => {
          _ = !0, o.value = E.substring(0, O);
        }, 333), O === 0 && _ && (_ = !1, g(), E = n.placeholderTexts[a.value][s.value]));
      }, n.typingSpeed);
    }
    return Qe(() => {
      n.enableTyping && $();
    }), lr(() => {
      l.value || (clearInterval(d.value), clearInterval(f));
    }), (E, O) => (T(), L("div", $p, [
      Q(Hr, {
        field: We(o),
        "onUpdate:field": [
          O[0] || (O[0] = (_) => dr(o) ? o.value = _ : o = _),
          m
        ],
        placeholder: We(l) ? "" : e.placeholder,
        onInput: g,
        onFocus: y,
        onBlur: S,
        class: "w-100 p-medium t-regular uppercase pd-small"
      }, null, 8, ["field", "placeholder"]),
      e.action ? (T(), L("button", {
        key: 0,
        onClick: p,
        class: "t-nowrap t-medium radius-big uppercase cursor-pointer flex flex-v-center pd-r-small pd-l-small w-max hover-bg-fifth t-semi transition-linear transition-timing-1 t-black bg-main"
      }, [
        P("span", null, W(e.action), 1),
        Q(hp, { class: "mn-l-thin radius-extra bg-white i-medium" })
      ])) : V("", !0)
    ]));
  }
}, vp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gp
}, Symbol.toStringTag, { value: "Module" }));
function yp(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bp = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var r, a, s;
    if (Array.isArray(t)) {
      if (r = t.length, r != n.length) return !1;
      for (a = r; a-- !== 0; )
        if (!e(t[a], n[a])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (s = Object.keys(t), r = s.length, r !== Object.keys(n).length) return !1;
    for (a = r; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, s[a])) return !1;
    for (a = r; a-- !== 0; ) {
      var o = s[a];
      if (!e(t[o], n[o])) return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
};
const _p = /* @__PURE__ */ yp(bp), Ep = (e, t) => t.filter((n) => {
  const { text: r } = e;
  if (typeof n.rule == "string") return !new RegExp(n.rule).test(r);
  if (n.rule instanceof RegExp) return !n.rule.test(r);
  if ({}.toString.call(n.rule) === "[object Function]") return n.rule(e);
}).map((n) => n.classes), Kt = (e) => JSON.parse(JSON.stringify(e)), Op = (e, t) => {
  let n = 0;
  for (; n < e.length; ) {
    if (t(e[n], n, e)) return n;
    n++;
  }
  return -1;
}, di = (e, t, n = [], r) => {
  e.text === void 0 && (e = { text: e });
  const a = Ep(e, n), s = Op(t, (d) => d === e), o = Kt(t), i = s !== -1 ? o.splice(s, 1)[0] : Kt(e);
  return (r ? r(o, i) : o.map((d) => d.text).indexOf(i.text) !== -1) && a.push("ti-duplicate"), a.length === 0 ? a.push("ti-valid") : a.push("ti-invalid"), a;
}, tn = (e, ...t) => {
  e.text === void 0 && (e = { text: e });
  const n = Kt(e);
  return n.tiClasses = di(e, ...t), n;
}, Cp = (e, ...t) => e.map((n) => tn(n, e, ...t)), Tp = {
  name: "TagInput",
  props: {
    scope: {
      type: Object
    }
  }
}, Sp = ["maxlength"];
function wp(e, t, n, r, a, s) {
  return n.scope.edit ? Be((T(), L("input", {
    key: 0,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => n.scope.tag.text = o),
    maxlength: n.scope.maxlength,
    type: "text",
    class: "ti-tag-input",
    size: "1",
    onInput: t[1] || (t[1] = (o) => n.scope.validateTag(n.scope.index, o)),
    onBlur: t[2] || (t[2] = (o) => n.scope.performCancelEdit(n.scope.index)),
    onKeydown: t[3] || (t[3] = (o) => n.scope.performSaveEdit(n.scope.index, o))
  }, null, 40, Sp)), [
    [Ci, n.scope.tag.text]
  ]) : V("", !0);
}
const Np = /* @__PURE__ */ $t(Tp, [["render", wp]]), Fs = (e) => !e.some((t) => {
  const n = !t.text;
  n && console.warn('Missing property "text"', t);
  let r = !1;
  return t.classes && (r = typeof t.classes != "string"), r && console.warn('Property "classes" must be type of string', t), n || r;
}), Ms = (e) => !e.some((t) => {
  if (typeof t == "number") {
    const n = isFinite(t) && Math.floor(t) === t;
    return n || console.warn("Only numerics are allowed for this prop. Found:", t), !n;
  } else if (typeof t == "string") {
    const n = /\W|[a-z]|!\d/i.test(t);
    return n || console.warn("Only alpha strings are allowed for this prop. Found:", t), !n;
  } else
    return console.warn("Only numeric and string values are allowed. Found:", t), !1;
}), Lp = {
  /**
   * @description Property to bind a model to the input.
     If the user changes the input value, the model updates, too.
     If the user presses enter with an valid input,
     a new tag is created with the value of this model.
     After creating the new tag, the model is cleared.
   * @property {props}
   * @required
   * @type {String}
   * @model
   * @default ''
   */
  modelValue: {
    type: String,
    default: "",
    required: !0
  },
  /**
   * @description Pass an array containing objects like in the example below.
     The properties 'style' and 'class' are optional. Of course it is possible to add custom
     properties to a tag object. vue-tags-input won't change the key and value.
   * @property {props}
   * @type {Array}
   * @sync
   * @default []
   * @example
    {
    &emsp;text: 'My tag value', &#47;* The visible text on display *&#47;
    &emsp;style: 'background-color: #ccc', &#47;* Adding inline styles is possible *&#47;
    &emsp;classes: 'custom-class another', &#47;* The value will be added as css classes *&#47;
    }
   */
  tags: {
    type: Array,
    default: () => [],
    validator: Fs
  },
  /**
   * @description Expects an array containing objects inside. The objects
    can have the same properties as a tag object.
   * @property {props}
   * @type {Array}
   * @default []
   */
  autocompleteItems: {
    type: Array,
    default: () => [],
    validator: Fs
  },
  /**
   * @description Defines whether a tag is editable after creation or not.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  allowEditTags: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Defines if duplicate autocomplete items are filtered out from the view or not.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  autocompleteFilterDuplicates: {
    default: !0,
    type: Boolean
  },
  /**
   * @description If it's true, the user can add tags only via the autocomplete layer.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  addOnlyFromAutocomplete: {
    type: Boolean,
    default: !1
  },
  /**
   * @description The minimum character length which is required
     until the autocomplete layer is shown. If set to 0,
     then it'll be shown on focus.
   * @property {props}
   * @type {Number}
   * @default 1
   */
  autocompleteMinLength: {
    type: Number,
    default: 1
  },
  /**
   * @description If it's true, the autocomplete layer is always shown, regardless if
     an input or an autocomplete items exists.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  autocompleteAlwaysOpen: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Property to disable vue-tags-input.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * @description The placeholder text which is shown in the input, when it's empty.
   * @property {props}
   * @type {String}
   * @default Add Tag
   */
  placeholder: {
    type: String,
    default: "Add Tag"
  },
  /**
   * @description Custom trigger key codes can be registrated. If the user presses one of these,
     a tag will be generated out of the input value. Can be either a numeric keyCode or the key
     as a string.
   * @property {props}
   * @type {Array}
   * @default [13]
   * @example add-on-key="[13, ':', ';']"
   */
  addOnKey: {
    type: Array,
    default: () => [13],
    validator: Ms
  },
  /**
   * @description Custom trigger key codes can be registrated. If the user edits a tag
     and presses one of these, the edited tag will be saved.
     Can be either a numeric keyCode or the key as a string.
   * @property {props}
   * @type {Array}
   * @default [13]
   * @example save-on-key="[13, ':', ';']"
   */
  saveOnKey: {
    type: Array,
    default: () => [13],
    validator: Ms
  },
  /**
   * @description The maximum amount the tags array is allowed to hold.
   * @property {props}
   * @type {Number}
   */
  maxTags: {
    type: Number
  },
  /**
   * @description The maximum amount of characters the input is allowed to hold.
   * @property {props}
   * @type {Number}
   */
  maxlength: {
    type: Number
  },
  /**
   * @description Pass an array containing objects like in the example below.
     The property 'classes' will be added as css classes, if the property 'rule' matches the text
     of a tag, an autocomplete item or the input. The property 'rule' can be type of
     RegExp or function. If the property 'disableAdd' is 'true', the item can't be added
     to the tags array, if the appropriated rule matches.
   * @property {props}
   * @type {Array}
   * @default []
   * @example
    {
    &ensp;classes: 'class', &#47;* css class *&#47;
    &ensp;rule: /^([^0-9]*)$/, &#47;* RegExp *&#47;
    }, {
    &ensp;classes: 'no-braces', &#47;* css class *&#47;
    &ensp;rule(text) { &#47;* function with text as param *&#47;
    &ensp;&ensp;return text.indexOf('{') !== -1 || text.indexOf('}') !== -1;
    &ensp;},
    &ensp;disableAdd: true, &#47;* if the rule matches, the item cannot be added *&#47;,
    },
   */
  validation: {
    type: Array,
    default: () => [],
    validator(e) {
      return !e.some((t) => {
        const n = !t.rule;
        n && console.warn('Property "rule" is missing', t);
        const r = t.rule && (typeof t.rule == "string" || t.rule instanceof RegExp || {}.toString.call(t.rule) === "[object Function]");
        r || console.warn(
          "A rule must be type of string, RegExp or function. Found:",
          JSON.stringify(t.rule)
        );
        const a = !t.classes;
        a && console.warn('Property "classes" is missing', t);
        const s = t.type && typeof t.type != "string";
        return s && console.warn('Property "type" must be type of string. Found:', t), !r || n || a || s;
      });
    }
  },
  /**
   * @description Defines the characters which splits a text into different pieces,
     to generate tags out of this pieces.
   * @property {props}
   * @type {Array}
   * @default [';']
   * @example
     separators: [';', ',']
     input: some; user input, has random; commas, an,d semicolons
     will split into: some - user input - has random - commas - an - d semicolons
   */
  separators: {
    type: Array,
    default: () => [";"],
    validator(e) {
      return !e.some((t) => {
        const n = typeof t != "string";
        return n && console.warn("Separators must be type of string. Found:", t), n;
      });
    }
  },
  /**
   * @description If it's true, the user can't add or save a tag,
     if another exists, with the same text value.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  avoidAddingDuplicates: {
    type: Boolean,
    default: !0
  },
  /**
   * @description If the input holds a value and loses the focus,
     a tag will be generated out of this value, if possible.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  addOnBlur: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Custom function to detect duplicates. If the function returns 'true',
    the tag will be marked as duplicate.
   * @property {props}
   * @type {Function}
   * @param {Array} tagsarray The Array of tags minus the one which is edited/created.
   * @param {Object} tag The tag which is edited or should be added to the tags array.
   * @example
     // The duplicate function to recreate the default behaviour, would look like this:
     isDuplicate(tags, tag) {
     &ensp;return tags.map(t => t.text).indexOf(tag.text) !== -1;
    }
   */
  isDuplicate: {
    type: Function,
    default: null
  },
  /**
   * @description If it's true, the user can paste into the input element and
     vue-tags-input will create tags out of the incoming text.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  addFromPaste: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Defines if it's possible to delete tags by pressing backspace.
     If so and the user wants to delete a tag,
     the tag gets the css class 'deletion-mark' for 1 second.
     If the user presses backspace again in that time period,
     the tag is removed from the tags array and the view.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  deleteOnBackspace: {
    default: !0,
    type: Boolean
  },
  // event handlers
  onBeforeAddingTag: Function,
  onBeforeDeletingTag: Function,
  onBeforeEditingTag: Function,
  onBeforeSavingTag: Function
}, Ip = {
  name: "VueTagsInput",
  components: { TagInput: Np },
  props: Lp,
  emits: [
    "adding-duplicate",
    "before-adding-tag",
    "before-deleting-tag",
    "before-editing-tag",
    "before-saving-tag",
    "max-tags-reached",
    "saving-duplicate",
    "tags-changed",
    "tag-clicked",
    "update:modelValue",
    "update:tags"
  ],
  inheritAttrs: !1,
  data() {
    return {
      tagCenter: [],
      newTag: null,
      tagsCopy: [],
      tagsEditStatus: null,
      deletionMark: null,
      deletionMarkTime: null,
      selectedItem: null,
      focused: null
    };
  },
  computed: {
    // Property which calculates if the autocomplete should be opened or not
    autocompleteOpen() {
      return this.autocompleteAlwaysOpen ? !0 : this.newTag !== null && this.newTag.length >= this.autocompleteMinLength && this.filteredAutocompleteItems.length > 0 && this.focused;
    },
    // Returns validated autocomplete items. Maybe duplicates are filtered out
    filteredAutocompleteItems() {
      const e = this.autocompleteItems.map((t) => tn(t, this.tags, this.validation, this.isDuplicate));
      return this.autocompleteFilterDuplicates ? e.filter(this.duplicateFilter) : e;
    }
  },
  methods: {
    createClasses: di,
    // Returns the index which item should be selected, based on the parameter 'method'
    getSelectedIndex(e) {
      const t = this.filteredAutocompleteItems, n = this.selectedItem, r = t.length - 1;
      if (t.length !== 0)
        return n === null ? 0 : e === "before" && n === 0 ? r : e === "after" && n === r ? 0 : e === "after" ? n + 1 : n - 1;
    },
    selectDefaultItem() {
      this.addOnlyFromAutocomplete && this.filteredAutocompleteItems.length > 0 ? this.selectedItem = 0 : this.selectedItem = null;
    },
    selectItem(e, t) {
      e.preventDefault(), this.selectedItem = this.getSelectedIndex(t);
    },
    isSelected(e) {
      return this.selectedItem === e;
    },
    isMarked(e) {
      return this.deletionMark === e;
    },
    // Save ref for tag
    setTagCenter(e) {
      e && this.tagCenter.push(e);
    },
    // Method which is called when the user presses backspace → remove the last tag
    invokeDelete() {
      if (!this.deleteOnBackspace || this.newTag.length > 0) return;
      const e = this.tagsCopy.length - 1;
      this.deletionMark === null ? (this.deletionMarkTime = setTimeout(() => this.deletionMark = null, 1e3), this.deletionMark = e) : this.performDeleteTag(e);
    },
    addTagsFromPaste() {
      this.addFromPaste && setTimeout(() => this.performAddTags(this.newTag), 10);
    },
    // Method to call if a tag should switch to it's edit mode
    performEditTag(e) {
      this.allowEditTags && (this.onBeforeAddingTag || this.editTag(e), this.$emit("before-editing-tag", {
        index: e,
        tag: this.tagsCopy[e],
        editTag: () => this.editTag(e)
      }));
    },
    // Opens the edit mode for a tag and focuses it
    editTag(e) {
      this.allowEditTags && (this.toggleEditMode(e), this.focus(e));
    },
    // Toggles the edit mode for a tag
    toggleEditMode(e) {
      !this.allowEditTags || this.disabled || (this.tagsEditStatus[e] = !this.tagsEditStatus[e]);
    },
    // only called by the @input event from TagInput.
    // Creates a new tag model and applys it to this.tagsCopy[index]
    createChangedTag(e, t) {
      const n = this.tagsCopy[e];
      n.text = t ? t.target.value : this.tagsCopy[e].text, this.tagsCopy[e] = tn(n, this.tagsCopy, this.validation, this.isDuplicate);
    },
    // Focuses the input of a tag
    focus(e) {
      this.$nextTick(() => {
        const t = this.tagCenter[e].querySelector("input.ti-tag-input");
        t && t.focus();
      });
    },
    quote(e) {
      return e.replace(/([()[{*+.$^\\|?])/g, "\\$1");
    },
    // Cancels the edit mode for a tag → resets the tag to it's original model!
    cancelEdit(e) {
      this.tags[e] && (this.tagsCopy[e] = Kt(
        tn(this.tags[e], this.tags, this.validation, this.isDuplicate)
      ), this.tagsEditStatus[e] = !1);
    },
    hasForbiddingAddRule(e) {
      return e.some((t) => {
        const n = this.validation.find((r) => t === r.classes);
        return n ? n.disableAdd : !1;
      });
    },
    // Creates multiple tags out of a string, based on the prop separators
    createTagTexts(e) {
      const t = new RegExp(this.separators.map((n) => this.quote(n)).join("|"));
      return e.split(t).map((n) => ({ text: n }));
    },
    // Method to call to delete a tag
    performDeleteTag(e) {
      this.onBeforeDeletingTag || this.deleteTag(e), this.$emit("before-deleting-tag", {
        index: e,
        tag: this.tagsCopy[e],
        deleteTag: () => this.deleteTag(e)
      });
    },
    deleteTag(e) {
      this.disabled || (this.deletionMark = null, clearTimeout(this.deletionMarkTime), this.tagsCopy.splice(e, 1), this.$emit("update:tags", this.tagsCopy), this.$emit("tags-changed", this.tagsCopy));
    },
    // Decides wether the input keyCode is one, which is allowed to modify/add tags
    noTriggerKey(e, t) {
      const n = this[t].indexOf(e.keyCode) !== -1 || this[t].indexOf(e.key) !== -1;
      return n && e.preventDefault(), !n;
    },
    // Method to call to add a tag
    performAddTags(e, t, n) {
      if (this.disabled || t && this.noTriggerKey(t, "addOnKey")) return;
      let r = [];
      typeof e == "object" && (r = [e]), typeof e == "string" && (r = this.createTagTexts(e)), r = r.filter((a) => a.text.trim().length > 0), r.forEach((a) => {
        a = tn(a, this.tags, this.validation, this.isDuplicate), this.onBeforeAddingTag || this.addTag(a, n), this.$emit("before-adding-tag", {
          tag: a,
          addTag: () => this.addTag(a, n)
        });
      });
    },
    duplicateFilter(e) {
      return this.isDuplicate ? !this.isDuplicate(this.tagsCopy, e) : !this.tagsCopy.find((t) => t.text === e.text);
    },
    addTag(e, t = "new-tag-input") {
      const n = this.filteredAutocompleteItems.map((r) => r.text);
      this.addOnlyFromAutocomplete && n.indexOf(e.text) === -1 || this.$nextTick(() => {
        if (this.maxTags && this.maxTags <= this.tagsCopy.length) return this.$emit("max-tags-reached", e);
        if (this.avoidAddingDuplicates && !this.duplicateFilter(e)) return this.$emit("adding-duplicate", e);
        this.hasForbiddingAddRule(e.tiClasses) || (this.newTag = "", this.tagsCopy.push(e), this.$emit("update:tags", this.tagsCopy), t === "autocomplete" && this.$refs.newTagInput.focus(), this.$emit("tags-changed", this.tagsCopy));
      });
    },
    // Method to call to save a tag
    performSaveTag(e, t) {
      const n = this.tagsCopy[e];
      this.disabled || t && this.noTriggerKey(t, "addOnKey") || n.text.trim().length !== 0 && (this["on-before-saving-tag"] || this.saveTag(e, n), this.$emit("before-saving-tag", {
        index: e,
        tag: n,
        saveTag: () => this.saveTag(e, n)
      }));
    },
    saveTag(e, t) {
      if (this.avoidAddingDuplicates) {
        const n = Kt(this.tagsCopy), r = n.splice(e, 1)[0];
        if (this.isDuplicate ? this.isDuplicate(n, r) : n.map((s) => s.text).indexOf(r.text) !== -1) return this.$emit("saving-duplicate", t);
      }
      this.hasForbiddingAddRule(t.tiClasses) || (this.tagsCopy[e] = t, this.toggleEditMode(e), this.$emit("update:tags", this.tagsCopy), this.$emit("tags-changed", this.tagsCopy));
    },
    tagsEqual() {
      return !this.tagsCopy.some((e, t) => !_p(e, this.tags[t]));
    },
    updateNewTag(e) {
      const t = e.target.value;
      this.newTag = t, this.$emit("update:modelValue", t);
    },
    initTags() {
      this.tagsCopy = Cp(this.tags, this.validation, this.isDuplicate), this.tagsEditStatus = Kt(this.tags).map(() => !1), this.tagsEqual() || this.$emit("update:tags", this.tagsCopy);
    },
    blurredOnClick(e) {
      this.$el.contains(e.target) || this.$el.contains(document.activeElement) || this.performBlur(e);
    },
    performBlur() {
      this.addOnBlur && this.focused && this.performAddTags(this.newTag), this.focused = !1;
    }
  },
  watch: {
    modelValue(e) {
      this.addOnlyFromAutocomplete || (this.selectedItem = null), this.newTag = e;
    },
    tags: {
      handler() {
        this.initTags();
      },
      deep: !0
    },
    autocompleteOpen: "selectDefaultItem"
  },
  created() {
    this.newTag = this.modelValue, this.initTags();
  },
  mounted() {
    this.selectDefaultItem(), document.addEventListener("click", this.blurredOnClick);
  },
  beforeUpdate() {
    this.tagCenter = [];
  },
  unmounted() {
    document.removeEventListener("click", this.blurredOnClick);
  }
}, Pp = { class: "ti-input" }, Ap = {
  key: 0,
  class: "ti-tags"
}, kp = ["onClick"], Dp = { class: "ti-content" }, Rp = {
  key: 0,
  class: "ti-tag-left"
}, Fp = ["onClick"], Mp = {
  key: 1,
  class: "ti-tag-right"
}, xp = { class: "ti-actions" }, Up = ["onClick"], Bp = ["onClick"], Vp = { class: "ti-new-tag-input-wrapper" }, jp = ["placeholder", "value", "maxlength", "disabled"], Hp = ["onMouseover"], Gp = ["onClick"];
function Wp(e, t, n, r, a, s) {
  const o = Ks("tag-input");
  return T(), L("div", {
    class: X(["vue-tags-input pos-relative", [{ "ti-disabled": e.disabled }, { "ti-focus": e.focused }, e.$attrs.class]]),
    style: Xe(e.$attrs.style)
  }, [
    P("div", Pp, [
      e.tagsCopy ? (T(), L("ul", Ap, [
        (T(!0), L(pe, null, De(e.tagsCopy, (i, l) => (T(), L("li", {
          key: l,
          style: Xe(i.style),
          class: X([[
            { "ti-editing": e.tagsEditStatus[l] },
            i.tiClasses,
            i.classes,
            { "ti-deletion-mark": e.isMarked(l) }
          ], "ti-tag t-medium"]),
          tabindex: "0",
          onClick: (d) => e.$emit("tag-clicked", { tag: i, index: l })
        }, [
          P("div", Dp, [
            e.$slots["tag-left"] ? (T(), L("div", Rp, [
              J(e.$slots, "tag-left", {
                tag: i,
                index: l,
                edit: e.tagsEditStatus[l],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(l)
              })
            ])) : V("", !0),
            P("div", {
              ref_for: !0,
              ref: e.setTagCenter,
              class: "ti-tag-center"
            }, [
              e.$slots["tag-center"] ? V("", !0) : (T(), L("span", {
                key: 0,
                class: X({ "ti-hidden": e.tagsEditStatus[l] }),
                onClick: (d) => e.performEditTag(l)
              }, W(i.text), 11, Fp)),
              e.$slots["tag-center"] ? V("", !0) : (T(), Le(o, {
                key: 1,
                scope: {
                  edit: e.tagsEditStatus[l],
                  maxlength: e.maxlength,
                  tag: i,
                  index: l,
                  validateTag: e.createChangedTag,
                  performCancelEdit: e.cancelEdit,
                  performSaveEdit: e.performSaveTag
                }
              }, null, 8, ["scope"])),
              J(e.$slots, "tag-center", {
                tag: i,
                index: l,
                maxlength: e.maxlength,
                edit: e.tagsEditStatus[l],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                validateTag: e.createChangedTag,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(l)
              })
            ], 512),
            e.$slots["tag-right"] ? (T(), L("div", Mp, [
              J(e.$slots, "tag-right", {
                tag: i,
                index: l,
                edit: e.tagsEditStatus[l],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(l)
              })
            ])) : V("", !0)
          ]),
          P("div", xp, [
            e.$slots["tag-actions"] ? V("", !0) : Be((T(), L("i", {
              key: 0,
              class: "ti-icon-undo",
              onClick: (d) => e.cancelEdit(l)
            }, null, 8, Up)), [
              [ut, e.tagsEditStatus[l]]
            ]),
            e.$slots["tag-actions"] ? V("", !0) : Be((T(), L("i", {
              key: 1,
              class: "ti-icon-close",
              onClick: (d) => e.performDeleteTag(l)
            }, null, 8, Bp)), [
              [ut, !e.tagsEditStatus[l]]
            ]),
            e.$slots["tag-actions"] ? J(e.$slots, "tag-actions", {
              key: 2,
              tag: i,
              index: l,
              edit: e.tagsEditStatus[l],
              performSaveEdit: e.performSaveTag,
              performDelete: e.performDeleteTag,
              performCancelEdit: e.cancelEdit,
              performOpenEdit: e.performEditTag,
              deletionMark: e.isMarked(l)
            }) : V("", !0)
          ])
        ], 14, kp))), 128)),
        P("li", Vp, [
          P("input", {
            ref: "newTagInput",
            class: X([[e.createClasses(e.newTag, e.tags, e.validation, e.isDuplicate)], "ti-new-tag-input"]),
            placeholder: e.placeholder,
            value: e.newTag,
            maxlength: e.maxlength,
            disabled: e.disabled,
            type: "text",
            size: "1",
            onKeydown: [
              t[0] || (t[0] = (i) => e.performAddTags(
                e.filteredAutocompleteItems[e.selectedItem] || e.newTag,
                i
              )),
              t[2] || (t[2] = Me((...i) => e.invokeDelete && e.invokeDelete(...i), ["delete"])),
              t[3] || (t[3] = Me((...i) => e.performBlur && e.performBlur(...i), ["tab"])),
              t[4] || (t[4] = Me((i) => e.selectItem(i, "before"), ["up"])),
              t[5] || (t[5] = Me((i) => e.selectItem(i, "after"), ["down"]))
            ],
            onPaste: t[1] || (t[1] = (...i) => e.addTagsFromPaste && e.addTagsFromPaste(...i)),
            onInput: t[6] || (t[6] = (...i) => e.updateNewTag && e.updateNewTag(...i)),
            onFocus: t[7] || (t[7] = (i) => e.focused = !0),
            onClick: t[8] || (t[8] = (i) => e.addOnlyFromAutocomplete ? !1 : e.selectedItem = null)
          }, null, 42, jp)
        ])
      ])) : V("", !0)
    ]),
    J(e.$slots, "between-elements"),
    e.autocompleteOpen ? (T(), L("div", {
      key: 0,
      class: X(["ti-autocomplete", e.$attrs.class]),
      onMouseout: t[9] || (t[9] = (i) => e.selectedItem = null)
    }, [
      J(e.$slots, "autocomplete-header"),
      P("ul", null, [
        (T(!0), L(pe, null, De(e.filteredAutocompleteItems, (i, l) => (T(), L("li", {
          key: l,
          style: Xe(i.style),
          class: X([[
            i.tiClasses,
            i.classes,
            { "ti-selected-item": e.isSelected(l) }
          ], "ti-item"]),
          onMouseover: (d) => e.disabled ? !1 : e.selectedItem = l
        }, [
          e.$slots["autocomplete-item"] ? J(e.$slots, "autocomplete-item", {
            key: 1,
            item: i,
            index: l,
            performAdd: (d) => e.performAddTags(d, void 0, "autocomplete"),
            selected: e.isSelected(l)
          }) : (T(), L("div", {
            key: 0,
            onClick: (d) => e.performAddTags(i, void 0, "autocomplete")
          }, W(i.text), 9, Gp))
        ], 46, Hp))), 128))
      ]),
      J(e.$slots, "autocomplete-footer")
    ], 34)) : V("", !0)
  ], 6);
}
const Kp = /* @__PURE__ */ $t(Ip, [["render", Wp]]), Yp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kp
}, Symbol.toStringTag, { value: "Module" })), qp = {
  id: "glcanvas",
  ref: "refCanvas"
}, zp = {
  __name: "Shader",
  setup(e) {
    return Qe(() => {
      const t = document.getElementById("glcanvas"), n = t.getContext("webgl") || t.getContext("experimental-webgl"), r = `
        attribute vec4 aVertexPosition;
        void main() {
          gl_Position = aVertexPosition;
        }
     `, a = `
        precision mediump float;

       const float PI = 3.14159265358979323846264;
       const float TWOPI = PI * 2.0;
       const vec4 WHITE = vec4(0.0, 1.0, 0.533, 1); // Для цвета F6F9F7
       const vec4 BLACK = vec4(0.0, 0.9, 0.48, 1); // Для цвета EBF2ED

       const int MAX_RINGS = 30;
       const float RING_DISTANCE = 0.03;
       const float WAVE_COUNT = 60.0;
       const float WAVE_DEPTH = 0.08;

       uniform float iTime;
       uniform vec2 iResolution;

       void main() {
           float rot = mod(iTime * 0.6, TWOPI);
           vec2 fragCoord = gl_FragCoord.xy;
           vec2 pos = vec2(fragCoord.x / iResolution.x, fragCoord.y / iResolution.y);
           pos = vec2(3.0 * (pos.x - 0.5), 3.0 * (pos.y - 0.4));
           float x = pos.x;
           float y = pos.y;

           bool black = false;
           float prevRingDist = RING_DISTANCE;
           for (int i = 0; i < MAX_RINGS; i++) {
               vec2 center = vec2(0.0, 0.7 - RING_DISTANCE * float(i) * 1.2);
               float radius = 0.5 + RING_DISTANCE / (pow(float(i + 5), 1.1) * 0.006);
               float dist = distance(center, pos);
               dist = pow(dist, 0.3);
               float ringDist = abs(dist - radius);
               if (ringDist < RING_DISTANCE * prevRingDist * 7.0) {
                   float angle = atan(y - center.y, x - center.x);
                   float thickness = 1.1 * abs(dist - radius) / prevRingDist;
                   float depthFactor = WAVE_DEPTH * sin((angle + rot * radius) * WAVE_COUNT);
                   if (dist > radius) {
                       black = (thickness < RING_DISTANCE * 5.0 - depthFactor * 2.0);
                   } else {
                       black = (thickness < RING_DISTANCE * 5.0 + depthFactor);
                   }
                   break;
               }
               if (dist > radius) break;
               prevRingDist = ringDist;
           }

           gl_FragColor = black ? BLACK : WHITE;
       }

     `;
      function s(u, f, v) {
        const p = u.createShader(f);
        return u.shaderSource(p, v), u.compileShader(p), u.getShaderParameter(p, u.COMPILE_STATUS) ? p : (alert("An error occurred compiling the shaders: " + u.getShaderInfoLog(p)), u.deleteShader(p), null);
      }
      const o = s(n, n.VERTEX_SHADER, r), i = s(n, n.FRAGMENT_SHADER, a), l = n.createProgram();
      n.attachShader(l, o), n.attachShader(l, i), n.linkProgram(l), n.getProgramParameter(l, n.LINK_STATUS) || alert("Unable to initialize the shader program: " + n.getProgramInfoLog(l));
      function d(u) {
        const f = u.clientWidth * window.devicePixelRatio, v = u.clientHeight * window.devicePixelRatio;
        return u.width !== f || u.height !== v ? (u.width = f, u.height = v, !0) : !1;
      }
      function c() {
        d(n.canvas) && n.viewport(0, 0, n.canvas.width, n.canvas.height), n.clearColor(0, 0, 0, 1), n.clearDepth(1), n.enable(n.DEPTH_TEST), n.depthFunc(n.LEQUAL), n.clear(n.COLOR_BUFFER_BIT | n.DEPTH_BUFFER_BIT), n.useProgram(l);
        const u = n.createBuffer();
        n.bindBuffer(n.ARRAY_BUFFER, u);
        const f = [
          -1,
          1,
          1,
          1,
          -1,
          -1,
          1,
          -1
        ];
        n.bufferData(n.ARRAY_BUFFER, new Float32Array(f), n.STATIC_DRAW);
        const v = n.getAttribLocation(l, "aVertexPosition");
        n.vertexAttribPointer(v, 2, n.FLOAT, !1, 0, 0), n.enableVertexAttribArray(v);
        var p = n.getUniformLocation(l, "iTime"), m = n.getUniformLocation(l, "iResolution");
        n.uniform1f(p, performance.now() / 3e3), n.uniform2f(m, n.canvas.width, n.canvas.height), n.drawArrays(n.TRIANGLE_STRIP, 0, 4), requestAnimationFrame(c);
      }
      requestAnimationFrame(c);
    }), (t, n) => (T(), L("canvas", qp, null, 512));
  }
}, Xp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zp
}, Symbol.toStringTag, { value: "Module" }));
function Jp(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function xs(e) {
  return Jp(e) || Array.isArray(e);
}
function Zp() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function ia(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const a = JSON.stringify(Object.keys(e.breakpoints || {})), s = JSON.stringify(Object.keys(t.breakpoints || {}));
  return a !== s ? !1 : n.every((o) => {
    const i = e[o], l = t[o];
    return typeof i == "function" ? `${i}` == `${l}` : !xs(i) || !xs(l) ? i === l : ia(i, l);
  });
}
function Us(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function Qp(e, t) {
  if (e.length !== t.length) return !1;
  const n = Us(e), r = Us(t);
  return n.every((a, s) => {
    const o = r[s];
    return ia(a, o);
  });
}
function la(e) {
  return typeof e == "number";
}
function Rr(e) {
  return typeof e == "string";
}
function qn(e) {
  return typeof e == "boolean";
}
function Bs(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ve(e) {
  return Math.abs(e);
}
function da(e) {
  return Math.sign(e);
}
function rn(e, t) {
  return ve(e - t);
}
function em(e, t) {
  if (e === 0 || t === 0 || ve(e) <= ve(t)) return 0;
  const n = rn(ve(e), ve(t));
  return ve(n / e);
}
function pn(e) {
  return mn(e).map(Number);
}
function ct(e) {
  return e[yn(e)];
}
function yn(e) {
  return Math.max(0, e.length - 1);
}
function ua(e, t) {
  return t === yn(e);
}
function Vs(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function mn(e) {
  return Object.keys(e);
}
function ui(e, t) {
  return [e, t].reduce((n, r) => (mn(r).forEach((a) => {
    const s = n[a], o = r[a], i = Bs(s) && Bs(o);
    n[a] = i ? ui(s, o) : o;
  }), n), {});
}
function Fr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function tm(e, t) {
  const n = {
    start: r,
    center: a,
    end: s
  };
  function r() {
    return 0;
  }
  function a(l) {
    return s(l) / 2;
  }
  function s(l) {
    return t - l;
  }
  function o(l, d) {
    return Rr(e) ? n[e](l) : e(t, l, d);
  }
  return {
    measure: o
  };
}
function hn() {
  let e = [];
  function t(a, s, o, i = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in a)
      a.addEventListener(s, o, i), l = () => a.removeEventListener(s, o, i);
    else {
      const d = a;
      d.addListener(o), l = () => d.removeListener(o);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((a) => a());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function nm(e, t, n, r) {
  const a = hn(), s = 1e3 / 60;
  let o = null, i = 0, l = 0;
  function d() {
    a.add(e, "visibilitychange", () => {
      e.hidden && p();
    });
  }
  function c() {
    v(), a.clear();
  }
  function u(g) {
    if (!l) return;
    o || (o = g);
    const y = g - o;
    for (o = g, i += y; i >= s; )
      n(s), i -= s;
    const S = i / s;
    r(S), l && t.requestAnimationFrame(u);
  }
  function f() {
    l || (l = t.requestAnimationFrame(u));
  }
  function v() {
    t.cancelAnimationFrame(l), o = null, i = 0, l = 0;
  }
  function p() {
    o = null, i = 0;
  }
  return {
    init: d,
    destroy: c,
    start: f,
    stop: v,
    update: () => n(s),
    render: r
  };
}
function rm(e, t) {
  const n = t === "rtl", r = e === "y", a = r ? "y" : "x", s = r ? "x" : "y", o = !r && n ? -1 : 1, i = c(), l = u();
  function d(p) {
    const {
      height: m,
      width: g
    } = p;
    return r ? m : g;
  }
  function c() {
    return r ? "top" : n ? "right" : "left";
  }
  function u() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(p) {
    return p * o;
  }
  return {
    scroll: a,
    cross: s,
    startEdge: i,
    endEdge: l,
    measureSize: d,
    direction: f
  };
}
function Bt(e = 0, t = 0) {
  const n = ve(e - t);
  function r(d) {
    return d < e;
  }
  function a(d) {
    return d > t;
  }
  function s(d) {
    return r(d) || a(d);
  }
  function o(d) {
    return s(d) ? r(d) ? e : t : d;
  }
  function i(d) {
    return n ? d - n * Math.ceil((d - t) / n) : d;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: o,
    reachedAny: s,
    reachedMax: a,
    reachedMin: r,
    removeOffset: i
  };
}
function ci(e, t, n) {
  const {
    constrain: r
  } = Bt(0, e), a = e + 1;
  let s = o(t);
  function o(f) {
    return n ? ve((a + f) % a) : r(f);
  }
  function i() {
    return s;
  }
  function l(f) {
    return s = o(f), u;
  }
  function d(f) {
    return c().set(i() + f);
  }
  function c() {
    return ci(e, i(), n);
  }
  const u = {
    get: i,
    set: l,
    add: d,
    clone: c
  };
  return u;
}
function am(e, t, n, r, a, s, o, i, l, d, c, u, f, v, p, m, g, y, S) {
  const {
    cross: $,
    direction: E
  } = e, O = ["INPUT", "SELECT", "TEXTAREA"], _ = {
    passive: !1
  }, w = hn(), k = hn(), C = Bt(50, 225).constrain(v.measure(20)), M = {
    mouse: 300,
    touch: 400
  }, U = {
    mouse: 500,
    touch: 600
  }, j = p ? 43 : 25;
  let Y = !1, $e = 0, Se = 0, de = !1, Ue = !1, ye = !1, Re = !1;
  function et(G) {
    if (!S) return;
    function D(B) {
      (qn(S) || S(G, B)) && nt(B);
    }
    const N = t;
    w.add(N, "dragstart", (B) => B.preventDefault(), _).add(N, "touchmove", () => {
    }, _).add(N, "touchend", () => {
    }).add(N, "touchstart", D).add(N, "mousedown", D).add(N, "touchcancel", _e).add(N, "contextmenu", _e).add(N, "click", Fe, !0);
  }
  function Ie() {
    w.clear(), k.clear();
  }
  function be() {
    const G = Re ? n : t;
    k.add(G, "touchmove", Oe, _).add(G, "touchend", _e).add(G, "mousemove", Oe, _).add(G, "mouseup", _e);
  }
  function Pe(G) {
    const D = G.nodeName || "";
    return O.includes(D);
  }
  function Ae() {
    return (p ? U : M)[Re ? "mouse" : "touch"];
  }
  function tt(G, D) {
    const N = u.add(da(G) * -1), B = c.byDistance(G, !p).distance;
    return p || ve(G) < C ? B : g && D ? B * 0.5 : c.byIndex(N.get(), 0).distance;
  }
  function nt(G) {
    const D = Fr(G, r);
    Re = D, ye = p && D && !G.buttons && Y, Y = rn(a.get(), o.get()) >= 2, !(D && G.button !== 0) && (Pe(G.target) || (de = !0, s.pointerDown(G), d.useFriction(0).useDuration(0), a.set(o), be(), $e = s.readPoint(G), Se = s.readPoint(G, $), f.emit("pointerDown")));
  }
  function Oe(G) {
    if (!Fr(G, r) && G.touches.length >= 2) return _e(G);
    const N = s.readPoint(G), B = s.readPoint(G, $), te = rn(N, $e), he = rn(B, Se);
    if (!Ue && !Re && (!G.cancelable || (Ue = te > he, !Ue)))
      return _e(G);
    const Ne = s.pointerMove(G);
    te > m && (ye = !0), d.useFriction(0.3).useDuration(0.75), i.start(), a.add(E(Ne)), G.preventDefault();
  }
  function _e(G) {
    const N = c.byDistance(0, !1).index !== u.get(), B = s.pointerUp(G) * Ae(), te = tt(E(B), N), he = em(B, te), Ne = j - 10 * he, He = y + he / 50;
    Ue = !1, de = !1, k.clear(), d.useDuration(Ne).useFriction(He), l.distance(te, !p), Re = !1, f.emit("pointerUp");
  }
  function Fe(G) {
    ye && (G.stopPropagation(), G.preventDefault(), ye = !1);
  }
  function Ce() {
    return de;
  }
  return {
    init: et,
    destroy: Ie,
    pointerDown: Ce
  };
}
function sm(e, t) {
  let r, a;
  function s(u) {
    return u.timeStamp;
  }
  function o(u, f) {
    const p = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (Fr(u, t) ? u : u.touches[0])[p];
  }
  function i(u) {
    return r = u, a = u, o(u);
  }
  function l(u) {
    const f = o(u) - o(a), v = s(u) - s(r) > 170;
    return a = u, v && (r = u), f;
  }
  function d(u) {
    if (!r || !a) return 0;
    const f = o(a) - o(r), v = s(u) - s(r), p = s(u) - s(a) > 170, m = f / v;
    return v && !p && ve(m) > 0.1 ? m : 0;
  }
  return {
    pointerDown: i,
    pointerMove: l,
    pointerUp: d,
    readPoint: o
  };
}
function om() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: a,
      offsetWidth: s,
      offsetHeight: o
    } = n;
    return {
      top: r,
      right: a + s,
      bottom: r + o,
      left: a,
      width: s,
      height: o
    };
  }
  return {
    measure: e
  };
}
function im(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function lm(e, t, n, r, a, s, o) {
  const i = [e].concat(r);
  let l, d, c = [], u = !1;
  function f(g) {
    return a.measureSize(o.measure(g));
  }
  function v(g) {
    if (!s) return;
    d = f(e), c = r.map(f);
    function y(S) {
      for (const $ of S) {
        if (u) return;
        const E = $.target === e, O = r.indexOf($.target), _ = E ? d : c[O], w = f(E ? e : r[O]);
        if (ve(w - _) >= 0.5) {
          g.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((S) => {
      (qn(s) || s(g, S)) && y(S);
    }), n.requestAnimationFrame(() => {
      i.forEach((S) => l.observe(S));
    });
  }
  function p() {
    u = !0, l && l.disconnect();
  }
  return {
    init: v,
    destroy: p
  };
}
function dm(e, t, n, r, a, s) {
  let o = 0, i = 0, l = a, d = s, c = e.get(), u = 0;
  function f(_) {
    const w = _ / 1e3, k = l * w, C = r.get() - e.get(), M = !l;
    let U = 0;
    return M ? (o = 0, n.set(r), e.set(r), U = C) : (n.set(e), o += C / k, o *= d, c += o, e.add(o * w), U = c - u), i = da(U), u = c, O;
  }
  function v() {
    const _ = r.get() - t.get();
    return ve(_) < 1e-3;
  }
  function p() {
    return l;
  }
  function m() {
    return i;
  }
  function g() {
    return o;
  }
  function y() {
    return $(a);
  }
  function S() {
    return E(s);
  }
  function $(_) {
    return l = _, O;
  }
  function E(_) {
    return d = _, O;
  }
  const O = {
    direction: m,
    duration: p,
    velocity: g,
    seek: f,
    settled: v,
    useBaseFriction: S,
    useBaseDuration: y,
    useFriction: E,
    useDuration: $
  };
  return O;
}
function um(e, t, n, r, a) {
  const s = a.measure(10), o = a.measure(50), i = Bt(0.1, 0.99);
  let l = !1;
  function d() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function c(v) {
    if (!d()) return;
    const p = e.reachedMin(t.get()) ? "min" : "max", m = ve(e[p] - t.get()), g = n.get() - t.get(), y = i.constrain(m / o);
    n.subtract(g * y), !v && ve(g) < s && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function u(v) {
    l = !v;
  }
  return {
    shouldConstrain: d,
    constrain: c,
    toggleActive: u
  };
}
function cm(e, t, n, r, a) {
  const s = Bt(-t + e, 0), o = u(), i = c(), l = f();
  function d(p, m) {
    return rn(p, m) < 1;
  }
  function c() {
    const p = o[0], m = ct(o), g = o.lastIndexOf(p), y = o.indexOf(m) + 1;
    return Bt(g, y);
  }
  function u() {
    return n.map((p, m) => {
      const {
        min: g,
        max: y
      } = s, S = s.constrain(p), $ = !m, E = ua(n, m);
      return $ ? y : E || d(g, S) ? g : d(y, S) ? y : S;
    }).map((p) => parseFloat(p.toFixed(3)));
  }
  function f() {
    if (t <= e + a) return [s.max];
    if (r === "keepSnaps") return o;
    const {
      min: p,
      max: m
    } = i;
    return o.slice(p, m);
  }
  return {
    snapsContained: l,
    scrollContainLimit: i
  };
}
function fm(e, t, n) {
  const r = t[0], a = n ? r - e : ct(t);
  return {
    limit: Bt(a, r)
  };
}
function pm(e, t, n, r) {
  const s = t.min + 0.1, o = t.max + 0.1, {
    reachedMin: i,
    reachedMax: l
  } = Bt(s, o);
  function d(f) {
    return f === 1 ? l(n.get()) : f === -1 ? i(n.get()) : !1;
  }
  function c(f) {
    if (!d(f)) return;
    const v = e * (f * -1);
    r.forEach((p) => p.add(v));
  }
  return {
    loop: c
  };
}
function mm(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(s) {
    const o = s - t;
    return n ? o / -n : 0;
  }
  return {
    get: r
  };
}
function hm(e, t, n, r, a) {
  const {
    startEdge: s,
    endEdge: o
  } = e, {
    groupSlides: i
  } = a, l = u().map(t.measure), d = f(), c = v();
  function u() {
    return i(r).map((m) => ct(m)[o] - m[0][s]).map(ve);
  }
  function f() {
    return r.map((m) => n[s] - m[s]).map((m) => -ve(m));
  }
  function v() {
    return i(d).map((m) => m[0]).map((m, g) => m + l[g]);
  }
  return {
    snaps: d,
    snapsAligned: c
  };
}
function $m(e, t, n, r, a, s) {
  const {
    groupSlides: o
  } = a, {
    min: i,
    max: l
  } = r, d = c();
  function c() {
    const f = o(s), v = !e || t === "keepSnaps";
    return n.length === 1 ? [s] : v ? f : f.slice(i, l).map((p, m, g) => {
      const y = !m, S = ua(g, m);
      if (y) {
        const $ = ct(g[0]) + 1;
        return Vs($);
      }
      if (S) {
        const $ = yn(s) - ct(g)[0] + 1;
        return Vs($, ct(g)[0]);
      }
      return p;
    });
  }
  return {
    slideRegistry: d
  };
}
function gm(e, t, n, r, a) {
  const {
    reachedAny: s,
    removeOffset: o,
    constrain: i
  } = r;
  function l(p) {
    return p.concat().sort((m, g) => ve(m) - ve(g))[0];
  }
  function d(p) {
    const m = e ? o(p) : i(p), g = t.map((S, $) => ({
      diff: c(S - m, 0),
      index: $
    })).sort((S, $) => ve(S.diff) - ve($.diff)), {
      index: y
    } = g[0];
    return {
      index: y,
      distance: m
    };
  }
  function c(p, m) {
    const g = [p, p + n, p - n];
    if (!e) return p;
    if (!m) return l(g);
    const y = g.filter((S) => da(S) === m);
    return y.length ? l(y) : ct(g) - n;
  }
  function u(p, m) {
    const g = t[p] - a.get(), y = c(g, m);
    return {
      index: p,
      distance: y
    };
  }
  function f(p, m) {
    const g = a.get() + p, {
      index: y,
      distance: S
    } = d(g), $ = !e && s(g);
    if (!m || $) return {
      index: y,
      distance: p
    };
    const E = t[y] - S, O = p + c(E, 0);
    return {
      index: y,
      distance: O
    };
  }
  return {
    byDistance: f,
    byIndex: u,
    shortcut: c
  };
}
function vm(e, t, n, r, a, s, o) {
  function i(u) {
    const f = u.distance, v = u.index !== t.get();
    s.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), v && (n.set(t.get()), t.set(u.index), o.emit("select"));
  }
  function l(u, f) {
    const v = a.byDistance(u, f);
    i(v);
  }
  function d(u, f) {
    const v = t.clone().set(u), p = a.byIndex(v.get(), f);
    i(p);
  }
  return {
    distance: l,
    index: d
  };
}
function ym(e, t, n, r, a, s, o, i) {
  const l = {
    passive: !0,
    capture: !0
  };
  let d = 0;
  function c(v) {
    if (!i) return;
    function p(m) {
      if ((/* @__PURE__ */ new Date()).getTime() - d > 10) return;
      o.emit("slideFocusStart"), e.scrollLeft = 0;
      const S = n.findIndex(($) => $.includes(m));
      la(S) && (a.useDuration(0), r.index(S, 0), o.emit("slideFocus"));
    }
    s.add(document, "keydown", u, !1), t.forEach((m, g) => {
      s.add(m, "focus", (y) => {
        (qn(i) || i(v, y)) && p(g);
      }, l);
    });
  }
  function u(v) {
    v.code === "Tab" && (d = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: c
  };
}
function nn(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = o(l);
  }
  function a(l) {
    t += o(l);
  }
  function s(l) {
    t -= o(l);
  }
  function o(l) {
    return la(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: a,
    subtract: s
  };
}
function fi(e, t) {
  const n = e.scroll === "x" ? s : o, r = t.style;
  let a = !1;
  function s(u) {
    return `translate3d(${u}px,0px,0px)`;
  }
  function o(u) {
    return `translate3d(0px,${u}px,0px)`;
  }
  function i(u) {
    a || (r.transform = n(e.direction(u)));
  }
  function l(u) {
    a = !u;
  }
  function d() {
    a || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: d,
    to: i,
    toggleActive: l
  };
}
function bm(e, t, n, r, a, s, o, i, l) {
  const c = pn(a), u = pn(a).reverse(), f = y().concat(S());
  function v(w, k) {
    return w.reduce((C, M) => C - a[M], k);
  }
  function p(w, k) {
    return w.reduce((C, M) => v(C, k) > 0 ? C.concat([M]) : C, []);
  }
  function m(w) {
    return s.map((k, C) => ({
      start: k - r[C] + 0.5 + w,
      end: k + t - 0.5 + w
    }));
  }
  function g(w, k, C) {
    const M = m(k);
    return w.map((U) => {
      const j = C ? 0 : -n, Y = C ? n : 0, $e = C ? "end" : "start", Se = M[U][$e];
      return {
        index: U,
        loopPoint: Se,
        slideLocation: nn(-1),
        translate: fi(e, l[U]),
        target: () => i.get() > Se ? j : Y
      };
    });
  }
  function y() {
    const w = o[0], k = p(u, w);
    return g(k, n, !1);
  }
  function S() {
    const w = t - o[0] - 1, k = p(c, w);
    return g(k, -n, !0);
  }
  function $() {
    return f.every(({
      index: w
    }) => {
      const k = c.filter((C) => C !== w);
      return v(k, t) <= 0.1;
    });
  }
  function E() {
    f.forEach((w) => {
      const {
        target: k,
        translate: C,
        slideLocation: M
      } = w, U = k();
      U !== M.get() && (C.to(U), M.set(U));
    });
  }
  function O() {
    f.forEach((w) => w.translate.clear());
  }
  return {
    canLoop: $,
    clear: O,
    loop: E,
    loopPoints: f
  };
}
function _m(e, t, n) {
  let r, a = !1;
  function s(l) {
    if (!n) return;
    function d(c) {
      for (const u of c)
        if (u.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((c) => {
      a || (qn(n) || n(l, c)) && d(c);
    }), r.observe(e, {
      childList: !0
    });
  }
  function o() {
    r && r.disconnect(), a = !0;
  }
  return {
    init: s,
    destroy: o
  };
}
function Em(e, t, n, r) {
  const a = {};
  let s = null, o = null, i, l = !1;
  function d() {
    i = new IntersectionObserver((p) => {
      l || (p.forEach((m) => {
        const g = t.indexOf(m.target);
        a[g] = m;
      }), s = null, o = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((p) => i.observe(p));
  }
  function c() {
    i && i.disconnect(), l = !0;
  }
  function u(p) {
    return mn(a).reduce((m, g) => {
      const y = parseInt(g), {
        isIntersecting: S
      } = a[y];
      return (p && S || !p && !S) && m.push(y), m;
    }, []);
  }
  function f(p = !0) {
    if (p && s) return s;
    if (!p && o) return o;
    const m = u(p);
    return p && (s = m), p || (o = m), m;
  }
  return {
    init: d,
    destroy: c,
    get: f
  };
}
function Om(e, t, n, r, a, s) {
  const {
    measureSize: o,
    startEdge: i,
    endEdge: l
  } = e, d = n[0] && a, c = p(), u = m(), f = n.map(o), v = g();
  function p() {
    if (!d) return 0;
    const S = n[0];
    return ve(t[i] - S[i]);
  }
  function m() {
    if (!d) return 0;
    const S = s.getComputedStyle(ct(r));
    return parseFloat(S.getPropertyValue(`margin-${l}`));
  }
  function g() {
    return n.map((S, $, E) => {
      const O = !$, _ = ua(E, $);
      return O ? f[$] + c : _ ? f[$] + u : E[$ + 1][i] - S[i];
    }).map(ve);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: v,
    startGap: c,
    endGap: u
  };
}
function Cm(e, t, n, r, a, s, o, i, l) {
  const {
    startEdge: d,
    endEdge: c,
    direction: u
  } = e, f = la(n);
  function v(y, S) {
    return pn(y).filter(($) => $ % S === 0).map(($) => y.slice($, $ + S));
  }
  function p(y) {
    return y.length ? pn(y).reduce((S, $, E) => {
      const O = ct(S) || 0, _ = O === 0, w = $ === yn(y), k = a[d] - s[O][d], C = a[d] - s[$][c], M = !r && _ ? u(o) : 0, U = !r && w ? u(i) : 0, j = ve(C - U - (k + M));
      return E && j > t + l && S.push($), w && S.push(y.length), S;
    }, []).map((S, $, E) => {
      const O = Math.max(E[$ - 1] || 0);
      return y.slice(O, S);
    }) : [];
  }
  function m(y) {
    return f ? v(y, n) : p(y);
  }
  return {
    groupSlides: m
  };
}
function Tm(e, t, n, r, a, s, o) {
  const {
    align: i,
    axis: l,
    direction: d,
    startIndex: c,
    loop: u,
    duration: f,
    dragFree: v,
    dragThreshold: p,
    inViewThreshold: m,
    slidesToScroll: g,
    skipSnaps: y,
    containScroll: S,
    watchResize: $,
    watchSlides: E,
    watchDrag: O,
    watchFocus: _
  } = s, w = 2, k = om(), C = k.measure(t), M = n.map(k.measure), U = rm(l, d), j = U.measureSize(C), Y = im(j), $e = tm(i, j), Se = !u && !!S, de = u || !!S, {
    slideSizes: Ue,
    slideSizesWithGaps: ye,
    startGap: Re,
    endGap: et
  } = Om(U, C, M, n, de, a), Ie = Cm(U, j, g, u, C, M, Re, et, w), {
    snaps: be,
    snapsAligned: Pe
  } = hm(U, $e, C, M, Ie), Ae = -ct(be) + ct(ye), {
    snapsContained: tt,
    scrollContainLimit: nt
  } = cm(j, Ae, Pe, S, w), Oe = Se ? tt : Pe, {
    limit: _e
  } = fm(Ae, Oe, u), Fe = ci(yn(Oe), c, u), Ce = Fe.clone(), ne = pn(n), G = ({
    dragHandler: ie,
    scrollBody: st,
    scrollBounds: St,
    options: {
      loop: it
    }
  }, lt) => {
    it || St.constrain(ie.pointerDown()), st.seek(lt);
  }, D = ({
    scrollBody: ie,
    translate: st,
    location: St,
    offsetLocation: it,
    scrollLooper: lt,
    slideLooper: zn,
    dragHandler: bn,
    animation: pi,
    eventHandler: pa,
    scrollBounds: mi,
    options: {
      loop: ma
    }
  }, ha) => {
    const $a = ie.settled(), hi = !mi.shouldConstrain(), ga = ma ? $a : $a && hi;
    ga && !bn.pointerDown() && (pi.stop(), pa.emit("settle")), ga || pa.emit("scroll");
    const $i = St.get() * ha + Ne.get() * (1 - ha);
    it.set($i), ma && (lt.loop(ie.direction()), zn.loop()), st.to(it.get());
  }, N = nm(r, a, (ie) => G(ee, ie), (ie) => D(ee, ie)), B = 0.68, te = Oe[Fe.get()], he = nn(te), Ne = nn(te), He = nn(te), h = nn(te), b = dm(he, He, Ne, h, f, B), R = gm(u, Oe, Ae, _e, h), K = vm(N, Fe, Ce, b, R, h, o), ue = mm(_e), oe = hn(), re = Em(t, n, o, m), {
    slideRegistry: A
  } = $m(Se, S, Oe, nt, Ie, ne), x = ym(e, n, A, K, b, oe, o, _), ee = {
    ownerDocument: r,
    ownerWindow: a,
    eventHandler: o,
    containerRect: C,
    slideRects: M,
    animation: N,
    axis: U,
    dragHandler: am(U, e, r, a, h, sm(U, a), he, N, K, b, R, Fe, o, Y, v, p, y, B, O),
    eventStore: oe,
    percentOfView: Y,
    index: Fe,
    indexPrevious: Ce,
    limit: _e,
    location: he,
    offsetLocation: He,
    previousLocation: Ne,
    options: s,
    resizeHandler: lm(t, o, a, n, U, $, k),
    scrollBody: b,
    scrollBounds: um(_e, He, h, b, Y),
    scrollLooper: pm(Ae, _e, He, [he, He, Ne, h]),
    scrollProgress: ue,
    scrollSnapList: Oe.map(ue.get),
    scrollSnaps: Oe,
    scrollTarget: R,
    scrollTo: K,
    slideLooper: bm(U, j, Ae, Ue, ye, be, Oe, He, n),
    slideFocus: x,
    slidesHandler: _m(t, o, E),
    slidesInView: re,
    slideIndexes: ne,
    slideRegistry: A,
    slidesToScroll: Ie,
    target: h,
    translate: fi(U, t)
  };
  return ee;
}
function Sm() {
  let e = {}, t;
  function n(d) {
    t = d;
  }
  function r(d) {
    return e[d] || [];
  }
  function a(d) {
    return r(d).forEach((c) => c(t, d)), l;
  }
  function s(d, c) {
    return e[d] = r(d).concat([c]), l;
  }
  function o(d, c) {
    return e[d] = r(d).filter((u) => u !== c), l;
  }
  function i() {
    e = {};
  }
  const l = {
    init: n,
    emit: a,
    off: o,
    on: s,
    clear: i
  };
  return l;
}
const wm = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Nm(e) {
  function t(s, o) {
    return ui(s, o || {});
  }
  function n(s) {
    const o = s.breakpoints || {}, i = mn(o).filter((l) => e.matchMedia(l).matches).map((l) => o[l]).reduce((l, d) => t(l, d), {});
    return t(s, i);
  }
  function r(s) {
    return s.map((o) => mn(o.breakpoints || {})).reduce((o, i) => o.concat(i), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function Lm(e) {
  let t = [];
  function n(s, o) {
    return t = o.filter(({
      options: i
    }) => e.optionsAtMedia(i).active !== !1), t.forEach((i) => i.init(s, e)), o.reduce((i, l) => Object.assign(i, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((s) => s.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Rn(e, t, n) {
  const r = e.ownerDocument, a = r.defaultView, s = Nm(a), o = Lm(s), i = hn(), l = Sm(), {
    mergeOptions: d,
    optionsAtMedia: c,
    optionsMediaQueries: u
  } = s, {
    on: f,
    off: v,
    emit: p
  } = l, m = U;
  let g = !1, y, S = d(wm, Rn.globalOptions), $ = d(S), E = [], O, _, w;
  function k() {
    const {
      container: ne,
      slides: G
    } = $;
    _ = (Rr(ne) ? e.querySelector(ne) : ne) || e.children[0];
    const N = Rr(G) ? _.querySelectorAll(G) : G;
    w = [].slice.call(N || _.children);
  }
  function C(ne) {
    const G = Tm(e, _, w, r, a, ne, l);
    if (ne.loop && !G.slideLooper.canLoop()) {
      const D = Object.assign({}, ne, {
        loop: !1
      });
      return C(D);
    }
    return G;
  }
  function M(ne, G) {
    g || (S = d(S, ne), $ = c(S), E = G || E, k(), y = C($), u([S, ...E.map(({
      options: D
    }) => D)]).forEach((D) => i.add(D, "change", U)), $.active && (y.translate.to(y.location.get()), y.animation.init(), y.slidesInView.init(), y.slideFocus.init(Ce), y.eventHandler.init(Ce), y.resizeHandler.init(Ce), y.slidesHandler.init(Ce), y.options.loop && y.slideLooper.loop(), _.offsetParent && w.length && y.dragHandler.init(Ce), O = o.init(Ce, E)));
  }
  function U(ne, G) {
    const D = Ie();
    j(), M(d({
      startIndex: D
    }, ne), G), l.emit("reInit");
  }
  function j() {
    y.dragHandler.destroy(), y.eventStore.clear(), y.translate.clear(), y.slideLooper.clear(), y.resizeHandler.destroy(), y.slidesHandler.destroy(), y.slidesInView.destroy(), y.animation.destroy(), o.destroy(), i.clear();
  }
  function Y() {
    g || (g = !0, i.clear(), j(), l.emit("destroy"), l.clear());
  }
  function $e(ne, G, D) {
    !$.active || g || (y.scrollBody.useBaseFriction().useDuration(G === !0 ? 0 : $.duration), y.scrollTo.index(ne, D || 0));
  }
  function Se(ne) {
    const G = y.index.add(1).get();
    $e(G, ne, -1);
  }
  function de(ne) {
    const G = y.index.add(-1).get();
    $e(G, ne, 1);
  }
  function Ue() {
    return y.index.add(1).get() !== Ie();
  }
  function ye() {
    return y.index.add(-1).get() !== Ie();
  }
  function Re() {
    return y.scrollSnapList;
  }
  function et() {
    return y.scrollProgress.get(y.location.get());
  }
  function Ie() {
    return y.index.get();
  }
  function be() {
    return y.indexPrevious.get();
  }
  function Pe() {
    return y.slidesInView.get();
  }
  function Ae() {
    return y.slidesInView.get(!1);
  }
  function tt() {
    return O;
  }
  function nt() {
    return y;
  }
  function Oe() {
    return e;
  }
  function _e() {
    return _;
  }
  function Fe() {
    return w;
  }
  const Ce = {
    canScrollNext: Ue,
    canScrollPrev: ye,
    containerNode: _e,
    internalEngine: nt,
    destroy: Y,
    off: v,
    on: f,
    emit: p,
    plugins: tt,
    previousScrollSnap: be,
    reInit: m,
    rootNode: Oe,
    scrollNext: Se,
    scrollPrev: de,
    scrollProgress: et,
    scrollSnapList: Re,
    scrollTo: $e,
    selectedScrollSnap: Ie,
    slideNodes: Fe,
    slidesInView: Pe,
    slidesNotInView: Ae
  };
  return M(t, n), setTimeout(() => l.emit("init"), 0), Ce;
}
Rn.globalOptions = void 0;
function ca(e = {}, t = []) {
  const n = dr(e), r = dr(t);
  let a = n ? e.value : e, s = r ? t.value : t;
  const o = an(), i = an();
  function l() {
    i.value && i.value.reInit(a, s);
  }
  return Qe(() => {
    !Zp() || !o.value || (Rn.globalOptions = ca.globalOptions, i.value = Rn(o.value, a, s));
  }), Br(() => {
    i.value && i.value.destroy();
  }), n && Te(e, (d) => {
    ia(a, d) || (a = d, l());
  }), r && Te(t, (d) => {
    Qp(s, d) || (s = d, l());
  }), [o, i];
}
ca.globalOptions = void 0;
const Im = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function fa(e = {}) {
  let t, n, r, a = !1, s = !0, o = !1, i = 0;
  function l(E, O) {
    n = E;
    const {
      mergeOptions: _,
      optionsAtMedia: w
    } = O, k = _(Im, fa.globalOptions), C = _(k, e);
    if (t = w(C), n.scrollSnapList().length <= 1) return;
    o = t.jump, r = !1;
    const {
      eventStore: M,
      ownerDocument: U
    } = n.internalEngine(), j = n.rootNode(), Y = t.rootNode && t.rootNode(j) || j, $e = n.containerNode();
    n.on("pointerDown", u), t.stopOnInteraction || n.on("pointerUp", c), t.stopOnMouseEnter && (M.add(Y, "mouseenter", () => {
      s = !1, u();
    }), t.stopOnInteraction || M.add(Y, "mouseleave", () => {
      s = !0, c();
    })), t.stopOnFocusIn && (n.on("slideFocusStart", u), t.stopOnInteraction || M.add($e, "focusout", c)), M.add(U, "visibilitychange", f), t.playOnInit && !v() && c();
  }
  function d() {
    n.off("pointerDown", u).off("pointerUp", c).off("slideFocusStart", u), u(), r = !0, a = !1;
  }
  function c() {
    if (r || !s) return;
    a || n.emit("autoplay:play");
    const {
      ownerWindow: E
    } = n.internalEngine();
    E.clearInterval(i), i = E.setInterval(S, t.delay), a = !0;
  }
  function u() {
    if (r) return;
    a && n.emit("autoplay:stop");
    const {
      ownerWindow: E
    } = n.internalEngine();
    E.clearInterval(i), i = 0, a = !1;
  }
  function f() {
    if (v())
      return s = a, u();
    s && c();
  }
  function v() {
    const {
      ownerDocument: E
    } = n.internalEngine();
    return E.visibilityState === "hidden";
  }
  function p(E) {
    typeof E < "u" && (o = E), s = !0, c();
  }
  function m() {
    a && u();
  }
  function g() {
    a && p();
  }
  function y() {
    return a;
  }
  function S() {
    const {
      index: E
    } = n.internalEngine(), O = E.clone().add(1).get(), _ = n.scrollSnapList().length - 1;
    t.stopOnLastSnap && O === _ && u(), n.canScrollNext() ? n.scrollNext(o) : n.scrollTo(0, o);
  }
  return {
    name: "autoplay",
    options: e,
    init: l,
    destroy: d,
    play: p,
    stop: m,
    reset: g,
    isPlaying: y
  };
}
fa.globalOptions = void 0;
const Pm = { class: "embla__container" }, Am = {
  __name: "Slider",
  props: {
    store: Object,
    options: Object,
    text: Object,
    user: Object
  },
  setup(e) {
    const t = e;
    to();
    const n = F([]), r = F(!0), a = F(0), s = {
      delay: 2e3,
      jump: !1,
      stopOnInteraction: !1,
      stopOnMouseEnter: !1,
      stopOnFocusIn: !0,
      stopOnLastSnap: !1,
      rootNode: (d) => d.parentElement
    }, [o, i] = ca(
      { loop: !0 },
      [
        fa(s)
      ]
    ), l = (d) => a.value = i.value.selectedScrollSnap();
    return Qe(async () => {
      n.value = await t.store.read(t.options), r.value = !1, l(), i.value.on("reInit", l), i.value.on("select", l);
    }), (d, c) => (T(), L("div", {
      class: "embla",
      ref_key: "emblaNode",
      ref: o
    }, [
      P("div", Pm, [
        (T(!0), L(pe, null, De(n.value, (u, f, v) => (T(), L("div", {
          class: "embla__slide pd-nano",
          key: f
        }, [
          Q(xe, {
            name: "fade",
            mode: "out-in",
            appear: ""
          }, {
            default: fe(() => [
              J(d.$slots, "default", {
                item: u,
                user: e.user
              })
            ]),
            _: 2
          }, 1024)
        ]))), 128))
      ])
    ], 512));
  }
}, km = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Am
}, Symbol.toStringTag, { value: "Module" })), Dm = { class: "pd-small error-wrapper" }, Rm = { class: "flex-nowrap flex radius-small pd-small t-white bg-fourth" }, Fm = { class: "w-100" }, Mm = {
  __name: "Status",
  props: {
    status: String,
    message: String,
    show: Boolean,
    data: Object
  },
  emits: "close",
  setup(e, { emit: t }) {
    const n = t;
    function r() {
      n("close");
    }
    return (a, s) => (T(), L("div", Dm, [
      P("div", Rm, [
        P("p", Fm, [
          mt(W(e.data.message) + " ", 1),
          s[1] || (s[1] = P("br", null, null, -1))
        ]),
        Q(ta, {
          onClick: s[0] || (s[0] = (o) => r()),
          class: "cursor-pointer hover-scale-1 i-regular z-index-5"
        })
      ])
    ]));
  }
}, xm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mm
}, Symbol.toStringTag, { value: "Module" })), Um = {
  class: "marquee",
  "aria-hidden": !0
}, Bm = {
  __name: "Marquee",
  props: {
    vertical: { type: Boolean, default: !1 },
    direction: { type: String, default: "normal" },
    duration: { type: Number, default: 20 },
    delay: { type: Number, default: 0 },
    loop: { type: Number, default: 0 },
    clone: { type: Boolean, default: !1 },
    gradient: { type: Boolean, default: !1 },
    gradientColor: { type: [Array, String], default: () => [255, 255, 255] },
    gradientLength: { type: String },
    pauseOnHover: { type: Boolean, default: !1 },
    pauseOnClick: { type: Boolean, default: !1 },
    pause: { type: Boolean, default: !1 }
  },
  emits: ["onComplete", "onLoopComplete", "onPause", "onResume"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = F(!1), s = F(0), o = F(0), i = F(0), l = F(null), d = F("100%"), c = F(0), u = F(0), f = F("100%"), v = F(0), p = F(0), m = F("200px"), g = F(!1), y = F(null), S = F(null), $ = async () => {
      await E(), s.value++;
    }, E = async () => {
      n.vertical && (g.value = !0), setInterval(() => {
        if (d.value = "0%", f.value = "0%", y.value !== null && S.value !== null)
          if (y.value && S.value)
            if (n.vertical && "clientHeight" in y.value && "clientHeight" in S.value) {
              p.value = y.value.clientHeight, v.value = S.value.clientHeight;
              const U = Math.ceil(v.value / p.value);
              return o.value = isFinite(U) ? U : 0, g.value = !1, o.value;
            } else if (!n.vertical && "clientWidth" in y.value && "clientWidth" in S.value) {
              u.value = y.value.clientWidth, c.value = S.value.clientWidth;
              const U = Math.ceil(c.value / u.value);
              return o.value = isFinite(U) ? U : 0, o.value;
            } else
              return d.value = "100%", f.value = "100%", 0;
          else
            return d.value = "100%", f.value = "100%", 0;
        else
          return d.value = "100%", f.value = "100%", 0;
      }, 100);
    }, O = () => {
      n.pauseOnHover && r("onPause");
    }, _ = () => {
      n.pauseOnHover && r("onResume");
    }, w = () => {
      n.pauseOnClick && r("onPause");
    }, k = () => {
      n.pauseOnClick && r("onResume");
    }, C = ae(() => ({
      "--loops": `${n.loop === 0 ? "infinite" : n.loop}`,
      "--duration": `${n.duration}s`,
      "--delay": `${n.delay}s`,
      "--direction": `${n.direction}`,
      "--pauseOnHover": `${n.pauseOnHover ? "paused" : "running"}`,
      "--pauseOnClick": `${n.pauseOnClick ? "paused" : "running"}`,
      "--pauseAnimation": `${n.vertical && g.value || n.pause ? "paused" : "running"}`,
      "--gradient-color": `rgba(${n.gradientColor}, 1), rgba(${n.gradientColor}, 0)`,
      "--gradient-length": `${m.value}`,
      "--min-width": `${d.value}`,
      "--min-height": `${f.value}`,
      "--orientation": n.vertical ? "scrollY" : "scrollX"
    })), M = async () => {
      n.vertical ? (f.value = "100%", d.value = "auto") : (f.value = "auto", d.value = "100%"), n.gradient && n.gradientLength && (m.value = n.gradientLength), n.clone && (await E(), $()), a.value = !0;
    };
    return Qe(async () => {
      M(), l.value = setInterval(() => {
        i.value++, n.loop !== 0 && i.value === n.loop && (r("onComplete"), clearInterval(l.value)), r("onLoopComplete");
      }, n.duration * 1e3);
    }), Br(() => {
      clearInterval(l.value);
    }), Te(u, async () => {
      n.clone && $();
    }), Te(c, async () => {
      n.clone && $();
    }), Te(
      () => n.pause,
      (U, j) => {
        U !== j && r(U ? "onResume" : "onPause");
      }
    ), (U, j) => a.value ? (T(), L("div", {
      class: X(["vue3-marquee", { vertical: e.vertical, horizontal: !e.vertical }]),
      style: Xe(C.value),
      key: s.value,
      onMouseenter: O,
      onMouseleave: _,
      onMousedown: w,
      onMouseup: k
    }, [
      P("div", {
        class: X(["transparent-overlay", { vertical: e.vertical, horizontal: !e.vertical, overlay: e.gradient }]),
        ref_key: "marqueeOverlayContainer",
        ref: S,
        "aria-hidden": !0
      }, null, 2),
      P("div", {
        class: "marquee",
        ref_key: "marqueeContent",
        ref: y
      }, [
        J(U.$slots, "default")
      ], 512),
      P("div", Um, [
        J(U.$slots, "default")
      ]),
      (T(!0), L(pe, null, De(o.value, (Y) => (T(), L("div", {
        key: Y,
        "aria-hidden": !0,
        class: "marquee cloned"
      }, [
        J(U.$slots, "default")
      ]))), 128))
    ], 38)) : V("", !0);
  }
}, Vm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bm
}, Symbol.toStringTag, { value: "Module" })), Hm = {
  install: (e) => {
    e.component("Address", () => Promise.resolve().then(() => ki)), e.component("Button", () => Promise.resolve().then(() => Yi)), e.component("Checkbox", () => Promise.resolve().then(() => Ji)), e.component("Dropdown", () => Promise.resolve().then(() => el)), e.component("Error", () => Promise.resolve().then(() => al)), e.component("Field", () => Promise.resolve().then(() => fl)), e.component("FieldPhone", () => Promise.resolve().then(() => Lu)), e.component("LocationMarker", () => Promise.resolve().then(() => ku)), e.component("Map", () => Promise.resolve().then(() => Fu)), e.component("Popup", () => Promise.resolve().then(() => V0)), e.component("Radio", () => Promise.resolve().then(() => K0)), e.component("Select", () => Promise.resolve().then(() => e1)), e.component("SelectMulti", () => Promise.resolve().then(() => S1)), e.component("Spoiler", () => Promise.resolve().then(() => N1)), e.component("Tab", () => Promise.resolve().then(() => k1)), e.component("Tooltip", () => Promise.resolve().then(() => R1)), e.component("Text", () => Promise.resolve().then(() => x1)), e.component("Upload", () => Promise.resolve().then(() => O2)), e.component("UploadImage", () => Promise.resolve().then(() => w2)), e.component("UploadImageMultiple", () => Promise.resolve().then(() => U2)), e.component("Breadcrumbs", () => Promise.resolve().then(() => W2)), e.component("Chips", () => Promise.resolve().then(() => X2)), e.component("Countdown", () => Promise.resolve().then(() => l3)), e.component("DatePicker", () => Promise.resolve().then(() => f3)), e.component("EmptyState", () => Promise.resolve().then(() => h3)), e.component("Feed", () => Promise.resolve().then(() => fp)), e.component("FieldBig", () => Promise.resolve().then(() => vp)), e.component("FieldTags", () => Promise.resolve().then(() => Yp)), e.component("Loader", () => Promise.resolve().then(() => Ui)), e.component("Shader", () => Promise.resolve().then(() => Xp)), e.component("Slider", () => Promise.resolve().then(() => km)), e.component("Status", () => Promise.resolve().then(() => xm)), e.component("Marquee", () => Promise.resolve().then(() => Vm));
  }
};
export {
  Ai as Address,
  G2 as Breadcrumbs,
  Ki as Button,
  qs as Checkbox,
  z2 as Chips,
  i3 as Countdown,
  c3 as DatePicker,
  ur as Dropdown,
  li as EmptyState,
  rl as Error,
  cp as Feed,
  Hr as Field,
  gp as FieldBig,
  Nu as FieldPhone,
  Kp as FieldTags,
  $n as Loader,
  Au as LocationMarker,
  Ru as Map,
  Bm as Marquee,
  B0 as Popup,
  Ro as Radio,
  Q0 as Select,
  T1 as SelectMulti,
  zp as Shader,
  Am as Slider,
  Mo as Spoiler,
  Mm as Status,
  A1 as Tab,
  M1 as Text,
  D1 as Tooltip,
  E2 as Upload,
  S2 as UploadImage,
  x2 as UploadImageMultiple,
  Hm as default
};
